{
  "common": {
    "loading": "लोड हो रहा है...",
    "error": "त्रुटि",
    "retry": "पुनः प्रयास करें",
    "cancel": "रद्द करें",
    "save": "सहेजें",
    "saving": "सहेज रहे हैं...",
    "close": "बंद करें",
    "back": "वापस",
    "next": "अगला",
    "search": "खोजें",
    "watchNow": "अभी देखें",
    "playNow": "अभी चलाएं",
    "play": "चलाएं",
    "moreInfo": "अधिक जानकारी",
    "seeAll": "सभी देखें",
    "new": "नया",
    "live": "लाइव",
    "recommended": "अनुशंसित",
    "edit": "संपादित करें",
    "delete": "हटाएं",
    "add": "जोड़ें",
    "enabled": "सक्षम",
    "disabled": "अक्षम",
    "invalidDate": "अमान्य तिथि",
    "appName": "🏠 Bayit+",
    "appVersion": "🏠 Bayit+ v1.0.0",
    "slogan": "आपका घर। कहीं भी।",
    "ok": "ठीक है",
    "success": "सफलता",
    "warning": "चेतावनी",
    "confirm": "पुष्टि करें",
    "yes": "हाँ",
    "no": "नहीं",
    "apply": "लागू करें",
    "errors": {
      "unexpected": "एक अप्रत्याशित त्रुटि हुई"
    },
    "send": "भेजें",
    "done": "हो गया",
    "all": "सभी",
    "reset": "रीसेट करें",
    "deleting": "हटा रहे हैं...",
    "noResults": "कोई परिणाम नहीं मिला",
    "tryDifferentSearch": "कोई अन्य खोज शब्द आज़माएं",
    "previous": "पिछला",
    "actions": "कार्रवाइयां",
    "pageOf": "पृष्ठ {{page}} / {{total}}",
    "noData": "कोई डेटा उपलब्ध नहीं",
    "filters": "फ़िल्टर",
    "clear": "साफ़ करें",
    "clearSelection": "साफ़ करें",
    "expand": "विस्तार करें",
    "collapse": "संक्षिप्त करें",
    "upgrade": "प्रीमियम में अपग्रेड करें",
    "skip": "छोड़ें",
    "thisContent": "[hi] this content",
    "backToHome": "[hi] Back to Home",
    "dismiss": "[hi] Dismiss",
    "goBack": "[hi] Go Back",
    "pause": "[hi] Pause",
    "tryAgain": "[hi] Try Again",
    "refresh": "रिफ्रेश"
  },
  "culturalContext": {
    "loading": "व्याख्या लोड हो रही है...",
    "loadError": "व्याख्या लोड करने में विफल",
    "related": "संबंधित संदर्भ"
  },
  "demo": {
    "banner": "डेमो मोड",
    "bannerSubtext": "मॉक डेटा का उपयोग - कोई API कॉल नहीं",
    "days": {
      "sunday": "रविवार",
      "monday": "सोमवार",
      "tuesday": "मंगलवार",
      "wednesday": "बुधवार",
      "thursday": "गुरुवार",
      "friday": "शुक्रवार",
      "saturday": "शनिवार"
    },
    "shabbat": "शब्बत",
    "until_shabbat": "शब्बत तक",
    "search_interpretation": "\"{{query}}\" खोजें",
    "suggestions": {
      "0": "फ़ौदा",
      "1": "שטיסל",
      "2": "तेहरान",
      "3": "द आर्बिट्रेटर",
      "4": "श्रम"
    },
    "premium_plan": "प्रीमियम",
    "assistant_response": "मैं Fauda की सिफारिश करता हूं - एक उत्कृष्ट थ्रिलर सीरीज!",
    "morning_greeting": "सुप्रभात! आज मौसम अच्छा है, इज़राइल से कुछ महत्वपूर्ण समाचार हैं।"
  },
  "hero": {
    "watch": "देखें",
    "moreInfo": "अधिक जानकारी",
    "addToList": "सूची में जोड़ें"
  },
  "login": {
    "title": "वापसी पर स्वागत है",
    "subtitle": "Bayit+ जारी रखने के लिए साइन इन करें",
    "tagline": "USA में आपका घर",
    "email": "ईमेल",
    "emailPlaceholder": "अपना ईमेल दर्ज करें",
    "password": "पासवर्ड",
    "passwordPlaceholder": "अपना पासवर्ड दर्ज करें",
    "submit": "साइन इन करें",
    "loggingIn": "साइन इन हो रहा है...",
    "or": "या",
    "forgotPassword": "पासवर्ड भूल गए?",
    "continueWithGoogle": "Google से जारी रखें",
    "noAccount": "खाता नहीं है?",
    "signUp": "साइन अप करें",
    "register": "रजिस्टर करें",
    "name": "नाम",
    "termsNotice": "साइन इन करके, आप हमारी सेवा की शर्तों और गोपनीयता नीति से सहमत हैं",
    "errors": {
      "emailRequired": "ईमेल आवश्यक है",
      "passwordRequired": "पासवर्ड आवश्यक है",
      "loginFailed": "लॉगिन विफल।",
      "googleFailed": "Google साइन-इन विफल।",
      "fillAllFields": "कृपया सभी फ़ील्ड भरें"
    },
    "qrInstructions": "त्वरित लॉगिन के लिए अपने फोन से कोड स्कैन करें",
    "methodQR": "QR कोड",
    "methodVoice": "आवाज़",
    "methodTraditional": "ईमेल",
    "qrTitle": "लॉगिन के लिए स्कैन करें",
    "qrDescription": "[hi] Scan this QR code with your phone to login without typing",
    "expiresIn": "5 मिनट में समाप्त",
    "companionConnected": "फोन कनेक्ट हो गया!",
    "authenticating": "लॉग इन हो रहा है...",
    "sessionExpired": "सत्र समाप्त",
    "refreshQR": "नया कोड जनरेट करें",
    "generatingQR": "[hi] Generating QR code...",
    "howItWorks": "[hi] How it works:",
    "step1": "[hi] Open camera on your phone",
    "step2": "[hi] Scan the QR code above",
    "step3": "[hi] Login on your phone",
    "step4": "[hi] TV logs in automatically!",
    "voicePlaceholder": "[hi] Type your response...",
    "send": "भेजें",
    "createAccount": "खाता बनाएं",
    "bayitThinking": "Bayit सोच रहा है...",
    "unexpectedError": "एक अप्रत्याशित त्रुटि हुई"
  },
  "tvLogin": {
    "invalidQR": "अमान्य QR कोड।",
    "sessionInvalid": "यह QR कोड समाप्त हो गया है।",
    "verificationFailed": "सत्यापन विफल।",
    "fillAllFields": "कृपया सभी फ़ील्ड भरें",
    "loginFailed": "लॉगिन विफल।",
    "notLoggedIn": "[hi] You are not logged in on this device.",
    "enterCredentials": "[hi] Please enter your credentials to authorize your TV.",
    "authFailed": "[hi] Authorization failed.",
    "verifying": "[hi] Verifying...",
    "verifyingDescription": "[hi] Connecting to your TV...",
    "loginTitle": "अपने TV में लॉगिन करें",
    "loginDescription": "[hi] Enter your credentials to authorize your TV",
    "authorizing": "[hi] Authorizing...",
    "authorizingDescription": "[hi] Logging you in on your TV...",
    "authorizeTV": "TV अधिकृत करें",
    "success": "सफलता!",
    "successDescription": "[hi] Your TV is now logged in. You can close this page.",
    "goToHome": "होम जाएं",
    "error": "कुछ गलत हुआ",
    "tryAgain": "पुनः प्रयास करें",
    "securityNote": "[hi] Your credentials are sent securely and are never stored on the TV.",
    "footer": "[hi] Having trouble? Make sure you scanned a fresh QR code from your TV.",
    "almostThere": "[hi] Almost there!",
    "authenticating": "[hi] Authenticating...",
    "connected": "[hi] Connected",
    "expired": "[hi] Code Expired",
    "expiredMessage": "[hi] Your sign-in code has expired. Please request a new one.",
    "header": "[hi] Sign In to TV",
    "pleaseSignIn": "[hi] Please sign in on your phone or computer",
    "signInButton": "[hi] Sign In",
    "signInToTV": "[hi] Sign In to TV",
    "subtitle": "[hi] Enter the code shown on your TV screen",
    "tvSignedIn": "[hi] TV signed in successfully"
  },
  "googleLogin": {
    "cancelledError": "[hi] Google sign-in was cancelled",
    "missingCode": "[hi] Authentication code is missing",
    "loginError": "[hi] Error signing in with Google",
    "redirecting": "[hi] Redirecting to login page...",
    "connecting": "[hi] Connecting with Google..."
  },
  "register": {
    "title": "खाता बनाएं",
    "subtitle": "अपनी पसंदीदा सामग्री देखने के लिए Bayit+ में शामिल हों",
    "name": "पूरा नाम",
    "namePlaceholder": "राहुल शर्मा",
    "email": "ईमेल",
    "emailPlaceholder": "your@email.com",
    "password": "पासवर्ड",
    "passwordPlaceholder": "कम से कम 8 अक्षर",
    "confirmPassword": "पासवर्ड की पुष्टि करें",
    "confirmPasswordPlaceholder": "पासवर्ड दोबारा दर्ज करें",
    "submit": "साइन अप करें",
    "registering": "साइन अप हो रहा है...",
    "acceptTerms": "मैं सहमत हूं",
    "termsOfService": "सेवा की शर्तें",
    "and": "और",
    "privacyPolicy": "गोपनीयता नीति",
    "continueWithGoogle": "Google से साइन अप करें",
    "haveAccount": "पहले से खाता है?",
    "signIn": "साइन इन करें",
    "fullName": "[hi] Full Name",
    "loginLink": "[hi] Login",
    "placeholders": {
      "fullName": "[hi] John Doe",
      "email": "[hi] your@email.com",
      "password": "[hi] At least 8 characters",
      "confirmPassword": "[hi] Enter password again"
    },
    "errors": {
      "nameRequired": "नाम आवश्यक है",
      "emailRequired": "ईमेल आवश्यक है",
      "passwordRequired": "पासवर्ड आवश्यक है",
      "passwordTooShort": "पासवर्ड कम से कम 8 वर्ण का होना चाहिए",
      "passwordMismatch": "पासवर्ड मेल नहीं खाते",
      "acceptTerms": "आपको शर्तें स्वीकार करनी होंगी",
      "fillAllFields": "कृपया सभी फ़ील्ड भरें",
      "registrationFailed": "पंजीकरण विफल।",
      "googleFailed": "[hi] Sign up with Google failed. Please try again."
    }
  },
  "nav": {
    "home": "होम",
    "vod": "VOD",
    "liveTV": "लाइव TV",
    "epg": "TV गाइड",
    "radio": "रेडियो",
    "podcasts": "पॉडकास्ट",
    "flows": "फ्लो",
    "judaism": "यहूदी धर्म",
    "children": "बच्चे",
    "profile": "प्रोफ़ाइल",
    "search": "खोजें",
    "settings": "सेटिंग्स",
    "favorites": "पसंदीदा",
    "watchlist": "वॉचलिस्ट",
    "downloads": "डाउनलोड",
    "recordings": "मेरी रिकॉर्डिंग",
    "widgets": "विजेट",
    "help": "सहायता",
    "discover": "खोजें",
    "account": "खाता",
    "subscribe": "सब्सक्राइब करें",
    "plans": "[hi] Plans",
    "admin": "एडमिन",
    "games": "गेम्स",
    "friends": "मित्र",
    "glossary": "शब्दकोश",
    "missions": "मिशन",
    "audiobooks": "ऑडियोबुक्स",
    "playlist": "प्लेलिस्ट",
    "zehAniHub": "ज़ेह अनी",
    "support": "सहायता",
    "discoverHub": "AI खोजें",
    "listen": "सुनें",
    "byoc": "मेरे स्रोत",
    "household": "परिवार",
    "messages": "संदेश",
    "myContent": "मेरी सामग्री",
    "social": "सामाजिक"
  },
  "epg": {
    "title": "TV गाइड",
    "subtitle": "लाइव TV प्रोग्रामिंग शेड्यूल",
    "gridView": "ग्रिड व्यू",
    "listView": "सूची व्यू",
    "israelTime": "इज़राइल समय",
    "localTime": "स्थानीय समय",
    "il": "[hi] IL",
    "local": "[hi] Local",
    "jumpToNow": "अभी पर जाएं",
    "goBack": "[hi] ← {{hours}}h",
    "goForward": "[hi] {{hours}}h →",
    "toggleTimezone": "[hi] Toggle Timezone",
    "errorTitle": "TV गाइड लोड करने में विफल",
    "errorLoading": "[hi] Could not load TV guide data",
    "noPrograms": "कोई प्रोग्राम नहीं मिला",
    "noChannels": "कोई चैनल उपलब्ध नहीं",
    "recordProgram": "प्रोग्राम रिकॉर्ड करें",
    "channel": "चैनल",
    "enableSubtitles": "[hi] Enable Subtitles",
    "subtitleLanguage": "[hi] Subtitle Language",
    "storageEstimate": "[hi] Storage Estimate",
    "availableSpace": "[hi] Available Space",
    "lowStorage": "[hi] Low Storage Warning",
    "lowStorageMessage": "[hi] You're running low on storage space. Consider deleting old recordings.",
    "scheduleRecording": "[hi] Schedule Recording",
    "scheduledRecordingNotSupported": "[hi] Scheduled recordings are not yet supported. Only immediate recordings are available.",
    "recordingFailed": "[hi] Failed to start/schedule recording",
    "smartSearch": "[hi] Smart Search",
    "smartSearchSubtitle": "[hi] Ask questions in natural language",
    "smartSearchPlaceholder": "[hi] e.g., Show me all shows with actress Tali Sharon tonight",
    "searchPlaceholder": "प्रोग्राम, चैनल खोजें...",
    "premiumRequired": "[hi] Premium Feature",
    "premiumRequiredMessage": "[hi] Smart Search uses AI to understand your questions. Upgrade to Premium to access this feature.",
    "searchWithAI": "[hi] Search with AI",
    "searching": "[hi] Searching...",
    "tryThese": "[hi] Try these examples",
    "exampleQuery1": "[hi] Show me all shows with actress Tali Sharon tonight",
    "exampleQuery2": "[hi] What comedy shows are airing this week?",
    "exampleQuery3": "[hi] Find documentaries about history on Channel 11",
    "exampleQuery4": "[hi] Show me all news programs tomorrow morning",
    "aiDisclaimer": "[hi] Powered by Claude AI. Results may vary based on program data availability.",
    "interpretationTitle": "[hi] What I understood",
    "noResultsFound": "[hi] No programs found matching your query"
  },
  "home": {
    "continueWatching": "देखना जारी रखें",
    "featuredContent": "फीचर्ड",
    "liveTV": "लाइव TV",
    "allChannels": "सभी चैनल",
    "liveChannels": "लाइव चैनल",
    "showOnlyWithSubtitles": "केवल सबटाइटल वाले दिखाएं",
    "israeliMovies": "इज़राइली फ़िल्में",
    "israeli-movies": "इज़राइली फ़िल्में",
    "israeli-series": "इज़राइली सीरीज़",
    "action": "एक्शन और थ्रिलर",
    "comedy": "कॉमेडी",
    "drama": "ड्रामा",
    "documentaries": "डॉक्यूमेंट्री",
    "loadingContent": "सामग्री लोड हो रही है...",
    "liveNow": "अभी लाइव",
    "trendingInIsrael": "इज़राइल में ट्रेंडिंग",
    "jerusalemConnection": "[hi] Jerusalem Connection",
    "telAvivConnection": "[hi] Tel Aviv Connection",
    "categories": "श्रेणियां",
    "nearYou": "आसपास के इज़राइली",
    "betaExclusive": "बीटा एक्सक्लूसिव",
    "carousel": {
      "fauda": {
        "title": "[hi] Fauda",
        "subtitle": "[hi] Season 4 - Now Streaming",
        "description": "[hi] The hit Israeli series returns for a fourth season full of suspense and action"
      },
      "shtisel": {
        "title": "[hi] Shtisel",
        "subtitle": "[hi] All Seasons Available",
        "description": "[hi] Follow the Shtisel family in the ultra-Orthodox neighborhood of Jerusalem"
      },
      "tehran": {
        "title": "[hi] Tehran",
        "subtitle": "[hi] Season 2",
        "description": "[hi] A Mossad agent deep in Iran on a dangerous mission"
      },
      "live": {
        "title": "[hi] Live - Kan 11",
        "subtitle": "[hi] Watch Now",
        "description": "[hi] News, current affairs and quality content"
      }
    },
    "enableLocation": "[hi] Enable Location",
    "locationPermissionDeniedDescription": "[hi] Location access was denied. Enable it in Settings to see content near you.",
    "locationPermissionDescription": "[hi] Allow location access to discover content near you.",
    "openSettings": "[hi] Open Settings"
  },
  "search": {
    "title": "खोजें",
    "subtitle": "फ़िल्में, सीरीज़, चैनल, रेडियो और पॉडकास्ट खोजें",
    "placeholder": "सामग्री खोजें...",
    "voicePlaceholder": "अभी बोलें...",
    "searching": "खोज रहे हैं...",
    "listening": "सुन रहे हैं...",
    "noResults": "कोई परिणाम नहीं मिला",
    "noResultsHint": "अलग कीवर्ड आज़माएं",
    "tryDifferent": "[hi] Try different search terms",
    "resultsFor": "[hi] results for",
    "resultsFound": "[hi] {{count}} results found for \"{{query}}\"",
    "recentSearches": "हाल की खोजें",
    "clearAll": "सभी साफ़ करें",
    "trending": "ट्रेंडिंग खोजें",
    "promptTitle": "[hi] What are you looking for?",
    "promptDescription": "[hi] Search for your favorite content or use voice search",
    "filters": {
      "all": "सभी",
      "vod": "फ़िल्में और सीरीज़",
      "live": "चैनल",
      "radio": "रेडियो",
      "podcast": "पॉडकास्ट",
      "moviesAndSeries": "[hi] Movies & Series",
      "channels": "[hi] Channels",
      "podcasts": "[hi] Podcasts"
    },
    "suggestions": {
      "movies": "[hi] Movies",
      "series": "[hi] Series",
      "liveTV": "[hi] Live TV",
      "news": "[hi] News",
      "sports": "[hi] Sports",
      "kids": "[hi] Kids"
    }
  },
  "liveTV": {
    "title": "लाइव TV",
    "channels": "चैनल",
    "nowPlaying": "अभी चल रहा है",
    "loadError": "चैनल लोड करने में विफल",
    "categories": {
      "all": "सभी",
      "news": "समाचार",
      "sports": "खेल",
      "entertainment": "मनोरंजन",
      "kids": "बच्चे",
      "documentary": "डॉक्यूमेंट्री"
    }
  },
  "listen": {
    "title": "सुनें",
    "subtitle": "रेडियो, पॉडकास्ट और ऑडियोबुक",
    "tab": {
      "radio": "रेडियो",
      "podcasts": "पॉडकास्ट",
      "audiobooks": "ऑडियोबुक"
    }
  },
  "radio": {
    "title": "रेडियो",
    "categories": {
      "all": "सभी",
      "music": "संगीत",
      "news": "समाचार",
      "talk": "टॉक",
      "jewish": "यहूदी"
    },
    "noStations": "कोई रेडियो स्टेशन उपलब्ध नहीं",
    "tryLater": "बाद में पुनः प्रयास करें",
    "playing": "चल रहा है",
    "fmSuffix": "FM"
  },
  "podcasts": {
    "title": "पॉडकास्ट",
    "episodes": "एपिसोड",
    "categories": {
      "all": "सभी",
      "general": "सामान्य",
      "news": "समाचार",
      "politics": "राजनीति",
      "tech": "तकनीक",
      "business": "व्यापार",
      "jewish": "यहूदी",
      "entertainment": "मनोरंजन",
      "sports": "खेल",
      "history": "इतिहास",
      "educational": "शैक्षिक"
    },
    "noPodcasts": "कोई पॉडकास्ट उपलब्ध नहीं",
    "tryLater": "बाद में पुनः प्रयास करें",
    "playLatest": "[hi] Play Latest"
  },
  "vod": {
    "title": "फ़िल्में और सीरीज़",
    "movies": "फ़िल्में",
    "series": "सीरीज़",
    "searchPlaceholder": "फ़िल्में और सीरीज़ खोजें...",
    "noMovies": "कोई फ़िल्म नहीं मिली",
    "noSeries": "कोई सीरीज़ नहीं मिली",
    "loadError": "सामग्री लोड करने में विफल",
    "showOnlyWithSubtitles": "केवल सबटाइटल वाले दिखाएं",
    "categories": {
      "all": "सभी",
      "drama": "ड्रामा",
      "comedy": "कॉमेडी",
      "action": "एक्शन",
      "documentary": "डॉक्यूमेंट्री",
      "kids": "बच्चे"
    },
    "allCategories": "सभी",
    "emptyTitle": "कोई सामग्री उपलब्ध नहीं",
    "emptyDescription": "कोई अन्य श्रेणी आज़माएं",
    "allContent": "[hi] All Content",
    "noContent": "[hi] No content available",
    "noContentInCategory": "[hi] No content found in this category"
  },
  "account": {
    "title": "मेरा खाता",
    "profile": "प्रोफ़ाइल",
    "settings": "सेटिंग्स",
    "subscription": "सब्सक्रिप्शन",
    "manageSubscription": "सब्सक्रिप्शन प्रबंधित करें",
    "personalDetails": "व्यक्तिगत विवरण",
    "billing": "बिलिंग और भुगतान",
    "logout": "लॉगआउट",
    "login": "लॉगिन",
    "register": "रजिस्टर करें",
    "email": "ईमेल",
    "password": "पासवर्ड",
    "name": "नाम",
    "guest": "अतिथि",
    "premium": "प्रीमियम",
    "basic": "बेसिक"
  },
  "flows": {
    "title": "फ्लो",
    "subtitle": "हर पल के लिए व्यक्तिगत सामग्री अनुभव",
    "activeNow": "अभी सक्रिय",
    "start": "शुरू करें",
    "skipToday": "आज छोड़ें",
    "systemFlows": "तैयार फ्लो",
    "customFlows": "मेरे फ्लो",
    "system": "[hi] System",
    "noCustomFlows": "[hi] No custom flows yet",
    "createHint": "[hi] Create your first personalized flow",
    "createCustom": "[hi] Create Custom Flow",
    "createFlow": "फ्लो बनाएं",
    "editFlow": "फ्लो संपादित करें",
    "type": "[hi] Type",
    "systemFlow": "[hi] System Flow",
    "customFlow": "[hi] Custom Flow",
    "schedule": "[hi] Schedule",
    "content": "[hi] Content",
    "items": "[hi] items",
    "aiGenerated": "[hi] AI Generated",
    "autoPlay": "[hi] Auto Play",
    "aiEnabled": "[hi] AI Curation",
    "shabbatTrigger": "[hi] Shabbat Evening",
    "manual": "[hi] Manual",
    "flowName": "[hi] Flow Name",
    "flowNamePlaceholder": "[hi] e.g., My Morning Routine",
    "description": "[hi] Description",
    "descriptionPlaceholder": "[hi] What is this flow for?",
    "startTime": "[hi] Start Time",
    "endTime": "[hi] End Time",
    "actions": "[hi] Actions",
    "details": "[hi] Details",
    "createFlowDesc": "[hi] Design your personalized content experience",
    "editFlowDesc": "[hi] Update your flow settings and content",
    "basicInfo": "[hi] Basic Information",
    "options": "[hi] Options",
    "autoPlayDesc": "[hi] Automatically play next item when current one ends",
    "aiEnabledDesc": "[hi] Let AI curate content based on your preferences",
    "startFlow": "[hi] Start Flow",
    "deleteFlow": "[hi] Delete Flow",
    "custom": "[hi] Custom",
    "morning": "[hi] Morning",
    "evening": "[hi] Evening",
    "shabbat": "[hi] Shabbat",
    "addContent": "[hi] Add Content",
    "contentPicker": {
      "title": "[hi] Add Content to Flow",
      "tabs": {
        "live": "[hi] Live TV",
        "radio": "[hi] Radio",
        "vod": "[hi] On Demand",
        "podcast": "[hi] Podcasts"
      },
      "search": "[hi] Search content...",
      "selected": "[hi] {{count}} selected",
      "addSelected": "[hi] Add Selected",
      "noResults": "[hi] No content found",
      "alreadyAdded": "[hi] Already in flow",
      "loadMore": "[hi] Load More"
    },
    "flowItems": {
      "title": "[hi] Flow Content",
      "empty": "[hi] No content yet. Click Add Content to get started.",
      "count": "[hi] {{count}} items",
      "remove": "[hi] Remove",
      "moveUp": "[hi] Move Up",
      "moveDown": "[hi] Move Down",
      "order": "[hi] Order",
      "confirmRemove": "[hi] Click again to confirm removal",
      "maxReached": "[hi] Maximum {{max}} items reached",
      "more": "[hi] more items"
    },
    "days": {
      "sunday": "[hi] Sunday",
      "monday": "[hi] Monday",
      "tuesday": "[hi] Tuesday",
      "wednesday": "[hi] Wednesday",
      "thursday": "[hi] Thursday",
      "friday": "[hi] Friday",
      "saturday": "[hi] Saturday",
      "sundayShort": "[hi] Sun",
      "mondayShort": "[hi] Mon",
      "tuesdayShort": "[hi] Tue",
      "wednesdayShort": "[hi] Wed",
      "thursdayShort": "[hi] Thu",
      "fridayShort": "[hi] Fri",
      "saturdayShort": "[hi] Sat",
      "selectAll": "[hi] Select All",
      "deselectAll": "[hi] Deselect All",
      "title": "[hi] Active Days",
      "everyday": "[hi] Every day",
      "everyDay": "[hi] Every day",
      "weekdays": "[hi] Weekdays",
      "weekends": "[hi] Weekends",
      "noneSelected": "[hi] No days selected",
      "selectedCount": "[hi] {{count}} days selected"
    },
    "trigger": {
      "type": "[hi] Trigger Type",
      "time": "[hi] Time-based",
      "shabbat": "[hi] Shabbat Evening",
      "holiday": "[hi] Holiday",
      "skipShabbat": "[hi] Skip on Shabbat",
      "skipShabbatDesc": "[hi] Don't run this flow on Friday evening or Saturday",
      "shabbatOffset": "[hi] Minutes before candle lighting",
      "shabbatOffsetDesc": "[hi] How many minutes before Shabbat should this flow start?",
      "calculatedTime": "[hi] Calculated time",
      "thisWeek": "[hi] This week: {{day}} at {{time}}",
      "comingSoon": "[hi] Holiday triggers coming soon",
      "locationBased": "[hi] Times based on your location"
    },
    "examples": {
      "title": "[hi] Example Flows",
      "subtitle": "[hi] Tap to use as a template",
      "morningRoutine": {
        "name": "[hi] Morning Routine",
        "desc": "[hi] Start your day with news, weather, and uplifting content"
      },
      "eveningWindDown": {
        "name": "[hi] Evening Wind Down",
        "desc": "[hi] Relax with calming music and light entertainment"
      },
      "shabbatPrep": {
        "name": "[hi] Shabbat Preparation",
        "desc": "[hi] Set the mood for Shabbat with special content"
      },
      "coffeeBreak": {
        "name": "[hi] Coffee Break",
        "desc": "[hi] Quick entertainment for a short break"
      },
      "sunsetVibes": {
        "name": "[hi] Sunset Vibes",
        "desc": "[hi] Weekend relaxation with music and ambient content"
      }
    },
    "aiBrief": "[hi] AI Brief",
    "aiBriefDesc": "[hi] Get a personalized AI-generated summary before the flow starts",
    "aiBriefEnabled": "[hi] AI Brief Enabled",
    "validation": {
      "nameRequired": "[hi] Flow name is required",
      "startTimeRequired": "[hi] Start time is required",
      "endTimeRequired": "[hi] End time is required",
      "timeRange": "[hi] End time must be after start time",
      "daysRequired": "[hi] Select at least one day",
      "contentRequired": "[hi] Add content or enable AI"
    },
    "tv": {
      "useCompanion": "[hi] For full customization, use the Bayit+ app on your phone or visit bayit.plus on your computer."
    }
  },
  "profile": {
    "title": "मेरी प्रोफ़ाइल",
    "profileDetails": "प्रोफ़ाइल विवरण",
    "name": "नाम",
    "notSet": "सेट नहीं",
    "email": "ईमेल",
    "editProfile": "प्रोफ़ाइल संपादित करें",
    "notificationSettings": "सूचना सेटिंग्स",
    "security": "सुरक्षा",
    "changePassword": "पासवर्ड बदलें",
    "updatePassword": "[hi] Update your password",
    "connectedDevices": "[hi] Connected Devices",
    "manageDevices": "[hi] Manage devices connected to your account",
    "twoFactorAuth": "[hi] Two-Factor Authentication",
    "addExtraSecurity": "[hi] Add an extra layer of security",
    "address": {
      "line1": "[hi] 123 Main Street",
      "line2": "[hi] Tel Aviv, Israel 6100000"
    },
    "free": "[hi] Free",
    "premiumPrice": "[hi] $7.99/month",
    "familyPrice": "[hi] $12.99/month",
    "remaining": "[hi] remaining",
    "tabs": {
      "personal": "[hi] Personal",
      "overview": "[hi] Overview",
      "subscription": "[hi] Subscription",
      "notifications": "[hi] Notifications",
      "security": "[hi] Security",
      "ai": "[hi] AI & Voice",
      "voice": "[hi] Voice & Accessibility"
    },
    "subscription": {
      "currentPlan": "[hi] Current Plan",
      "renewsOn": "[hi] Renews on",
      "manageSubscription": "[hi] Manage Subscription",
      "cancelSubscription": "[hi] Cancel Subscription",
      "noActivePlan": "[hi] No active subscription",
      "selectPlan": "[hi] Select a Plan"
    },
    "notifications": "[hi] Notifications",
    "ai": {
      "title": "[hi] AI & Personalization",
      "description": "[hi] Configure AI-powered features",
      "assistant": "[hi] AI Assistant",
      "assistantDesc": "[hi] Personalized recommendations and help",
      "chatbot": "[hi] AI Assistant",
      "chatbotEnabled": "[hi] Enable AI Assistant",
      "chatbotEnabledDesc": "[hi] Get help navigating content",
      "saveHistory": "[hi] Save Conversation History",
      "saveHistoryDesc": "[hi] Remember previous conversations",
      "recommendations": "[hi] Recommendations",
      "personalizedRecs": "[hi] Personalized Recommendations",
      "personalizedRecsDesc": "[hi] Content suggestions based on history",
      "privacy": "[hi] Privacy & Data",
      "privacyDesc": "[hi] Your data is encrypted and secure",
      "dataConsent": "[hi] Usage Analytics",
      "dataConsentDesc": "[hi] Help improve AI features",
      "privacyNote": "[hi] Your data is encrypted and secure"
    },
    "voice": {
      "title": "[hi] Voice Control",
      "description": "[hi] Hands-free navigation",
      "enabled": "[hi] Voice Commands",
      "enabledDesc": "[hi] Control the app with your voice",
      "tts": "[hi] Text-to-Speech",
      "ttsDesc": "[hi] AI responses read aloud",
      "wakeWord": "[hi] Wake Word Detection",
      "wakeWordDesc": "[hi] Say \"Bayit\" to activate",
      "operationMode": "[hi] Operation Mode",
      "operationModeDesc": "[hi] Choose how you interact with the app",
      "voiceSearch": "[hi] Voice Search",
      "voiceSearchEnabled": "[hi] Enable voice search",
      "voiceSearchEnabledDesc": "[hi] Search for content using your voice",
      "constantListening": "[hi] Always Listening Mode",
      "constantListeningDesc": "[hi] Continuously listen for voice commands without pressing a button",
      "constantListeningPrivacy": "[hi] Audio is only sent to servers when speech is detected",
      "holdButtonMode": "[hi] Hold Button to Talk",
      "holdButtonModeDesc": "[hi] Press and hold the microphone button instead of always listening",
      "sensitivity": "[hi] Voice Detection Sensitivity",
      "sensitivityDesc": "[hi] Adjust how responsive the voice detection is",
      "sensitivityLow": "[hi] Low (fewer false triggers)",
      "sensitivityMedium": "[hi] Medium (balanced)",
      "sensitivityHigh": "[hi] High (most responsive)",
      "silenceThreshold": "[hi] Silence Detection",
      "silenceThresholdDesc": "[hi] How long to wait after speaking before processing",
      "language": "[hi] Voice language",
      "accessibility": "[hi] Accessibility",
      "autoSubtitle": "[hi] Auto-enable subtitles",
      "autoSubtitleDesc": "[hi] Automatically show subtitles when playing content",
      "highContrast": "[hi] High contrast mode",
      "highContrastDesc": "[hi] Increase contrast for better visibility",
      "textSize": "[hi] Text size",
      "textSizeSmall": "[hi] Small",
      "textSizeMedium": "[hi] Medium",
      "textSizeLarge": "[hi] Large",
      "voiceOnlyInfo": "[hi] Voice Only Mode",
      "voiceOnlyDetails": "[hi] Say \"Hi Bayit\" to activate. Remote control disabled. Navigate entirely with voice commands.",
      "hybridInfo": "[hi] Hybrid Mode",
      "hybridDetails": "[hi] Use voice or remote control. Voice feedback on non-voice actions.",
      "classicInfo": "[hi] Classic Mode",
      "classicDetails": "[hi] All voice features disabled. Remote control only.",
      "textToSpeech": "[hi] Voice Responses",
      "ttsEnabled": "[hi] Enable voice responses",
      "ttsEnabledDesc": "[hi] App will speak responses to your voice commands",
      "ttsVolume": "[hi] Voice Volume",
      "ttsSpeed": "[hi] Speaking Speed",
      "hybridFeedback": "[hi] Interactive Feedback",
      "voiceFeedback": "[hi] Voice feedback on actions",
      "voiceFeedbackDesc": "[hi] Get voice confirmation when you use the remote or click buttons",
      "feedbackExample": "[hi] Example: Click a movie → App says \"Playing [Movie Name]\""
    },
    "dropdown": {
      "myProfile": "[hi] My Profile",
      "subscription": "[hi] Subscription",
      "favorites": "[hi] Favorites",
      "downloads": "[hi] Downloads",
      "signOut": "[hi] Sign Out"
    },
    "guest": "[hi] Guest",
    "morningRitual": "[hi] Morning Ritual",
    "watchlist": "[hi] Watchlist",
    "favorites": "[hi] Favorites",
    "downloads": "[hi] Downloads",
    "settings": "[hi] Settings",
    "language": "[hi] Language",
    "admin": "[hi] Admin",
    "watchTime": "[hi] Watch Time",
    "minutes": "[hi] minutes",
    "hours": "[hi] hours",
    "logout": "लॉग आउट",
    "premium": "प्रीमियम",
    "basic": "बेसिक",
    "upgrade": "प्रीमियम में अपग्रेड करें",
    "memberSince": "सदस्य तब से",
    "aiAssistant": "[hi] AI Assistant",
    "voiceSettings": "[hi] Voice",
    "subscriptionButton": "[hi] Subscription",
    "recentActivity": "[hi] Recent Activity",
    "justNow": "[hi] Just now",
    "hoursAgo": "[hi] {{hours}} hours ago",
    "yesterday": "[hi] Yesterday",
    "noRecentActivity": "[hi] No recent activity",
    "accountInfo": "[hi] Account Information",
    "role": "[hi] Role",
    "accountSecurity": "[hi] Account Security",
    "securityNote": "[hi] Your account is secured with encrypted authentication",
    "lastLogin": "[hi] Last login",
    "dangerZone": "[hi] Danger Zone",
    "invalidImageType": "[hi] Please select a valid image file (JPEG, PNG, WebP, or GIF)",
    "imageTooLarge": "[hi] Image is too large. Maximum size is 5MB.",
    "uploadSuccess": "[hi] Avatar updated successfully!",
    "uploadFailed": "[hi] Failed to upload avatar. Please try again.",
    "complimentaryPremium": "मुफ्त प्रीमियम एक्सेस",
    "emailVerified": "ईमेल सत्यापित",
    "emailUnverified": "ईमेल सत्यापित नहीं",
    "phoneVerified": "फोन सत्यापित",
    "phoneUnverified": "फोन सत्यापित नहीं",
    "completeVerification": "सभी सुविधाएं अनलॉक करने के लिए सत्यापन पूरा करें",
    "unlockPremium": "प्रीमियम सुविधाएं अनलॉक करें",
    "unlockPremiumDescription": "विशेष सामग्री और सुविधाओं का आनंद लेने के लिए अपग्रेड करें"
  },
  "voiceMode": {
    "voiceOnly": "[hi] Voice Only",
    "voiceOnlyDesc": "[hi] No remote control - full voice navigation",
    "hybrid": "[hi] Hybrid",
    "hybridDesc": "[hi] Voice + Remote - voice feedback on actions",
    "classic": "[hi] Classic",
    "classicDesc": "[hi] No voice - remote control only"
  },
  "settings": {
    "title": "सेटिंग्स",
    "language": "भाषा",
    "appLanguage": "ऐप भाषा",
    "selectLanguage": "भाषा चुनें",
    "languages": {
      "en": "अंग्रेज़ी",
      "he": "हिब्रू",
      "es": "स्पेनिश",
      "zh": "中文",
      "fr": "फ़्रांसीसी",
      "it": "इतालवी",
      "hi": "हिन्दी",
      "ta": "तमिल",
      "bn": "बांग्ला",
      "ja": "日本語"
    },
    "chatTranslation": "[hi] Chat Translation",
    "autoTranslate": "[hi] Auto-translate messages",
    "autoTranslateDescription": "[hi] Automatically translate chat messages to your preferred language",
    "notifications": "सूचनाएं",
    "pushNotifications": "पुश नोटिफिकेशन",
    "playback": "प्लेबैक",
    "quality": "गुणवत्ता",
    "subtitles": "सबटाइटल",
    "autoplay": "ऑटोप्ले",
    "appearance": "दिखावट",
    "darkMode": "डार्क मोड",
    "privacy": "गोपनीयता",
    "privacyPolicy": "गोपनीयता नीति",
    "termsOfService": "सेवा की शर्तें",
    "about": "के बारे में",
    "display": "[hi] Display",
    "homePageSections": "[hi] Home Page Sections",
    "configureSections": "[hi] Configure which sections appear on your home page",
    "visibleSections": "[hi] Visible Sections",
    "hiddenSections": "[hi] Hidden Sections",
    "dragToReorder": "[hi] Drag to reorder",
    "tapToHide": "[hi] Tap to hide",
    "tapToShow": "[hi] Tap to show",
    "resetToDefault": "[hi] Reset to Default",
    "resetConfirmMessage": "[hi] Are you sure you want to reset home page sections to their default configuration?",
    "sectionHidden": "[hi] Section hidden",
    "sectionShown": "[hi] Section shown",
    "replayTour": "फीचर टूर दोबारा देखें"
  },
  "help": {
    "subtitle": "[hi] How can we help you?",
    "email": "[hi] Email Support",
    "phone": "[hi] Phone Support",
    "chat": "[hi] Live Chat",
    "chatAvailable": "[hi] Available 24/7",
    "openTooltip": "[hi] Open help tooltip",
    "openHelp": "[hi] Open help menu",
    "howTo": "[hi] How to use",
    "relatedArticles": "[hi] Related articles",
    "stillNeedHelp": "[hi] Still need help?",
    "contactSupport": "[hi] Contact Support",
    "previous": "[hi] Previous",
    "next": "[hi] Next",
    "getStarted": "[hi] Get Started",
    "skipTutorial": "[hi] Skip tutorial",
    "actions": {
      "search": "[hi] Search Help",
      "docs": "[hi] Documentation",
      "faq": "[hi] FAQ",
      "support": "[hi] Contact Support",
      "tutorial": "[hi] View Tutorial"
    },
    "search": {
      "placeholder": "[hi] Search help...",
      "noResults": "[hi] No results found for \"{{query}}\"",
      "noResultsHint": "[hi] Try different keywords or browse categories",
      "recent": "[hi] Recent",
      "popular": "[hi] Popular"
    },
    "categories": {
      "getting-started": "[hi] Getting Started",
      "features": "[hi] Features",
      "judaism": "[hi] Judaism",
      "platform-guides": "[hi] Platform Guides",
      "account": "[hi] Account",
      "troubleshooting": "[hi] Troubleshooting",
      "parents": "[hi] For Parents",
      "admin": "[hi] Admin Guide",
      "developer": "[hi] Developer API"
    },
    "faq": {
      "title": "[hi] Frequently Asked Questions",
      "q1": "[hi] How do I change my subscription plan?",
      "a1": "[hi] Go to Settings > Subscription to view and change your current plan. You can upgrade or downgrade at any time.",
      "q2": "[hi] How do I download content for offline viewing?",
      "a2": "[hi] Tap the download icon on any content to save it for offline viewing. Downloads are available on mobile devices only.",
      "q3": "[hi] Why isn't my video playing?",
      "a3": "[hi] Check your internet connection. If the problem persists, try clearing the app cache or restarting the app.",
      "q4": "[hi] How do I cancel my subscription?",
      "a4": "[hi] You can cancel your subscription anytime through Settings > Subscription > Cancel Plan. You'll continue to have access until the end of your billing period."
    },
    "onboarding": {
      "welcome": {
        "title": "[hi] Welcome to Bayit+",
        "description": "[hi] Your home for Israeli entertainment, anywhere in the world"
      },
      "liveTv": {
        "title": "[hi] Live TV",
        "description": "[hi] Watch Israeli channels live, including news, sports, and entertainment"
      },
      "vod": {
        "title": "[hi] On-Demand Content",
        "description": "[hi] Browse movies, series, and documentaries anytime"
      },
      "voice": {
        "title": "[hi] Voice Control",
        "description": "[hi] Say 'Bayit' to control the app with your voice"
      },
      "profiles": {
        "title": "[hi] Family Profiles",
        "description": "[hi] Create profiles for each family member with personalized recommendations"
      }
    }
  },
  "voice": {
    "panelTitle": "वॉयस असिस्टेंट",
    "typeCommand": "कोई कमांड टाइप करें...",
    "controlExecuted": "निष्पादित: {{action}}",
    "timerSet": "{{amount}} {{unit}} के लिए टाइमर सेट किया गया",
    "chatPending": "आपका संदेश प्रोसेस हो रहा है...",
    "suggestion": {
      "watchLive": "लाइव टीवी देखें",
      "search": "कंटेंट खोजें",
      "listenRadio": "रेडियो सुनें"
    },
    "error": {
      "micDenied": "माइक्रोफ़ोन एक्सेस अस्वीकृत",
      "notSupported": "इस ब्राउज़र में वॉयस कमांड समर्थित नहीं हैं",
      "recognitionFailed": "समझ नहीं सका। कृपया पुनः प्रयास करें।"
    }
  },
  "errors": {
    "networkError": "नेटवर्क त्रुटि",
    "loadingFailed": "लोडिंग विफल",
    "tryAgain": "पुनः प्रयास करें",
    "offline": {
      "title": "इंटरनेट कनेक्शन नहीं",
      "message": "आप वर्तमान में ऑफ़लाइन हैं।",
      "ttsMessage": "[hi] No internet connection. You are now in offline mode."
    },
    "online": {
      "title": "कनेक्शन बहाल",
      "message": "आप वापस ऑनलाइन हैं।",
      "ttsMessage": "[hi] Internet connection restored."
    },
    "api": {
      "badRequest": "[hi] Something went wrong. Please try again.",
      "unauthorized": "[hi] Please log in to continue.",
      "forbidden": "[hi] You do not have permission to access this content.",
      "notFound": "[hi] The content you are looking for is not available.",
      "rateLimit": "[hi] You are making too many requests. Please wait a moment.",
      "serverError": "[hi] Our servers are having issues. Please try again later.",
      "unknown": "[hi] Something went wrong. Please try again.",
      "networkTimeout": "[hi] Unable to connect to our servers. Please check your connection.",
      "offlineMessage": "[hi] You are offline. Please check your internet connection.",
      "requestFailed": "[hi] Something went wrong. Please try again."
    },
    "voice": {
      "permissionDenied": "[hi] Microphone access is required for voice commands. Please enable it in Settings.",
      "recognitionFailed": "[hi] I didn't understand that. Please try again.",
      "commandFailed": "[hi] Voice command failed. Please try again."
    },
    "widget": {
      "loadFailed": "[hi] Unable to load widget. Please try again."
    },
    "buttons": {
      "ok": "[hi] OK",
      "retry": "[hi] Retry",
      "cancel": "[hi] Cancel"
    },
    "title": "त्रुटि",
    "networkUnavailable": "नेटवर्क अनुपलब्ध",
    "no_audio_url": "ऑडियो URL उपलब्ध नहीं",
    "connection_failed": "कनेक्शन विफल",
    "quota_exceeded": "कोटा पार हो गया",
    "server_error": "सर्वर त्रुटि"
  },
  "player": {
    "loading": "लोड हो रहा है...",
    "retry": "पुनः प्रयास करें",
    "error": "वीडियो चलाने में त्रुटि",
    "back": "← वापस",
    "liveBadge": "लाइव",
    "noStream": "स्ट्रीम उपलब्ध नहीं",
    "loadError": "स्ट्रीम लोड करने में विफल",
    "settings": "सेटिंग्स",
    "subtitles": "[hi] Subtitles",
    "playbackSpeed": "प्लेबैक स्पीड",
    "quality": "गुणवत्ता",
    "auto": "ऑटो",
    "previousChapter": "[hi] Previous chapter",
    "nextChapter": "[hi] Next chapter",
    "skipBackward": "[hi] Skip backward 30 seconds",
    "skipForward": "[hi] Skip forward 30 seconds",
    "restart": "पुनः आरंभ करें",
    "subtitlesOff": "बंद",
    "speed": "गति",
    "subscription": {
      "requiredTitle": "[hi] Subscription Required",
      "requiredMessage": "[hi] requires a paid subscription",
      "upgradeInfo": "[hi] Upgrade your subscription to access premium content",
      "upgrade": "[hi] Upgrade Now"
    },
    "ai": {
      "dub": "Dub",
      "dubbing": "डबिंग",
      "featuresTitle": "AI सुविधाएँ",
      "languagePrimary": "प्राथमिक",
      "languageSecondary": "द्वितीयक (वैकल्पिक)",
      "languageTitle": "AI भाषा",
      "liveTranslate": "लाइव अनुवाद",
      "selectLanguage": "भाषा चुनें",
      "split": "विभाजित करें",
      "togglePanel": "AI पैनल टॉगल करें",
      "translate": "अनुवाद करें",
      "trivia": "ट्रिविया",
      "triviaToggle": "[hi] Trivia"
    },
    "catchup": {
      "description": "शुरुआत चूक गए? अब तक की कहानी का AI-जनित सारांश प्राप्त करें।",
      "generateSummary": "सारांश उत्पन्न करें",
      "summaryTitle": "सारांश",
      "title": "कैच अप",
      "keyPoints": "[hi] Key Points",
      "transcript": "[hi] Transcript"
    },
    "chat": {
      "title": "लाइव चैट",
      "messagePlaceholder": "एक संदेश टाइप करें..."
    },
    "companion": {
      "noContext": "इस सामग्री के लिए अभी कोई सांस्कृतिक संदर्भ उपलब्ध नहीं है।",
      "quizComplete": "प्रश्नोत्तरी पूर्ण",
      "quizRetry": "पुनः प्रयास करें",
      "quizStart": "प्रश्नोत्तरी शुरू करें",
      "quizTitle": "अपने ज्ञान का परीक्षण करने के लिए तैयार हैं?",
      "quizTryAgain": "पुनः प्रयास करें",
      "tabContext": "संदर्भ",
      "tabQuiz": "प्रश्नोत्तरी",
      "tabVocabulary": "शब्दावली",
      "tapWords": "यहाँ जोड़ने के लिए उपशीर्षक में शब्दों पर टैप करें",
      "title": "AI साथी",
      "loadError": "AI शिक्षण डेटा लोड करने में विफल"
    },
    "controls": {
      "audioTrack": "ऑडियो ट्रैक",
      "continueWatching": "देखना जारी रखें",
      "dismiss": "खारिज करें",
      "goBack": "वापस जाएं",
      "navigateBack": "वापस नेविगेट करें",
      "on": "ON",
      "pause": "रोकें",
      "play": "चलाएं",
      "preview": "पूर्वावलोकन",
      "selected": "चयनित",
      "send": "भेजें",
      "skip": "छोड़ें",
      "close": "[hi] Close",
      "exitFullscreen": "[hi] Exit Fullscreen",
      "fullscreen": "[hi] Fullscreen",
      "restart": "[hi] Restart",
      "skipBackward": "[hi] Skip Backward",
      "skipForward": "[hi] Skip Forward",
      "volume": "[hi] Volume"
    },
    "dubbing": {
      "notNow": "अभी नहीं",
      "premiumMessage": "लाइव डबिंग के लिए Premium या Beta 500 सदस्यता आवश्यक है",
      "premiumTitle": "प्रीमियम सुविधा",
      "upgrade": "अपग्रेड करें",
      "voiceTitle": "डबिंग वॉइस",
      "settings_title": "लाइव डबिंग सेटिंग्स",
      "target_language": "लक्ष्य भाषा"
    },
    "errors": {
      "streamLimitMessage": "आपने {{maxStreams}} समवर्ती स्ट्रीम की अधिकतम सीमा पूरी कर ली है। कृपया कोई अन्य स्ट्रीम बंद करें या अपना प्लान अपग्रेड करें।",
      "streamLimitTitle": "स्ट्रीम सीमा पूरी हुई",
      "upgradePlan": "प्लान अपग्रेड करें"
    },
    "audio_description": "ऑडियो विवरण",
    "dismiss": "खारिज करें",
    "scene_search": "दृश्य खोज",
    "search_placeholder": "दृश्य खोजें...",
    "language_ratio": "भाषा सीखने का अनुपात",
    "go_back": "वापस जाएं",
    "sleepTimer": {
      "title": "स्लीप टाइमर",
      "subtitle": "निर्धारित समय के बाद प्लेबैक स्वचालित रूप से रोकें",
      "minutes": "{{count}} मिनट",
      "customPlaceholder": "कस्टम मिनट",
      "set": "टाइमर सेट करें",
      "remaining": "{{time}} में स्लीप",
      "extend": "+15 मिनट",
      "cancel": "टाइमर रद्द करें",
      "off": "[hi] Off",
      "setTimer": "[hi] Set Sleep Timer"
    },
    "openSubs": {
      "title": "सबटाइटल खोजें",
      "searchPlaceholder": "शीर्षक से खोजें...",
      "search": "खोजें",
      "searchFailed": "खोज विफल। पुनः प्रयास करें।",
      "downloads": "{{count}} डाउनलोड",
      "noResults": "कोई सबटाइटल नहीं मिला"
    },
    "dialogue": {
      "cancel": "[hi] Cancel",
      "close": "[hi] Close",
      "placeholder": "[hi] Type your message...",
      "selectCharacter": "[hi] Select Character",
      "send": "[hi] Send",
      "sharedSession": "[hi] Shared Session",
      "waitingForTurn": "[hi] Waiting for your turn...",
      "yourAvatar": "[hi] Your Avatar"
    },
    "interaction": {
      "next": "[hi] Next",
      "previous": "[hi] Previous",
      "skip": "छोड़ें",
      "start": "इंटरैक्शन शुरू करें",
      "window": "इंटरैक्शन विंडो: {{duration}} सेकंड"
    },
    "pauseAsk": {
      "askAgain": "[hi] Ask Again",
      "placeholder": "[hi] Ask about this scene...",
      "resume": "[hi] Resume",
      "resumeMovie": "[hi] Resume Movie",
      "selectCharacter": "[hi] Select Character",
      "title": "[hi] Pause & Ask"
    },
    "phraseBreakdown": {
      "literal": "शाब्दिक",
      "meaning": "अर्थ",
      "origin": "उत्पत्ति",
      "funFact": "रोचक तथ्य",
      "usage": "उपयोग: {{level}}"
    },
    "translation": {
      "example": "उदाहरण:",
      "arrow": "→"
    },
    "subtitleMode": {
      "title": "सबटाइटल मोड",
      "modes": {
        "regular": {
          "name": "सामान्य",
          "description": "स्वर चिह्नों के बिना मानक हिब्रू सबटाइटल"
        },
        "nikud": {
          "name": "निकुद",
          "description": "आसान पठन के लिए स्वर चिह्नों सहित हिब्रू"
        },
        "shoresh": {
          "name": "शोरेश",
          "description": "शब्द उत्पत्ति के साथ मूल-आधारित शिक्षा"
        },
        "engrew": {
          "name": "एंग्रू",
          "description": "हिब्रू संदर्भ के साथ अंग्रेजी लिप्यंतरण"
        },
        "heblish": {
          "name": "हेब्लिश",
          "description": "हिब्रू शब्दों और सांस्कृतिक संदर्भ के साथ अंग्रेजी"
        },
        "grammarFlip": {
          "name": "व्याकरण पलटाव",
          "description": "अंग्रेजी शब्दों के साथ हिब्रू वाक्य संरचना"
        },
        "slangSynthesis": {
          "name": "स्लैंग संश्लेषण",
          "description": "सांस्कृतिक स्लैंग और मुहावरों की व्याख्या"
        }
      }
    }
  },
  "empty": {
    "noContent": "[hi] No content available",
    "tryAnotherCategory": "[hi] Try selecting another category",
    "noPodcasts": "[hi] No podcasts available",
    "tryLater": "[hi] Try again later",
    "noResults": "[hi] No results found"
  },
  "content": {
    "play": "चलाएं",
    "addToList": "सूची में जोड़ें",
    "inList": "सूची में",
    "details": "विवरण",
    "synopsis": "सारांश",
    "genre": "शैली",
    "genres": "शैलियां",
    "runtime": "अवधि",
    "released": "रिलीज़",
    "director": "निर्देशक",
    "starring": "अभिनेता",
    "cast": "कास्ट",
    "season": "सीज़न",
    "seasons": "सीज़न",
    "episode": "एपिसोड",
    "episodes": "एपिसोड",
    "ep": "[hi] Ep",
    "selectSeason": "सीज़न चुनें",
    "noEpisodes": "कोई एपिसोड उपलब्ध नहीं",
    "noEpisodesAvailable": "[hi] No episodes available to play",
    "loadingSeries": "[hi] Loading series information...",
    "votes": "[hi] votes",
    "rating": "रेटिंग",
    "imdbRating": "[hi] IMDB Rating",
    "preview": "प्रीव्यू",
    "previewPlaying": "[hi] Preview playing",
    "trailerPlaying": "[hi] Trailer playing",
    "watchTrailer": "ट्रेलर देखें",
    "youMayAlsoLike": "आपको यह भी पसंद आ सकता है",
    "relatedContent": "संबंधित सामग्री",
    "notFound": "सामग्री नहीं मिली",
    "availableSubtitles": "[hi] Available Subtitles",
    "subtitleSelected": "[hi] Selected: {{language}}"
  },
  "breadcrumbs": {
    "series": "[hi] Series",
    "movie": "[hi] Movie",
    "watching": "[hi] Watching",
    "channel": "[hi] Channel",
    "station": "[hi] Station",
    "podcast": "[hi] Podcast",
    "watchlist": "[hi] Watchlist",
    "downloads": "[hi] Downloads"
  },
  "favorites": {
    "title": "पसंदीदा",
    "items": "आइटम",
    "empty": "अभी तक कोई पसंदीदा नहीं",
    "emptyHint": "अपने पसंदीदा में आइटम जोड़ें"
  },
  "downloads": {
    "title": "डाउनलोड",
    "items": "आइटम",
    "storage": "स्टोरेज",
    "empty": "कोई डाउनलोड नहीं",
    "emptyHint": "ऑफ़लाइन देखने के लिए सामग्री डाउनलोड करें",
    "paused": "रुका हुआ"
  },
  "watchlist": {
    "filters": {
      "all": "सभी",
      "continue": "देखना जारी रखें",
      "movies": "फ़िल्में",
      "series": "सीरीज़",
      "kids": "बच्चे",
      "judaism": "यहूदी धर्म",
      "podcasts": "पॉडकास्ट",
      "radio": "रेडियो"
    },
    "title": "वॉचलिस्ट",
    "items": "आइटम",
    "watched": "[hi] watched",
    "empty": "आपकी वॉचलिस्ट खाली है",
    "emptyHint": "देखना शुरू करें और आइटम यहां दिखाई देंगे"
  },
  "widgets": {
    "empty": "[hi] No widgets yet",
    "emptyHint": "[hi] Your widgets will appear here",
    "emptyPersonal": "[hi] No personal widgets yet",
    "emptyPersonalHint": "[hi] Create your first personal widget or add system widgets above",
    "itemsTotal": "[hi] total widgets",
    "systemWidgets": "[hi] System Widgets",
    "systemWidgetsHint": "[hi] Browse and add widgets to your collection",
    "myWidgets": "[hi] My Personal Widgets",
    "myWidgetsHint": "[hi] Widgets you have created",
    "personalWidgets": "[hi] My Widgets",
    "noSystemWidgets": "[hi] No system widgets available",
    "added": "[hi] Added",
    "add": "[hi] Add",
    "remove": "[hi] Remove",
    "show": "[hi] Show",
    "hidden": "[hi] Hidden",
    "addToCollection": "[hi] Add to My Widgets",
    "removeFromCollection": "[hi] Remove from My Widgets",
    "contentTypes": {
      "liveChannel": "[hi] Live Channel",
      "iframe": "[hi] Web Content",
      "podcast": "[hi] Podcast",
      "radio": "[hi] Radio",
      "vod": "[hi] Video",
      "custom": "[hi] Custom",
      "widget": "[hi] Widget"
    },
    "form": {
      "title": "[hi] Create Widget",
      "basicInfo": "[hi] Basic Information",
      "titlePlaceholder": "[hi] Widget Title",
      "titleRequired": "[hi] Widget Title is required",
      "descriptionPlaceholder": "[hi] Description (optional)",
      "iconPlaceholder": "[hi] Icon emoji (e.g., 📺)",
      "content": "[hi] Content",
      "fromLibrary": "[hi] From Library",
      "iframe": "[hi] iFrame",
      "selectContent": "[hi] Select Content (Channels, Podcasts, Shows, etc.)",
      "iframeUrl": "[hi] iFrame URL",
      "iframeUrlRequired": "[hi] iFrame URL is required",
      "iframeTitle": "[hi] iFrame Title",
      "positionSize": "[hi] Position & Size",
      "behavior": "[hi] Behavior",
      "mutedByDefault": "[hi] Muted by Default",
      "closable": "[hi] Closable",
      "draggable": "[hi] Draggable",
      "widgetOrder": "[hi] Widget Order",
      "orderPlaceholder": "[hi] Order (0 = first)",
      "saveWidget": "[hi] Save Widget",
      "saving": "[hi] Saving...",
      "cancel": "[hi] Cancel",
      "change": "[hi] Change"
    }
  },
  "trending": {
    "title": "[hi] What's Trending in Israel",
    "noTopics": "[hi] No trending topics available",
    "topStory": "[hi] TOP STORY",
    "sources": "[hi] Sources",
    "categories": {
      "security": "[hi] Security",
      "politics": "[hi] Politics",
      "tech": "[hi] Tech",
      "culture": "[hi] Culture",
      "sports": "[hi] Sports",
      "economy": "[hi] Economy",
      "entertainment": "[hi] Entertainment",
      "weather": "[hi] Weather",
      "health": "[hi] Health",
      "general": "[hi] General"
    }
  },
  "cultures": {
    "title": "[hi] Select Your Culture",
    "select": "[hi] Select Culture",
    "selectCulture": "[hi] Choose Your Culture",
    "selectCultureDescription": "[hi] Select your cultural community to personalize your experience",
    "changeCulture": "[hi] Change Culture",
    "israeli": {
      "name": "[hi] Israeli",
      "description": "[hi] Israeli expat community content"
    },
    "chinese": {
      "name": "[hi] Chinese",
      "description": "[hi] Chinese community content"
    },
    "japanese": {
      "name": "[hi] Japanese",
      "description": "[hi] Japanese community content"
    },
    "korean": {
      "name": "[hi] Korean",
      "description": "[hi] Korean community content"
    },
    "indian": {
      "name": "[hi] Indian",
      "description": "[hi] Indian community content"
    }
  },
  "cultureTrending": {
    "whatsHotIn": "[hi] What's Hot in {{location}}",
    "noTopics": "[hi] No trending topics available",
    "sources": "[hi] Sources",
    "categories": {
      "security": "[hi] Security",
      "politics": "[hi] Politics",
      "tech": "[hi] Tech",
      "technology": "[hi] Technology",
      "culture": "[hi] Culture",
      "sports": "[hi] Sports",
      "economy": "[hi] Economy",
      "finance": "[hi] Finance",
      "entertainment": "[hi] Entertainment",
      "weather": "[hi] Weather",
      "health": "[hi] Health",
      "food": "[hi] Food",
      "fashion": "[hi] Fashion",
      "travel": "[hi] Travel",
      "history": "[hi] History",
      "expat": "[hi] Expat Life",
      "general": "[hi] General"
    }
  },
  "cultureClock": {
    "timeIn": "{{location}} में समय",
    "shabbat": "शब्बत",
    "weekend": "सप्ताहांत"
  },
  "cultureCities": {
    "connectionTo": "[hi] {{city}} Connection",
    "explore": "[hi] Explore {{city}}",
    "noContent": "[hi] No content available for this city",
    "categories": {
      "all": "[hi] All",
      "history": "[hi] History",
      "culture": "[hi] Culture",
      "finance": "[hi] Finance",
      "tech": "[hi] Tech",
      "food": "[hi] Food",
      "expat": "[hi] Expat Life",
      "news": "[hi] News",
      "entertainment": "[hi] Entertainment"
    }
  },
  "clock": {
    "israel": "[hi] Israel",
    "local": "[hi] Local",
    "shabbatShalom": "[hi] Shabbat Shalom!",
    "erevShabbat": "[hi] Erev Shabbat",
    "candleLighting": "[hi] Candle Lighting",
    "parasha": "[hi] Parasha"
  },
  "ritual": {
    "title": "[hi] Morning Ritual",
    "greeting": "[hi] Good Morning!",
    "israelUpdate": "[hi] It's afternoon in Israel, news is reporting on ongoing developments",
    "recommendation": "[hi] We recommend starting with morning news then switching to radio",
    "preparingRitual": "[hi] Preparing your morning ritual...",
    "israelTime": "[hi] Israel Time",
    "day": "[hi] Day",
    "letsStart": "[hi] Let's Start",
    "skipToday": "[hi] Skip for Today",
    "finish": "[hi] Finish",
    "noContentNow": "[hi] No content available right now",
    "typeLive": "[hi] Live",
    "typeRadio": "[hi] Radio",
    "typeVideo": "[hi] Video"
  },
  "watchParty": {
    "title": "[hi] Watch Party",
    "create": "[hi] Create Party",
    "join": "[hi] Join Party",
    "active": "[hi] Party Active",
    "createTitle": "[hi] Create Watch Party",
    "joinTitle": "[hi] Join Party",
    "enterCode": "[hi] Enter Room Code",
    "roomCode": "[hi] Room Code",
    "copyCode": "[hi] Copy Code",
    "codeCopied": "[hi] Code Copied!",
    "participants": "[hi] Participants",
    "host": "[hi] Host",
    "you": "[hi] You",
    "leave": "[hi] Leave Party",
    "end": "[hi] End Party",
    "chat": "[hi] Chat",
    "sendMessage": "[hi] Send Message",
    "typeMessage": "[hi] Type a message...",
    "synced": "[hi] Synced",
    "syncing": "[hi] Syncing...",
    "hostPaused": "[hi] Host Paused",
    "userJoined": "[hi] {{name}} joined",
    "userLeft": "[hi] {{name}} left",
    "partyEnded": "[hi] The party has ended",
    "connecting": "[hi] Connecting...",
    "options": {
      "chatEnabled": "[hi] Enable Chat",
      "syncPlayback": "[hi] Sync Playback"
    },
    "errors": {
      "invalidCode": "[hi] Invalid code",
      "partyFull": "[hi] Party is full",
      "partyEnded": "[hi] Party has ended",
      "connectionError": "[hi] Connection error",
      "createFailed": "[hi] Failed to create party",
      "joinFailed": "[hi] Failed to join party"
    },
    "audio": {
      "mute": "[hi] Mute",
      "unmute": "[hi] Unmute",
      "speaking": "[hi] Speaking",
      "connecting": "[hi] Connecting to audio...",
      "noAudio": "[hi] Audio not available"
    },
    "textOnlyMode": "[hi] Text Chat Only",
    "endParty": "[hi] End Party"
  },
  "footer": {
    "brandDescription": "USA में आपका घर। हिब्रू में TV प्रसारण, VOD, रेडियो और पॉडकास्ट।",
    "browse": "ब्राउज़ करें",
    "account": "खाता",
    "support": "सहायता",
    "legal": "कानूनी",
    "location": "[hi] New York, USA",
    "links": {
      "home": "[hi] Home",
      "liveTV": "[hi] Live TV",
      "vod": "[hi] Movies & Series",
      "radio": "[hi] Radio",
      "podcasts": "[hi] Podcasts",
      "judaism": "[hi] Judaism",
      "profile": "[hi] My Profile",
      "favorites": "[hi] Favorites",
      "watchlist": "[hi] Watchlist",
      "subscribe": "[hi] Subscribe",
      "downloads": "[hi] Downloads",
      "help": "[hi] Help Center",
      "faq": "[hi] FAQ",
      "contact": "[hi] Contact Us",
      "feedback": "[hi] Feedback",
      "terms": "[hi] Terms of Service",
      "privacy": "[hi] Privacy Policy",
      "cookies": "[hi] Cookie Policy",
      "licenses": "[hi] Licenses"
    },
    "newsletter": {
      "title": "[hi] Stay Updated",
      "description": "[hi] Subscribe to our newsletter for the latest updates and exclusive content.",
      "placeholder": "[hi] Enter your email",
      "success": "[hi] Thanks for subscribing!"
    },
    "apps": {
      "title": "[hi] Get the App",
      "downloadOn": "[hi] Download on",
      "getItOn": "[hi] Get it on",
      "appStore": "[hi] App Store",
      "googlePlay": "[hi] Google Play"
    },
    "social": {
      "facebook": "[hi] Facebook",
      "twitter": "[hi] Twitter",
      "instagram": "[hi] Instagram",
      "youtube": "[hi] YouTube"
    },
    "copyright": "© {{year}} Bayit+. सर्वाधिकार सुरक्षित।",
    "poweredBy": "द्वारा संचालित",
    "sitemap": "[hi] Sitemap",
    "accessibility": "[hi] Accessibility",
    "navigation": "[hi] Navigation",
    "liveTV": "[hi] Live TV",
    "moviesAndSeries": "[hi] Movies & Series",
    "radioStations": "[hi] Radio Stations",
    "myProfile": "[hi] My Profile",
    "subscriptions": "[hi] Subscriptions",
    "helpAndSupport": "[hi] Help & Support",
    "termsOfUse": "[hi] Terms of Use",
    "privacyPolicy": "[hi] Privacy Policy",
    "contactUs": "[hi] Contact Us"
  },
  "chapters": {
    "title": "[hi] Chapters",
    "noChapters": "[hi] No chapters available",
    "generating": "[hi] Generating chapters...",
    "jumpTo": "[hi] Jump to",
    "current": "[hi] Now",
    "categories": {
      "intro": "[hi] Introduction",
      "news": "[hi] News",
      "security": "[hi] Security",
      "politics": "[hi] Politics",
      "economy": "[hi] Economy",
      "sports": "[hi] Sports",
      "weather": "[hi] Weather",
      "culture": "[hi] Culture",
      "conclusion": "[hi] Conclusion"
    },
    "chapterLabel": "अध्याय {{number}}",
    "chapter_number": "अध्याय {{number}}"
  },
  "admin": {
    "brand": {
      "title": "Bayit+ एडमिन",
      "subtitle": "सिस्टम प्रबंधन"
    },
    "backToApp": "ऐप पर वापस जाएं",
    "refunds": {
      "subtitle": "रिफंड अनुरोध प्रबंधित करें",
      "approveModal": {
        "title": "स्वीकृति की पुष्टि करें",
        "message": "{{amount}} का रिफंड स्वीकार करें?"
      },
      "confirmApprove": "{{amount}} का रिफंड स्वीकार करें?",
      "confirmDelete": "रिफंड अनुरोध हटाएं?",
      "rejectModal": {
        "title": "रिफंड अनुरोध अस्वीकार करें",
        "message": "{{amount}} का रिफंड अस्वीकार करना",
        "reasonLabel": "अस्वीकृति का कारण",
        "reasonPlaceholder": "कृपया अस्वीकृति का कारण दर्ज करें...",
        "submitButton": "अनुरोध अस्वीकार करें"
      },
      "status": {
        "pending": "लंबित",
        "approved": "स्वीकृत",
        "rejected": "अस्वीकृत"
      },
      "columns": {
        "id": "ID",
        "user": "उपयोगकर्ता",
        "amount": "राशि",
        "reason": "कारण",
        "status": "स्थिति",
        "requestDate": "अनुरोध तिथि"
      },
      "stats": {
        "pendingTitle": "स्वीकृति लंबित",
        "approvedTitle": "स्वीकृत",
        "rejectedTitle": "अस्वीकृत",
        "totalRefunded": "कुल रिफंड"
      },
      "emptyMessage": "कोई रिफंड अनुरोध नहीं मिला",
      "errors": {
        "rejectReasonRequired": "कृपया अस्वीकृति का कारण दर्ज करें"
      },
      "title": "रिफंड"
    },
    "plans": {
      "title": "योजना प्रबंधन",
      "subtitle": "सब्सक्रिप्शन योजनाएं कॉन्फ़िगर और प्रबंधित करें",
      "createButton": "नई योजना",
      "inactive": "निष्क्रिय",
      "subscribersLabel": "सब्सक्राइबर:",
      "intervals": {
        "monthly": "महीना",
        "yearly": "वर्ष"
      },
      "trialDays": "{{days}} दिन का ट्रायल",
      "modal": {
        "editTitle": "योजना संपादित करें",
        "createTitle": "नई योजना"
      },
      "form": {
        "nameEn": "नाम (अंग्रेजी)",
        "nameHe": "नाम (हिब्रू)",
        "price": "मूल्य ($)",
        "interval": "बिलिंग अवधि",
        "trialDays": "ट्रायल दिन",
        "features": "विशेषताएं (प्रति पंक्ति एक)",
        "active": "सक्रिय योजना"
      },
      "errors": {
        "requiredFields": "नाम और मूल्य आवश्यक हैं"
      },
      "confirmDelete": "योजना \"{{name}}\" हटाएं?"
    },
    "emailCampaigns": {
      "subtitle": "ईमेल अभियान बनाएं और प्रबंधित करें",
      "createButton": "नया अभियान",
      "searchPlaceholder": "अभियान खोजें...",
      "emptyMessage": "कोई अभियान नहीं मिला",
      "status": {
        "draft": "ड्राफ्ट",
        "active": "सक्रिय",
        "scheduled": "अनुसूचित",
        "completed": "पूर्ण"
      },
      "columns": {
        "name": "अभियान नाम",
        "status": "स्थिति",
        "sent": "भेजे गए",
        "opened": "खोले गए",
        "clicked": "क्लिक किए गए",
        "created": "बनाया गया",
        "actions": "कार्रवाइयां"
      },
      "editModal": {
        "title": "अभियान संपादित करें"
      },
      "sendTestEmail": "टेस्ट भेजें",
      "confirmSend": "अभियान \"{{name}}\" भेजें?",
      "confirmDelete": "अभियान \"{{name}}\" हटाएं?",
      "testEmailSent": "टेस्ट ईमेल भेजा गया!",
      "createModal": {
        "title": "नया ईमेल अभियान"
      },
      "form": {
        "name": "अभियान नाम",
        "namePlaceholder": "जैसे, वर्ष अंत बिक्री",
        "subject": "ईमेल विषय",
        "subjectPlaceholder": "प्राप्तकर्ताओं को दिखाया जाने वाला विषय",
        "body": "सामग्री",
        "bodyPlaceholder": "ईमेल सामग्री...",
        "submitButton": "अभियान बनाएं",
        "requiredFields": "नाम और विषय आवश्यक हैं"
      },
      "testModal": {
        "title": "टेस्ट ईमेल भेजें",
        "emailLabel": "ईमेल पता",
        "emailPlaceholder": "test@example.com",
        "submitButton": "टेस्ट भेजें"
      },
      "errors": {
        "requiredFields": "नाम और विषय आवश्यक हैं"
      }
    },
    "dashboard": {
      "subtitle": "सिस्टम अवलोकन",
      "refresh": "रीफ्रेश",
      "timeAgo": {
        "minutes": "{{count}} मिनट पहले",
        "hours": "{{count}} घंटे पहले"
      },
      "title": "डैशबोर्ड",
      "users": "उपयोगकर्ता",
      "revenue": "राजस्व",
      "subscriptions": "सब्सक्रिप्शन",
      "recentActivity": "हाल की गतिविधि",
      "quickActions": "त्वरित कार्रवाइयां"
    },
    "common": {
      "all": "सभी",
      "cancel": "रद्द करें",
      "save": "सहेजें",
      "active": "सक्रिय",
      "back": "वापस",
      "filterAction": "कार्रवाई",
      "filterResource": "संसाधन",
      "filterUser": "उपयोगकर्ता",
      "filterDateRange": "तारीख सीमा"
    },
    "stats": {
      "totalUsers": "कुल उपयोगकर्ता",
      "activeUsers": "सक्रिय उपयोगकर्ता",
      "newToday": "आज नए",
      "newThisWeek": "इस सप्ताह नए",
      "totalRevenue": "कुल राजस्व",
      "revenueToday": "आज का राजस्व",
      "revenueMonth": "इस महीने का राजस्व",
      "arpu": "प्रति उपयोगकर्ता औसत राजस्व",
      "activeSubscriptions": "सक्रिय सब्सक्रिप्शन",
      "churnRate": "चर्न दर"
    },
    "actions": {
      "new": "नया",
      "addUser": "उपयोगकर्ता जोड़ें",
      "newCampaign": "नया अभियान",
      "sendEmail": "ईमेल भेजें",
      "viewReports": "रिपोर्ट देखें"
    },
    "auditActions": {
      "user_created": "उपयोगकर्ता बनाया गया",
      "user_updated": "उपयोगकर्ता अपडेट किया गया",
      "user_deleted": "उपयोगकर्ता हटाया गया",
      "user_role_changed": "उपयोगकर्ता भूमिका बदली गई",
      "campaign_created": "अभियान बनाया गया",
      "campaign_updated": "अभियान अपडेट किया गया",
      "campaign_deleted": "अभियान हटाया गया",
      "campaign_activated": "अभियान सक्रिय किया गया",
      "subscription_created": "सब्सक्रिप्शन बनाया गया",
      "subscription_updated": "सब्सक्रिप्शन अपडेट किया गया",
      "subscription_canceled": "सब्सक्रिप्शन रद्द किया गया",
      "subscription_deleted": "सब्सक्रिप्शन हटाया गया",
      "refund_processed": "रिफंड प्रोसेस किया गया",
      "payment_received": "भुगतान प्राप्त हुआ",
      "settings_updated": "सेटिंग्स अपडेट की गईं",
      "login": "लॉगिन",
      "logout": "लॉगआउट",
      "content_created": "सामग्री बनाई गई",
      "content_updated": "सामग्री अपडेट की गई",
      "content_deleted": "सामग्री हटाई गई",
      "content_published": "सामग्री प्रकाशित की गई",
      "content_unpublished": "सामग्री अप्रकाशित की गई",
      "category_created": "श्रेणी बनाई गई",
      "category_updated": "श्रेणी अपडेट की गई",
      "category_deleted": "श्रेणी हटाई गई",
      "live_channel_created": "लाइव चैनल बनाया गया",
      "live_channel_updated": "लाइव चैनल अपडेट किया गया",
      "live_channel_deleted": "लाइव चैनल हटाया गया",
      "radio_station_created": "रेडियो स्टेशन बनाया गया",
      "radio_station_updated": "रेडियो स्टेशन अपडेट किया गया",
      "radio_station_deleted": "रेडियो स्टेशन हटाया गया",
      "podcast_created": "पॉडकास्ट बनाया गया",
      "podcast_updated": "पॉडकास्ट अपडेट किया गया",
      "podcast_deleted": "पॉडकास्ट हटाया गया",
      "podcast_episode_created": "पॉडकास्ट एपिसोड बनाया गया",
      "podcast_episode_updated": "पॉडकास्ट एपिसोड अपडेट किया गया",
      "podcast_episode_deleted": "पॉडकास्ट एपिसोड हटाया गया",
      "content_imported": "सामग्री आयातित की गई",
      "widget_created": "विजेट बनाया गया",
      "widget_updated": "विजेट अपडेट किया गया",
      "widget_deleted": "विजेट हटाया गया",
      "widget_published": "विजेट प्रकाशित किया गया",
      "widget_unpublished": "विजेट अप्रकाशित किया गया"
    },
    "placeholder": {
      "userId": "उपयोगकर्ता ID दर्ज करें",
      "discount": "0"
    },
    "titles": {
      "users": "उपयोगकर्ता",
      "transactions": "लेनदेन",
      "subscriptions": "सब्सक्रिप्शन",
      "refunds": "रिफंड",
      "plans": "योजनाएं",
      "campaigns": "अभियान",
      "auditLogs": "ऑडिट लॉग",
      "pushNotifications": "पुश नोटिफिकेशन",
      "billing": "बिलिंग",
      "marketing": "मार्केटिंग",
      "content": "सामग्री लाइब्रेरी",
      "categories": "श्रेणियां",
      "liveChannels": "लाइव चैनल",
      "radioStations": "रेडियो स्टेशन",
      "podcasts": "पॉडकास्ट",
      "settings": "सेटिंग्स"
    },
    "nav": {
      "dashboard": "डैशबोर्ड",
      "users": "उपयोगकर्ता",
      "campaigns": "अभियान",
      "billing": "बिलिंग",
      "billingOverview": "अवलोकन",
      "transactions": "लेनदेन",
      "refunds": "रिफंड",
      "subscriptions": "सब्सक्रिप्शन",
      "subscriptionsList": "सब्सक्राइबर",
      "plans": "योजनाएं",
      "marketing": "मार्केटिंग",
      "marketingDashboard": "अवलोकन",
      "emailCampaigns": "ईमेल अभियान",
      "pushNotifications": "पुश नोटिफिकेशन",
      "content": "सामग्री",
      "contentLibrary": "सामग्री लाइब्रेरी",
      "categories": "श्रेणियां",
      "liveChannels": "लाइव चैनल",
      "radioStations": "रेडियो स्टेशन",
      "podcasts": "पॉडकास्ट",
      "widgets": "विजेट",
      "recordings": "रिकॉर्डिंग",
      "uploads": "अपलोड",
      "settings": "सेटिंग्स",
      "auditLogs": "ऑडिट लॉग",
      "librarian": "लाइब्रेरियन एजेंट",
      "featured": "फीचर्ड"
    },
    "featured": {
      "title": "फीचर्ड सामग्री",
      "subtitle": "होमपेज कैरोसेल के लिए फीचर्ड सामग्री प्रबंधित करें",
      "empty": "कोई फीचर्ड सामग्री नहीं",
      "emptyHint": "फीचर्ड आइटम होमपेज पर अपने संबंधित कैरोसेल में दिखाई देंगे",
      "count": "{{count}} आइटम",
      "confirmUnfeature": "फीचर्ड से हटाएं?",
      "remove": "हटाएं",
      "unsavedChanges": "आपके पास सहेजे न गए बदलाव हैं",
      "section": {
        "title": "{{name}}",
        "itemCount": "{{count}} आइटम",
        "itemCount_plural": "{{count}} आइटम",
        "empty": "कोई फीचर्ड आइटम नहीं",
        "emptyHint": "फीचर्ड आइटम होमपेज पर {{name}} कैरोसेल में दिखाई देंगे"
      },
      "saveButton": "{{count}} अनुभाग सहेजें",
      "saveButton_plural": "{{count}} अनुभाग सहेजें",
      "saving": "सहेज रहे हैं...",
      "saveSuccess": "फीचर्ड सामग्री सफलतापूर्वक अपडेट की गई",
      "saveFailed": "फीचर्ड सामग्री सहेजने में विफल",
      "removeConfirm": "{{section}} से हटाएं?",
      "removeSuccess": "{{section}} से हटाया गया"
    },
    "recordings": {
      "title": "रिकॉर्डिंग प्रबंधन",
      "subtitle": "प्लेटफ़ॉर्म पर उपयोगकर्ता रिकॉर्डिंग प्रबंधित करें",
      "totalRecordings": "कुल रिकॉर्डिंग",
      "totalStorage": "कुल स्टोरेज",
      "totalUsers": "रिकॉर्डिंग वाले उपयोगकर्ता",
      "activeSessions": "सक्रिय सत्र",
      "searchPlaceholder": "शीर्षक, उपयोगकर्ता, या चैनल द्वारा खोजें...",
      "user": "उपयोगकर्ता",
      "confirmDelete": "रिकॉर्डिंग '{{title}}' हटाएं? यह क्रिया पूर्ववत नहीं की जा सकती।",
      "deleteRecording": "रिकॉर्डिंग हटाएं",
      "deleteSuccess": "रिकॉर्डिंग सफलतापूर्वक हटाई गई",
      "deleteFailed": "रिकॉर्डिंग हटाने में विफल",
      "loadFailed": "रिकॉर्डिंग लोड करने में विफल",
      "noRecordings": "कोई रिकॉर्डिंग नहीं मिली",
      "noRecordingsHint": "सिस्टम में अभी तक कोई उपयोगकर्ता रिकॉर्डिंग नहीं है।"
    },
    "uploads": {
      "title": "अपलोड प्रबंधन",
      "subtitle": "सामग्री अपलोड और स्वचालित फ़ोल्डर मॉनिटरिंग प्रबंधित करें",
      "activeUploads": "सक्रिय अपलोड",
      "noActiveUploads": "कोई सक्रिय अपलोड नहीं",
      "queuedUploads": "कतारबद्ध अपलोड",
      "queued": "कतारबद्ध",
      "andMore": "और {{count}} और",
      "monitoredFolders": "मॉनिटर किए गए फ़ोल्डर",
      "noMonitoredFolders": "कोई मॉनिटर किया गया फ़ोल्डर कॉन्फ़िगर नहीं है",
      "configureFoldersHelp": "स्वचालित अपलोड के लिए मॉनिटर किए गए फ़ोल्डर कॉन्फ़िगर करने के लिए 'फ़ोल्डर जोड़ें' क्लिक करें",
      "addFolder": "फ़ोल्डर जोड़ें",
      "editFolder": "फ़ोल्डर संपादित करें",
      "deleteFolder": "फ़ोल्डर हटाएं",
      "confirmDelete": "यह फ़ोल्डर हटाएं?",
      "triggerUpload": "अपलोड ट्रिगर करें",
      "triggerUploadSuccess": "अपलोड करने के लिए {{files_found}} नई फाइलें मिलीं",
      "triggerUploadFailed": "अपलोड स्कैन ट्रिगर करने में विफल",
      "noFilesFound": "मॉनिटर किए गए फ़ोल्डर में कोई नई फाइलें नहीं मिलीं",
      "sessionIssue": "सत्र समस्या",
      "sessionIssueHelp": "आपका सत्र समाप्त हो सकता है। कृपया कनेक्शन पुनर्स्थापित करने के लिए पृष्ठ रीफ्रेश करें।",
      "sessionExpired": "सत्र समाप्त। कृपया पृष्ठ रीफ्रेश करें या फिर से लॉग इन करें।",
      "unauthorized": "सत्र अमान्य। कृपया पृष्ठ रीफ्रेश करें।",
      "endpointNotFound": "अपलोड सेवा उपलब्ध नहीं। सर्वर कॉन्फ़िगरेशन जांचें।",
      "timeout": "अपलोड स्कैन समय समाप्त। पुनः प्रयास करें या मॉनिटर किए गए फ़ोल्डर जांचें।",
      "wsDisconnected": "रियल-टाइम अपडेट अक्षम",
      "wsDisconnectedHelp": "WebSocket कनेक्शन विफल। कतार स्थिति पुरानी हो सकती है। पृष्ठ स्वतः पुनः प्रयास करेगा।",
      "wsReconnecting": "रियल-टाइम अपडेट से पुनः कनेक्ट हो रहा है...",
      "uploadAlreadyRunning": "अपलोड स्कैन पहले से प्रगति में है। कृपया वर्तमान अपलोड पूर्ण होने की प्रतीक्षा करें।",
      "uploadsActiveNotice": "अपलोड प्रगति में हैं ({{processing}} सक्रिय, {{queued}} कतारबद्ध)। वर्तमान बैच पूर्ण होने तक नया स्कैन अक्षम।",
      "clearQueue": "कतार साफ़ करें",
      "clearQueueConfirmTitle": "अपलोड कतार साफ़ करें?",
      "clearQueueConfirmMessage": "यह {{count}} सक्रिय जॉब रद्द करेगा। यह क्रिया पूर्ववत नहीं की जा सकती।",
      "clearQueueSuccess": "कतार सफलतापूर्वक साफ़ की गई",
      "clearQueueFailed": "कतार साफ़ करने में विफल",
      "cancelUpload": "रद्द करें",
      "cancelUploadConfirm": "यह अपलोड रद्द करें?",
      "cancelUploadSuccess": "अपलोड रद्द किया गया",
      "cancelUploadFailed": "अपलोड रद्द करने में विफल",
      "resetCache": "कैश रीसेट करें",
      "cacheResetSuccess": "कैश साफ़: {{count}} फाइलें अगले स्कैन में पुनः स्कैन होंगी",
      "cacheResetFailed": "कैश रीसेट करने में विफल",
      "contentTypeFilters": "सामग्री प्रकार फ़िल्टर",
      "contentTypeFiltersHelp": "वैकल्पिक - सभी सामग्री प्रकारों को प्रोसेस करने के लिए सभी अनचेक्ड रखें",
      "moviesOnly": "केवल मूवीज़",
      "seriesOnly": "केवल सीरीज़",
      "audiobooksOnly": "केवल ऑडियोबुक",
      "type": "प्रकार",
      "lastScan": "अंतिम स्कैन",
      "systemInfo": "अपलोड सिस्टम जानकारी",
      "systemInfoText": "तेज़ प्रोसेसिंग के लिए अपलोड के दौरान स्थानीय वीडियो फाइलों से स्वचालित रूप से उपशीर्षक निकालता है",
      "languagesInfo": "समर्थित उपशीर्षक भाषाएं: अंग्रेजी (en), हिब्रू (he), स्पेनिश (es)",
      "queueStatus": "अपलोड कतार",
      "totalJobs": "कुल",
      "processing": "सक्रिय",
      "completed": "पूर्ण",
      "skipped": "छोड़े गए",
      "failed": "विफल",
      "queuePaused": "कतार रुकी हुई",
      "resumeQueue": "फिर से शुरू करें",
      "activeUpload": "सक्रिय अपलोड",
      "queuedItems": "कतारबद्ध",
      "noQueuedItems": "कतार में कोई आइटम नहीं",
      "addedAt": "जोड़ा गया",
      "recentCompleted": "हाल में पूर्ण",
      "stages": {
        "browserUpload": "सर्वर पर अपलोड हो रहा है",
        "hashCalculation": "हैश की गणना हो रही है",
        "duplicateCheck": "डुप्लिकेट की जांच हो रही है",
        "metadataExtraction": "मेटाडेटा निकाला जा रहा है",
        "gcsUpload": "क्लाउड पर अपलोड हो रहा है",
        "databaseInsert": "डेटाबेस में सहेजा जा रहा है",
        "imdbLookup": "IMDB जानकारी प्राप्त हो रही है",
        "subtitleExtraction": "उपशीर्षक निकाले जा रहे हैं",
        "completed": "पूर्ण",
        "failed": "विफल",
        "skipped": "छोड़ा गया"
      },
      "form": {
        "name": "फ़ोल्डर नाम",
        "namePlaceholder": "मेरा मूवीज़ फ़ोल्डर",
        "path": "फ़ोल्डर पथ",
        "pathHelp": "फ़ोल्डर के लिए सर्वर पथ दर्ज करें (जैसे, /Volumes/USB Drive/Movies)",
        "contentType": "सामग्री प्रकार",
        "enabled": "सक्षम",
        "autoUpload": "स्वतः अपलोड"
      },
      "contentTypes": {
        "movie": "मूवीज़",
        "series": "सीरीज़",
        "audiobook": "ऑडियोबुक"
      },
      "errors": {
        "pathRequired": "फ़ोल्डर पथ आवश्यक है"
      },
      "manualUpload": {
        "title": "मैनुअल अपलोड",
        "subtitle": "फाइलें खींचें और छोड़ें या फ़ोल्डर चुनें",
        "dropHere": "यहां फाइलें छोड़ें या ब्राउज़ करने के लिए क्लिक करें",
        "dropHereActive": "जोड़ने के लिए फाइलें छोड़ें",
        "selectFolder": "फ़ोल्डर चुनें",
        "supportedFormats": "वीडियो फाइलें समर्थित (mp4, mkv, avi, mov, webm)",
        "selectedFiles": "चयनित फाइलें",
        "noFilesSelected": "कोई फाइलें चयनित नहीं",
        "clearAll": "सभी साफ़ करें",
        "uploadSelected": "चयनित अपलोड करें",
        "selectContentType": "अपलोड के लिए सामग्री प्रकार चुनें",
        "uploadingFiles": "{{count}} फाइलें कतार में जोड़ी जा रही हैं...",
        "uploadSuccess": "{{count}} फाइलें सफलतापूर्वक कतार में जोड़ी गईं",
        "uploadFailed": "फाइलें कतार में जोड़ने में विफल",
        "fileSize": "आकार",
        "removeFile": "हटाएं",
        "invalidFileType": "अमान्य फ़ाइल प्रकार। केवल वीडियो फाइलें समर्थित हैं।",
        "filesCount": "{{count}} फाइलें चयनित",
        "pendingRestore": "पिछले सत्र से {{count}} फाइलें लंबित",
        "pendingRestoreHint": "अपनी अपलोड कतार पुनर्स्थापित करने के लिए वही फाइलें खींचें या चुनें"
      }
    },
    "librarian": {
      "title": "लाइब्रेरियन एजेंट",
      "subtitle": "स्वायत्त AI-संचालित सामग्री लाइब्रेरी प्रबंधन",
      "loading": "लाइब्रेरियन एजेंट लोड हो रहा है...",
      "loadingConfig": "कॉन्फ़िगरेशन लोड हो रहा है...",
      "refresh": "रीफ्रेश",
      "errors": {
        "configError": "कॉन्फ़िगरेशन त्रुटि",
        "configNotLoaded": "कॉन्फ़िगरेशन लोड नहीं हुआ",
        "failedToLoad": "लाइब्रेरियन डेटा लोड करने में विफल",
        "failedToLoadConfig": "लाइब्रेरियन कॉन्फ़िगरेशन लोड करने में विफल",
        "failedToTrigger": "ऑडिट ट्रिगर करने में विफल। कृपया पुनः प्रयास करें।",
        "failedToLoadDetails": "रिपोर्ट विवरण लोड करने में विफल।",
        "failedToRollback": "क्रिया रोलबैक करने में विफल।",
        "failedToClearReports": "ऑडिट रिपोर्ट साफ़ करने में विफल। कृपया पुनः प्रयास करें।",
        "failedToPause": "ऑडिट रोकने में विफल",
        "failedToResume": "ऑडिट फिर से शुरू करने में विफल",
        "failedToCancel": "ऑडिट रद्द करने में विफल",
        "failedToInterject": "AI एजेंट को संदेश भेजने में विफल",
        "auditAlreadyRunning": "एक ऑडिट पहले से चल रहा है। कृपया नया शुरू करने से पहले इसके पूरा होने या रद्द होने की प्रतीक्षा करें।",
        "budgetExceeded": "मासिक बजट सीमा पार हो गई। ऑडिट नहीं चला सकते।",
        "contactAdmin": "लाइब्रेरियन पेज उचित कॉन्फ़िगरेशन के बिना लोड नहीं हो सकता।\nकृपया अपने प्रशासक से संपर्क करें।"
      },
      "stats": {
        "systemHealth": "सिस्टम स्वास्थ्य",
        "totalAudits": "कुल ऑडिट (30 दिन)",
        "last30Days": "पिछले 30 दिन",
        "issuesFixed": "समस्याएं ठीक की गईं",
        "lastAudit": "अंतिम ऑडिट",
        "never": "कभी नहीं",
        "unknown": "अज्ञात"
      },
      "health": {
        "excellent": "उत्कृष्ट",
        "good": "अच्छा",
        "fair": "ठीक",
        "poor": "खराब",
        "unknown": "अज्ञात"
      },
      "quickActions": {
        "title": "रन कॉन्फ़िगरेशन",
        "subtitle": "ऑडिट कॉन्फ़िगर और ट्रिगर करें",
        "auditMode": "ऑडिट मोड",
        "auditModeHelp": "क्या जांचना है चुनें",
        "dryRun": "प्रीव्यू मोड",
        "dryRunHelp": "बिना बदलाव किए दिखाएं क्या बदलेगा",
        "scopeFilters": "ऑडिट क्षमताएं",
        "scopeFiltersHelp": "सक्षम करने के लिए क्षमताएं चुनें (कई संयोजित की जा सकती हैं)",
        "last24Hours": "केवल हाल की सामग्री",
        "last24HoursHelp": "ऑडिट को पिछले 24 घंटों में जोड़ी गई सामग्री तक सीमित करें",
        "cybTitlesOnly": "गंदे शीर्षक साफ़ करें",
        "cybTitlesOnlyHelp": "शीर्षकों से फ़ाइल एक्सटेंशन, गुणवत्ता मार्कर और रिलीज़ टैग हटाएं",
        "tmdbPostersOnly": "TMDB पोस्टर और मेटाडेटा",
        "tmdbPostersOnlyHelp": "TMDB से गायब पोस्टर, विवरण और मेटाडेटा प्राप्त करें",
        "openSubtitlesEnabled": "उपशीर्षक प्राप्त करें",
        "openSubtitlesEnabledHelp": "OpenSubtitles से गायब उपशीर्षक डाउनलोड करें (HE/EN/ES)",
        "classifyOnly": "वर्गीकरण सत्यापित करें",
        "classifyOnlyHelp": "मूवी बनाम सीरीज़ वर्गीकरण त्रुटियों की जांच और सुधार करें",
        "purgeDuplicates": "डुप्लिकेट हटाएं",
        "purgeDuplicatesHelp": "डुप्लिकेट सामग्री आइटम खोजें और हटाएं",
        "auditType": "ऑडिट प्रकार",
        "auditTypeHelp": "नियम-आधारित या AI-संचालित ऑडिट के बीच चुनें",
        "dailyAudit": "दैनिक ऑडिट",
        "dailyBadge": "नियम-आधारित • तेज़ • मुफ्त",
        "dailyDescription": "पिछले 7 दिनों में संशोधित सामग्री पर पूर्वनिर्धारित जांच चलाता है। तेज़ और अनुमानित, कोई AI लागत नहीं।",
        "aiAgentAudit": "AI एजेंट ऑडिट",
        "aiAgentBadge": "AI-संचालित • बुद्धिमान • बजट का उपयोग करता है",
        "aiAgentDescription": "स्वायत्त AI एजेंट (Claude) क्या जांचना और ठीक करना है इस पर बुद्धिमान निर्णय लेता है। अधिक व्यापक लेकिन API बजट का उपयोग करता है।",
        "triggerDaily": "दैनिक ऑडिट चलाएं",
        "triggerAI": "AI एजेंट ऑडिट चलाएं",
        "auditRunningNotice": "वर्तमान में एक ऑडिट चल रहा है। पूर्ण होने पर बटन सक्षम होंगे।",
        "budgetLabel": "AI एजेंट बजट सीमा: ${{budget}}",
        "budgetPerAudit": "प्रति ऑडिट बजट",
        "monthlyBudgetUsed": "बजट उपयोग (30 दिन)",
        "monthlyBudgetLimit": "/ ${{limit}} मासिक",
        "budgetWarning": "इस ऑडिट को चलाने से मासिक बजट सीमा पार हो जाएगी",
        "aiAuditSuccess": "AI एजेंट ऑडिट सफलतापूर्वक ट्रिगर किया गया। {{dryRun}}",
        "dailyAuditSuccess": "दैनिक ऑडिट सफलतापूर्वक ट्रिगर किया गया। {{dryRun}}",
        "dryRunMode": "(ड्राई रन मोड)",
        "rollbackSuccess": "क्रिया सफलतापूर्वक रोलबैक की गई।"
      },
      "voice": {
        "title": "वॉइस कंट्रोल",
        "description": "लाइब्रेरियन को आदेश देने के लिए अपनी आवाज़ का उपयोग करें। बस बटन दबाएं और स्वाभाविक रूप से बोलें।",
        "pressToSpeak": "बोलने के लिए दबाएं",
        "listening": "सुन रहे हैं...",
        "transcript": "ट्रांसक्रिप्ट",
        "processing": "आपकी कमांड प्रोसेस हो रही है...",
        "speaking": "लाइब्रेरियन जवाब दे रहा है...",
        "examples": "उदाहरण आदेश",
        "example1": "पिछले 24 घंटों में गायब पोस्टर जांचें",
        "example2": "CYB शीर्षकों के लिए मेटाडेटा ठीक करें",
        "example3": "टूटे स्ट्रीमिंग URLs के लिए स्कैन करें",
        "example4": "मूवीज़ से उपशीर्षक निकालें",
        "notSupported": "आपके ब्राउज़र में वॉइस रिकग्निशन समर्थित नहीं है। कृपया Chrome, Edge, या Safari का उपयोग करें।",
        "notAvailable": "वॉइस कंट्रोल उपलब्ध नहीं है",
        "noSpeech": "कोई आवाज़ नहीं मिली। कृपया पुनः प्रयास करें।",
        "noMicrophone": "कोई माइक्रोफोन नहीं मिला। कृपया अपना डिवाइस जांचें।",
        "microphoneBlocked": "माइक्रोफोन एक्सेस ब्लॉक की गई। कृपया अपने ब्राउज़र सेटिंग्स में इसे सक्षम करें।",
        "error": "वॉइस रिकग्निशन त्रुटि: {{error}}",
        "startFailed": "वॉइस रिकग्निशन शुरू करने में विफल। कृपया पुनः प्रयास करें।",
        "commandFailed": "आदेश निष्पादित करने में विफल। कृपया पुनः प्रयास करें।"
      },
      "schedules": {
        "title": "अनुसूचित ऑडिट",
        "subtitle": "दैनिक और साप्ताहिक ऑडिट शेड्यूल कॉन्फ़िगर करें",
        "dailyTitle": "दैनिक ऑडिट",
        "weeklyTitle": "साप्ताहिक AI ऑडिट",
        "schedule": "शेड्यूल",
        "time": "समय",
        "mode": "मोड",
        "cost": "अनु. लागत",
        "status": "स्थिति",
        "description": "विवरण",
        "viewInConsole": "Cloud Console में देखें",
        "modifyNote": "शेड्यूल संशोधित करने के लिए, Google Cloud Console का उपयोग करें",
        "editTitle": "शेड्यूल संपादित करें",
        "editNotAvailable": "शेड्यूल संपादन उपलब्ध नहीं",
        "editNotAvailableMessage": "शेड्यूल संशोधनों के लिए Cloud Scheduler API एकीकरण आवश्यक है। कृपया सीधे Google Cloud Console में शेड्यूल संशोधित करने के लिए 'Cloud Console में देखें' बटन का उपयोग करें।",
        "cronExpression": "Cron एक्सप्रेशन",
        "cronHint": "फॉर्मेट: मिनट घंटा दिन महीना सप्ताह का दिन (जैसे, 0 2 * * * = रोज़ाना सुबह 2:00 बजे)",
        "patterns": {
          "daily": "रोज़ाना {{hour}}:{{minute}} पर",
          "weekly": "हर {{day}} को {{hour}}:{{minute}} पर"
        },
        "days": {
          "sunday": "रविवार",
          "monday": "सोमवार",
          "tuesday": "मंगलवार",
          "wednesday": "बुधवार",
          "thursday": "गुरुवार",
          "friday": "शुक्रवार",
          "saturday": "शनिवार"
        }
      },
      "reports": {
        "title": "हाल की ऑडिट रिपोर्ट",
        "emptyMessage": "अभी तक कोई ऑडिट रिपोर्ट नहीं",
        "totalReports": "{{count}} रिपोर्ट",
        "clearAll": "सभी साफ़ करें",
        "confirmClearAll": "क्या आप सुनिश्चित हैं कि आप सभी ऑडिट रिपोर्ट साफ़ करना चाहते हैं? यह क्रिया पूर्ववत नहीं की जा सकती।",
        "clearedSuccessfully": "सभी ऑडिट रिपोर्ट सफलतापूर्वक साफ़ की गईं",
        "viewLogs": "लॉग देखें",
        "viewDetails": "विवरण देखें",
        "columns": {
          "date": "तारीख",
          "type": "प्रकार",
          "duration": "अवधि",
          "status": "स्थिति",
          "issues": "समस्याएं",
          "fixes": "सुधार",
          "actions": "कार्रवाइयां"
        },
        "detailModal": {
          "title": "ऑडिट रिपोर्ट: {{id}}",
          "summary": "सारांश",
          "status": "स्थिति",
          "executionTime": "निष्पादन समय",
          "totalItems": "कुल आइटम",
          "healthyItems": "स्वस्थ आइटम",
          "issuesFound": "समस्याएं मिलीं",
          "totalIssues": "कुल समस्याएं मिलीं",
          "seeInsightsBelow": "विवरण के लिए नीचे AI इनसाइट्स देखें",
          "brokenStreams": "टूटी स्ट्रीम",
          "missingMetadata": "गायब मेटाडेटा",
          "misclassifications": "गलत वर्गीकरण",
          "orphanedItems": "अनाथ आइटम",
          "fixesApplied": "सुधार लागू किए गए",
          "totalFixes": "{{count}} कुल सुधार",
          "aiInsights": "AI इनसाइट्स"
        }
      },
      "logs": {
        "title": "निष्पादन लॉग",
        "liveAuditLog": "लाइव ऑडिट लॉग",
        "executionLog": "ऑडिट निष्पादन लॉग",
        "searchPlaceholder": "लॉग खोजें...",
        "noLogs": "प्रदर्शित करने के लिए कोई लॉग नहीं",
        "noActiveAudit": "कोई सक्रिय ऑडिट नहीं",
        "triggerAuditToSee": "यहां लाइव निष्पादन लॉग देखने के लिए एक ऑडिट ट्रिगर करें",
        "auditType": "ऑडिट प्रकार",
        "started": "शुरू हुआ",
        "completed": "पूर्ण",
        "lastLog": "अंतिम लॉग",
        "staleWarning": "{{seconds}}s के लिए कोई नया लॉग नहीं - जॉब प्रोसेसिंग में या अटका हो सकता है",
        "pollingStatus": "पोलिंग सक्रिय • अंतिम जांच",
        "connecting": "लाइव ऑडिट लॉग से कनेक्ट हो रहा है...",
        "aiInsightPrefix": "AI इनसाइट",
        "source": {
          "librarian": "लाइब्रेरियन",
          "aiAgent": "AI एजेंट"
        },
        "levels": {
          "debug": "डीबग",
          "info": "जानकारी",
          "warn": "चेतावनी",
          "error": "त्रुटि",
          "success": "सफलता",
          "trace": "ट्रेस"
        },
        "auditStarted": "ऑडिट शुरू हुआ",
        "brokenStreamsFound": "{{count}} टूटी स्ट्रीम मिली",
        "missingMetadataFound": "{{count}} आइटम में गायब मेटाडेटा मिला",
        "misclassificationsFound": "{{count}} गलत वर्गीकृत आइटम मिले",
        "orphanedItemsFound": "{{count}} अनाथ आइटम मिले",
        "fixesApplied": "{{count}} सुधार लागू किए गए",
        "auditCompleted": "ऑडिट {{status}} {{duration}}s में",
        "auditInitializing": "🚀 {{auditType}} ऑडिट इनिशियलाइज़ हो रहा है...",
        "dryRunMode": "⚠️ DRY RUN मोड में चल रहा है - कोई बदलाव नहीं किए जाएंगे",
        "liveMode": "✅ LIVE मोड में चल रहा है - बदलाव लागू किए जाएंगे",
        "budgetSet": "💰 बजट सीमा: ${{budget}}",
        "connectingToAgent": "🔗 Claude AI एजेंट से कनेक्ट हो रहा है..."
      },
      "audit": {
        "types": {
          "aiAgent": "AI एजेंट",
          "dailyIncremental": "दैनिक इंक्रीमेंटल"
        },
        "pause": "रोकें",
        "resume": "फिर से शुरू करें",
        "cancel": "रद्द करें",
        "interject": "इंटरजेक्ट",
        "interjectTitle": "AI एजेंट को संदेश भेजें",
        "interjectHint": "यह संदेश अगले इटरेशन में AI एजेंट वार्तालाप में इंजेक्ट किया जाएगा। इसका उपयोग अतिरिक्त संदर्भ प्रदान करने, फोकस पुनर्निर्देशित करने, या विशिष्ट निर्देश देने के लिए करें।",
        "interjectPlaceholder": "जैसे, केवल मूवीज़ पर ध्यान दें, अभी सीरीज़ छोड़ें...",
        "sendInterject": "भेजें",
        "interjectSuccess": "AI एजेंट को संदेश सफलतापूर्वक भेजा गया",
        "pauseSuccess": "ऑडिट सफलतापूर्वक रोका गया",
        "resumeSuccess": "ऑडिट सफलतापूर्वक फिर से शुरू हुआ",
        "cancelSuccess": "ऑडिट सफलतापूर्वक रद्द किया गया"
      },
      "progress": {
        "batch": "बैच {{current}} / {{total}}",
        "items": "{{processed}} / {{total}} आइटम",
        "finishing": "समाप्त हो रहा है...",
        "finalizing": "रिपोर्ट जनरेट और सुधार लागू हो रहे हैं"
      },
      "activityLog": {
        "title": "गतिविधि लॉग",
        "subtitle": "{{count}} क्रियाएं रिकॉर्ड की गईं",
        "filterByType": "प्रकार से फ़िल्टर करें",
        "allActions": "सभी क्रियाएं",
        "content": "सामग्री",
        "noDescription": "कोई विवरण उपलब्ध नहीं",
        "updatedFields": "{{fields}} अपडेट किए गए",
        "pagination": "पृष्ठ {{page}} / {{totalPages}}",
        "issueType": "समस्या प्रकार",
        "confidence": "आत्मविश्वास",
        "autoApproved": "स्वतः स्वीकृत",
        "changes": "बदलाव",
        "actionTypes": {
          "addPoster": "पोस्टर जोड़ें",
          "updateMetadata": "मेटाडेटा अपडेट करें",
          "recategorize": "पुनः वर्गीकृत करें",
          "fixUrl": "URL ठीक करें",
          "cleanTitle": "शीर्षक साफ़ करें",
          "classify": "वर्गीकृत करें"
        },
        "rollback": "रोलबैक",
        "rolledBack": "रोलबैक किया गया",
        "confirmRollback": {
          "title": "रोलबैक की पुष्टि करें",
          "message": "क्या आप सुनिश्चित हैं कि आप इस क्रिया को रोलबैक करना चाहते हैं? यह पिछली स्थिति को पुनर्स्थापित करेगा।"
        },
        "emptyMessage": "कोई क्रियाएं नहीं मिलीं"
      },
      "modal": {
        "confirmAI": {
          "title": "AI एजेंट ऑडिट ट्रिगर करें?",
          "message": "यह ${{budget}} की बजट सीमा के साथ एक स्वायत्त AI एजेंट ऑडिट ट्रिगर करेगा। एजेंट क्या जांचना और ठीक करना है इस पर निर्णय लेगा। {{dryRun}}",
          "dryRunNote": "DRY RUN मोड में चल रहा है (कोई बदलाव नहीं किए जाएंगे)।"
        },
        "cancel": "रद्द करें",
        "confirm": "पुष्टि करें",
        "close": "बंद करें",
        "retry": "पुनः प्रयास करें"
      },
      "status": {
        "enabled": "सक्षम",
        "disabled": "अक्षम",
        "completed": "ऑडिट पूर्ण",
        "failed": "ऑडिट विफल",
        "in_progress": "प्रगति में",
        "partial": "आंशिक रूप से पूर्ण",
        "pending": "लंबित",
        "running": "चल रहा है"
      },
      "auditTypes": {
        "daily_incremental": "दैनिक इंक्रीमेंटल",
        "ai_agent": "AI एजेंट"
      }
    },
    "widgets": {
      "title": "विजेट",
      "subtitle": "लाइव स्ट्रीम और एम्बेड के लिए फ्लोटिंग ओवरले विजेट प्रबंधित करें",
      "newWidget": "नया विजेट",
      "editWidget": "विजेट संपादित करें",
      "columns": {
        "title": "शीर्षक",
        "contentType": "सामग्री प्रकार",
        "targetRoles": "लक्ष्य भूमिकाएं",
        "targetPages": "लक्ष्य पृष्ठ",
        "status": "स्थिति",
        "order": "क्रम"
      },
      "contentTypes": {
        "liveChannel": "लाइव चैनल",
        "live": "लाइव",
        "vod": "वीडियो ऑन डिमांड",
        "podcast": "पॉडकास्ट",
        "radio": "रेडियो",
        "iframe": "Iframe"
      },
      "status": {
        "active": "सक्रिय",
        "inactive": "निष्क्रिय"
      },
      "form": {
        "title": "विजेट शीर्षक",
        "description": "विवरण (वैकल्पिक)",
        "icon": "आइकन इमोजी (वैकल्पिक)",
        "contentType": "सामग्री प्रकार",
        "selectChannel": "लाइव चैनल चुनें",
        "channelPlaceholder": "-- चैनल चुनें --",
        "iframeUrl": "Iframe URL",
        "iframeTitle": "Iframe शीर्षक (एक्सेसिबिलिटी के लिए)",
        "position": "डिफ़ॉल्ट स्थिति",
        "behavior": "व्यवहार",
        "mutedByDefault": "डिफ़ॉल्ट रूप से म्यूट",
        "closable": "बंद करने योग्य",
        "draggable": "खींचने योग्य",
        "targetPages": "लक्ष्य पृष्ठ (अल्पविराम से अलग, खाली = सभी)",
        "targetPagesPlaceholder": "/, /live, /vod",
        "order": "क्रम"
      },
      "actions": {
        "save": "सहेजें",
        "cancel": "रद्द करें"
      },
      "confirmDelete": "क्या आप सुनिश्चित हैं कि आप इस विजेट को हटाना चाहते हैं?",
      "emptyMessage": "कोई विजेट नहीं मिला। शुरू करने के लिए एक बनाएं।",
      "allPages": "सभी पृष्ठ",
      "allRoles": "सभी",
      "errors": {
        "titleRequired": "शीर्षक आवश्यक है",
        "selectChannel": "कृपया एक लाइव चैनल चुनें",
        "iframeUrlRequired": "Iframe URL आवश्यक है"
      }
    },
    "billing": {
      "subtitle": "राजस्व और भुगतान ट्रैक करें",
      "revenue": "राजस्व",
      "today": "आज",
      "thisWeek": "इस सप्ताह",
      "thisMonth": "इस महीने",
      "thisYear": "इस वर्ष",
      "metrics": "प्रमुख मेट्रिक्स",
      "totalTransactions": "कुल लेनदेन",
      "avgTransaction": "औसत लेनदेन",
      "pendingRefunds": "लंबित रिफंड",
      "refundRate": "रिफंड दर",
      "retention": "रिटेंशन",
      "retentionRate": "रिटेंशन दर",
      "churnRate": "चर्न दर",
      "atRiskUsers": "जोखिम में उपयोगकर्ता",
      "churnedUsers": "चर्न हुए उपयोगकर्ता",
      "quickLinks": "त्वरित लिंक"
    },
    "marketing": {
      "recentCampaigns": "हाल के अभियान",
      "audienceSegments": "ऑडियंस सेगमेंट",
      "emailMetrics": "ईमेल मेट्रिक्स",
      "pushMetrics": "पुश मेट्रिक्स",
      "quickActions": "त्वरित कार्रवाइयां"
    },
    "push": {
      "titlePlaceholder": "नोटिफिकेशन शीर्षक",
      "bodyPlaceholder": "नोटिफिकेशन संदेश"
    },
    "auditLogs": {
      "subtitle": "सभी सिस्टम क्रियाओं को ट्रैक करें",
      "filter": "फ़िल्टर",
      "export": "निर्यात",
      "all": "सभी",
      "advancedFiltering": "उन्नत फ़िल्टरिंग",
      "actionType": "क्रिया प्रकार",
      "clear": "साफ़ करें",
      "apply": "लागू करें",
      "noRecords": "कोई रिकॉर्ड नहीं मिला",
      "columns": {
        "action": "क्रिया",
        "user": "उपयोगकर्ता",
        "resource": "संसाधन",
        "details": "विवरण",
        "date": "तारीख",
        "ip": "IP"
      },
      "changed": "बदला गया",
      "actionFilters": {
        "user": "उपयोगकर्ता",
        "subscription": "सब्सक्रिप्शन",
        "payment": "भुगतान",
        "settings": "सेटिंग्स",
        "campaign": "अभियान",
        "content": "सामग्री"
      }
    },
    "settings": {
      "subtitle": "सिस्टम पैरामीटर कॉन्फ़िगर करें",
      "saveChanges": "बदलाव सहेजें",
      "generalSettings": "सामान्य सेटिंग्स",
      "supportEmail": "सहायता ईमेल",
      "defaultPlan": "डिफ़ॉल्ट योजना",
      "termsUrl": "सेवा की शर्तें URL",
      "privacyUrl": "गोपनीयता नीति URL",
      "userSettings": "उपयोगकर्ता सेटिंग्स",
      "maxDevices": "प्रति खाता अधिकतम डिवाइस",
      "trialDays": "ट्रायल अवधि दिन",
      "maintenanceMode": "रखरखाव मोड",
      "maintenanceModeDesc": "सक्षम होने पर, सिस्टम उपयोगकर्ताओं के लिए अनुपलब्ध होगा",
      "featureFlags": "फ़ीचर फ्लैग",
      "systemActions": "सिस्टम क्रियाएं",
      "clearCache": "कैश साफ़ करें",
      "resetAnalytics": "एनालिटिक्स रीसेट करें",
      "actionsWarning": "ये क्रियाएं सिस्टम प्रदर्शन को प्रभावित कर सकती हैं। सावधानी से उपयोग करें।",
      "savingSuccess": "सेटिंग्स सफलतापूर्वक सहेजी गईं",
      "confirmClearCache": "कैश साफ़ करें? यह अस्थायी रूप से प्रदर्शन को प्रभावित कर सकता है।",
      "cacheCleared": "कैश सफलतापूर्वक साफ़ की गई",
      "confirmResetAnalytics": "एनालिटिक्स डेटा रीसेट करें? यह क्रिया पूर्ववत नहीं की जा सकती!",
      "analyticsReset": "एनालिटिक्स डेटा रीसेट किया गया",
      "featureFlagLabels": {
        "new_player": "नया प्लेयर",
        "live_chat": "लाइव चैट",
        "downloads": "डाउनलोड",
        "watch_party": "वॉच पार्टी",
        "voice_search": "वॉइस सर्च",
        "ai_recommendations": "AI अनुशंसाएं"
      }
    },
    "content": {
      "title": "सामग्री लाइब्रेरी",
      "subtitle": "मूवीज़, सीरीज़ और वीडियो सामग्री प्रबंधित करें",
      "importFree": "मुफ्त सामग्री आयात करें",
      "searchPlaceholder": "सामग्री खोजें...",
      "emptyMessage": "कोई सामग्री नहीं मिली",
      "confirmDelete": "यह सामग्री हटाएं?",
      "confirmBatchDelete": "क्या आप सुनिश्चित हैं कि आप {{count}} आइटम हटाना चाहते हैं?",
      "selectedItems": "{{count}} आइटम चयनित",
      "batchFeature": "फ़ीचर करें",
      "batchUnfeature": "अनफ़ीचर करें",
      "import": {
        "pageTitle": "मुफ्त सामग्री आयात करें",
        "subtitle": "मुफ्त स्रोतों से सार्वजनिक सामग्री ब्राउज़ और आयात करें",
        "selectCategory": "आयातित मूवीज़ के लिए श्रेणी चुनें:",
        "categoryPlaceholder": "एक श्रेणी चुनें...",
        "loading": "स्रोत लोड हो रहे हैं...",
        "sourceTypes": {
          "vod": "मूवीज़ और VOD",
          "live_tv": "लाइव TV",
          "radio": "रेडियो",
          "podcasts": "पॉडकास्ट"
        },
        "items": "आइटम",
        "itemsPlural": "आइटम",
        "selectItems": "कृपया आयात करने के लिए कम से कम एक आइटम चुनें",
        "selectCategory_vod": "कृपया VOD आयात के लिए एक श्रेणी चुनें",
        "importing": "{{count}} आयात हो रहा है... {{percent}}%",
        "importButton": "{{count}} {{item}} आयात करें",
        "noSources": "कोई स्रोत उपलब्ध नहीं",
        "noSourcesDescription": "{{type}} के लिए वर्तमान में कोई मुफ्त सामग्री स्रोत उपलब्ध नहीं है"
      },
      "filters": {
        "title": "फ़िल्टर",
        "contentType": "सामग्री प्रकार",
        "all": "सभी",
        "allContent": "सभी",
        "series": "सीरीज़",
        "movies": "मूवीज़",
        "podcasts": "पॉडकास्ट",
        "radioStations": "रेडियो स्टेशन",
        "status": "स्थिति",
        "allStatus": "सभी स्थिति",
        "subtitles": "उपशीर्षक"
      },
      "podcastsComingSoon": "पॉडकास्ट प्रबंधन जल्द आ रहा है। पॉडकास्ट अनुभाग का उपयोग करें।",
      "radioComingSoon": "रेडियो स्टेशन प्रबंधन जल्द आ रहा है। रेडियो स्टेशन अनुभाग का उपयोग करें।",
      "showOnlyWithSubtitles": "केवल उपशीर्षक वाले दिखाएं",
      "status": {
        "published": "प्रकाशित",
        "draft": "ड्राफ्ट"
      },
      "columns": {
        "title": "शीर्षक",
        "category": "श्रेणी",
        "year": "वर्ष",
        "status": "स्थिति",
        "views": "देखे गए",
        "rating": "रेटिंग",
        "streamUrl": "स्ट्रीम URL",
        "epgSource": "EPG स्रोत",
        "genre": "शैली",
        "episodeNumber": "एपिसोड #",
        "description": "विवरण",
        "duration": "अवधि",
        "publishedDate": "प्रकाशित",
        "episodes": "एपिसोड",
        "order": "क्रम",
        "name": "नाम",
        "slug": "स्लग",
        "subtitles": "उपशीर्षक"
      },
      "validation": {
        "titleRequired": "शीर्षक आवश्यक है",
        "nameRequired": "नाम आवश्यक है",
        "streamUrlRequired": "स्ट्रीम URL आवश्यक है",
        "audioUrlRequired": "ऑडियो URL आवश्यक है"
      },
      "episodes_one": "एपिसोड",
      "episodes_other": "एपिसोड",
      "noEpisodes": "कोई एपिसोड नहीं मिला",
      "type": {
        "series": "सीरीज़",
        "movie": "मूवी"
      },
      "toggleCarousel": "कैरोसेल टॉगल करें",
      "editor": {
        "pageTitle": "सामग्री संपादित करें",
        "pageTitleNew": "सामग्री जोड़ें",
        "sections": {
          "basicInfo": "मूल जानकारी",
          "media": "मीडिया",
          "streaming": "स्ट्रीमिंग",
          "details": "सामग्री विवरण",
          "publishing": "प्रकाशन",
          "accessControl": "एक्सेस कंट्रोल",
          "podcastDetails": "पॉडकास्ट विवरण",
          "episodeDetails": "एपिसोड विवरण",
          "stationDetails": "स्टेशन विवरण",
          "channelDetails": "चैनल विवरण"
        },
        "fields": {
          "title": "शीर्षक",
          "titlePlaceholder": "सामग्री शीर्षक",
          "titleRequired": "शीर्षक आवश्यक है",
          "year": "वर्ष",
          "yearPlaceholder": "2024",
          "description": "विवरण",
          "descriptionPlaceholder": "सामग्री विवरण",
          "thumbnail": "थंबनेल (3:4 पक्षानुपात)",
          "thumbnailUrl": "थंबनेल URL",
          "thumbnailUrlPlaceholder": "https://example.com/thumbnail.jpg",
          "backdrop": "बैकड्रॉप (16:9 पक्षानुपात)",
          "backdropUrl": "बैकड्रॉप URL",
          "posterCover": "पॉडकास्ट कवर",
          "logo": "लोगो",
          "channelLogo": "चैनल लोगो",
          "stationLogo": "स्टेशन लोगो",
          "streamUrl": "स्ट्रीम URL",
          "streamUrlRequired": "स्ट्रीम URL आवश्यक है",
          "streamType": "स्ट्रीम प्रकार",
          "drmProtected": "DRM संरक्षित",
          "drmProtectedLabel": "इस सामग्री को DRM सुरक्षा की आवश्यकता है",
          "category": "श्रेणी",
          "categoryRequired": "श्रेणी आवश्यक है",
          "duration": "अवधि",
          "durationPlaceholder": "1:30:00",
          "rating": "रेटिंग",
          "ratingPlaceholder": "PG-13",
          "genre": "शैली",
          "genrePlaceholder": "ड्रामा",
          "director": "निर्देशक",
          "directorPlaceholder": "निर्देशक नाम",
          "isSeries": "सीरीज़",
          "isSeriesLabel": "यह एक सीरीज़/बहु-भाग सामग्री है",
          "season": "सीज़न",
          "episode": "एपिसोड",
          "seriesId": "सीरीज़ ID",
          "seriesIdPlaceholder": "series-identifier",
          "isPublished": "प्रकाशित करें",
          "isPublishedLabel": "इस सामग्री को तुरंत प्रकाशित करें",
          "isFeatured": "फ़ीचर करें",
          "isFeaturedLabel": "इस सामग्री को होमपेज पर फ़ीचर करें",
          "requiresSubscription": "आवश्यक सब्सक्रिप्शन",
          "isKidsContent": "बच्चों की सामग्री",
          "isKidsContentLabel": "यह बच्चों के अनुकूल सामग्री है",
          "author": "लेखक",
          "authorPlaceholder": "पॉडकास्ट लेखक",
          "podcastCategory": "श्रेणी",
          "podcastCategoryPlaceholder": "समाचार, विज्ञान, आदि।",
          "rssFeed": "RSS फ़ीड URL",
          "rssFeedPlaceholder": "https://example.com/feed.xml",
          "website": "वेबसाइट URL",
          "websitePlaceholder": "https://example.com",
          "episodeNumber": "एपिसोड #",
          "seasonNumber": "सीज़न #",
          "audioUrl": "ऑडियो URL",
          "audioUrlRequired": "ऑडियो URL आवश्यक है",
          "audioUrlPlaceholder": "https://example.com/episode.mp3",
          "publishedAt": "प्रकाशन तिथि",
          "epgSource": "EPG स्रोत URL",
          "epgSourcePlaceholder": "https://example.com/epg.xml",
          "currentShow": "वर्तमान शो",
          "currentShowPlaceholder": "शो का नाम",
          "nextShow": "अगला शो",
          "nextShowPlaceholder": "शो का नाम",
          "currentSong": "वर्तमान गाना",
          "currentSongPlaceholder": "गाने का शीर्षक",
          "isActive": "सक्रिय",
          "isActiveLabel": "चैनल सक्रिय है",
          "requiredSubscription": "आवश्यक सब्सक्रिप्शन",
          "publishedDate": "प्रकाशन तिथि"
        },
        "subscriptionTiers": {
          "basic": "बेसिक",
          "premium": "प्रीमियम",
          "family": "फैमिली"
        },
        "actions": {
          "save": "सहेजें",
          "saving": "सहेज रहे हैं...",
          "cancel": "रद्द करें"
        },
        "imageUpload": {
          "dropHere": "यहां छवि छोड़ें या अपलोड करने के लिए क्लिक करें",
          "formats": "PNG, JPG, WebP {{maxSize}}MB तक",
          "uploading": "अपलोड हो रहा है...",
          "success": "छवि सफलतापूर्वक अपलोड की गई",
          "orPasteUrl": "या छवि URL पेस्ट करें",
          "urlPlaceholder": "https://example.com/image.jpg",
          "validateButton": "जोड़ें",
          "validating": "सत्यापित हो रहा है...",
          "clear": "छवि हटाएं",
          "errors": {
            "imageOnly": "कृपया एक छवि फ़ाइल चुनें",
            "tooLarge": "फ़ाइल का आकार {{maxSize}}MB से कम होना चाहिए",
            "uploadFailed": "अपलोड विफल",
            "invalidUrl": "अमान्य URL"
          }
        }
      },
      "categoryPicker": {
        "selectPlaceholder": "श्रेणी चुनें...",
        "searchPlaceholder": "श्रेणियां खोजें...",
        "loading": "श्रेणियां लोड हो रही हैं...",
        "noResults": "कोई श्रेणी नहीं मिली",
        "noCategories": "कोई श्रेणी उपलब्ध नहीं",
        "createNew": "नई श्रेणी बनाएं",
        "errors": {
          "loadFailed": "श्रेणियां लोड करने में विफल",
          "createFailed": "श्रेणी बनाने में विफल"
        },
        "modal": {
          "title": "नई श्रेणी बनाएं",
          "placeholder": "श्रेणी नाम (जैसे, मूवीज़, सीरीज़)",
          "creating": "बन रही है...",
          "create": "बनाएं"
        }
      },
      "streamUrlInput": {
        "copyUrl": "URL कॉपी करें",
        "copied": "URL क्लिपबोर्ड में कॉपी किया गया",
        "streamType": "स्ट्रीम प्रकार",
        "validUrl": "URL वैध है - {{type}} के रूप में पहचाना गया",
        "errors": {
          "required": "स्ट्रीम URL आवश्यक है",
          "invalidFormat": "अमान्य URL प्रारूप"
        },
        "supportedFormats": {
          "title": "समर्थित प्रारूप:",
          "hls": "HLS: .m3u8 स्ट्रीम",
          "dash": "DASH: .mpd स्ट्रीम",
          "audio": "ऑडियो: .mp3, .aac, या ऑडियो स्ट्रीम"
        }
      }
    },
    "categories": {
      "subtitle": "सामग्री श्रेणियां प्रबंधित करें",
      "emptyMessage": "कोई श्रेणी नहीं मिली",
      "status": {
        "active": "सक्रिय",
        "inactive": "निष्क्रिय"
      },
      "form": {
        "nameHebrew": "श्रेणी नाम (हिब्रू)",
        "nameEnglish": "श्रेणी नाम (अंग्रेजी)",
        "slug": "स्लग"
      }
    },
    "liveChannels": {
      "subtitle": "लाइव TV चैनल प्रबंधित करें",
      "emptyMessage": "कोई लाइव चैनल नहीं मिला",
      "subtitleSettings": "लाइव उपशीर्षक सेटिंग्स",
      "form": {
        "name": "चैनल नाम",
        "streamUrl": "स्ट्रीम URL",
        "epgSource": "EPG स्रोत URL (वैकल्पिक)",
        "currentShow": "वर्तमान शो",
        "order": "क्रम",
        "supportsSubtitles": "लाइव उपशीर्षक सक्षम करें",
        "primaryLanguage": "प्राथमिक भाषा (स्रोत)",
        "targetLanguages": "उपलब्ध अनुवाद भाषाएं",
        "targetLanguagesHelp": "चुनें कि उपयोगकर्ता किन भाषाओं में रियल-टाइम अनुवाद कर सकते हैं"
      }
    },
    "radioStations": {
      "subtitle": "रेडियो स्टेशन प्रबंधित करें",
      "emptyMessage": "कोई रेडियो स्टेशन नहीं मिला",
      "form": {
        "name": "स्टेशन नाम",
        "genre": "शैली",
        "streamUrl": "स्ट्रीम URL",
        "currentShow": "वर्तमान शो (वैकल्पिक)",
        "currentSong": "वर्तमान गाना (वैकल्पिक)",
        "order": "क्रम"
      }
    },
    "podcasts": {
      "subtitle": "पॉडकास्ट और एपिसोड प्रबंधित करें",
      "episodesSubtitle": "एपिसोड प्रबंधित करें",
      "emptyMessage": "कोई पॉडकास्ट नहीं मिला",
      "noEpisodes": "कोई एपिसोड नहीं मिला",
      "form": {
        "title": "पॉडकास्ट शीर्षक",
        "author": "लेखक",
        "description": "विवरण",
        "category": "श्रेणी",
        "rssFeed": "RSS फ़ीड URL",
        "website": "वेबसाइट URL (वैकल्पिक)"
      },
      "episodes": {
        "form": {
          "title": "एपिसोड शीर्षक",
          "description": "विवरण",
          "episodeNumber": "एपिसोड नंबर",
          "seasonNumber": "सीज़न नंबर (वैकल्पिक)",
          "duration": "अवधि",
          "audioUrl": "ऑडियो URL (आवश्यक)",
          "publishedDate": "प्रकाशन तिथि (YYYY-MM-DD)"
        }
      }
    },
    "users": {
      "subtitle": "उपयोगकर्ता और खाते प्रबंधित करें",
      "addUser": "उपयोगकर्ता जोड़ें",
      "status": {
        "active": "सक्रिय",
        "inactive": "निष्क्रिय",
        "blocked": "ब्लॉक"
      },
      "filters": {
        "all": "सभी",
        "active": "सक्रिय",
        "inactive": "निष्क्रिय",
        "blocked": "ब्लॉक"
      },
      "columns": {
        "name": "नाम",
        "role": "भूमिका",
        "subscription": "सब्सक्रिप्शन",
        "noSubscription": "कोई सब्सक्रिप्शन नहीं",
        "status": "स्थिति",
        "created": "बनाया गया",
        "actions": "कार्रवाइयां"
      },
      "confirmDelete": "उपयोगकर्ता हटाएं",
      "confirmDeleteMessage": "क्या आप सुनिश्चित हैं कि आप {{name}} को हटाना चाहते हैं? यह क्रिया पूर्ववत नहीं की जा सकती।",
      "resetPassword": "पासवर्ड रीसेट करें",
      "block": "ब्लॉक करें",
      "unban": "अनब्लॉक करें",
      "confirmResetPassword": "{{email}} को पासवर्ड रीसेट ईमेल भेजें?",
      "resetPasswordSent": "पासवर्ड रीसेट ईमेल भेजा गया",
      "recentActivity": "हाल की गतिविधि",
      "noActivity": "कोई गतिविधि नहीं",
      "notFound": "उपयोगकर्ता नहीं मिला",
      "backToList": "सूची पर वापस जाएं",
      "banReason": "प्रतिबंध का कारण",
      "banReasonPrompt": "प्रतिबंध का कारण:",
      "confirmUnban": "उपयोगकर्ता को अनब्लॉक करें?",
      "userDetails": "उपयोगकर्ता विवरण",
      "id": "ID",
      "registered": "पंजीकृत",
      "billingHistory": "बिलिंग इतिहास",
      "noPayments": "कोई भुगतान नहीं"
    },
    "campaigns": {
      "subtitle": "कूपन कोड और छूट प्रबंधित करें",
      "expired": "समाप्त",
      "status": {
        "active": "सक्रिय",
        "inactive": "निष्क्रिय"
      },
      "columns": {
        "name": "नाम",
        "discount": "छूट",
        "usage": "उपयोग",
        "validUntil": "तक वैध",
        "status": "स्थिति",
        "actions": "कार्रवाइयां"
      },
      "confirmDelete": "अभियान हटाएं",
      "confirmDeleteMessage": "क्या आप सुनिश्चित हैं कि आप \"{{name}}\" हटाना चाहते हैं? यह क्रिया पूर्ववत नहीं की जा सकती।",
      "searchPlaceholder": "अभियान खोजें...",
      "emptyMessage": "कोई अभियान नहीं मिला",
      "deactivate": "निष्क्रिय करें",
      "activate": "सक्रिय करें",
      "createTitle": "नया अभियान",
      "editTitle": "अभियान संपादित करें",
      "formSubtitle": "कूपन कोड या छूट सेट करें",
      "form": {
        "name": "अभियान नाम",
        "namePlaceholder": "जैसे, समर सेल 2024",
        "code": "कूपन कोड",
        "generate": "जनरेट करें",
        "discountType": "छूट प्रकार",
        "discountValue": "छूट मान",
        "maxUses": "अधिकतम उपयोग",
        "unlimited": "असीमित",
        "validUntil": "तक वैध",
        "active": "अभियान सक्रिय"
      }
    },
    "subscriptions": {
      "subtitle": "सिस्टम सब्सक्राइबर देखें और प्रबंधित करें",
      "status": {
        "active": "सक्रिय",
        "paused": "रुका हुआ",
        "cancelled": "रद्द",
        "expired": "समाप्त"
      },
      "columns": {
        "user": "उपयोगकर्ता",
        "plan": "योजना",
        "price": "मूल्य",
        "nextBilling": "अगली बिलिंग",
        "status": "स्थिति"
      },
      "perMonth": "/महीना",
      "searchPlaceholder": "सब्सक्रिप्शन खोजें...",
      "emptyMessage": "कोई सब्सक्रिप्शन नहीं मिला",
      "actions": {
        "changePlan": "योजना बदलें",
        "pause": "रोकें",
        "resume": "फिर से शुरू करें",
        "cancel": "रद्द करें",
        "delete": "हटाएं"
      },
      "editPlan": {
        "title": "सब्सक्रिप्शन योजना बदलें",
        "user": "उपयोगकर्ता",
        "currentPlan": "वर्तमान योजना",
        "newPlan": "नई योजना चुनें"
      },
      "addSubscription": {
        "title": "सब्सक्रिप्शन जोड़ें",
        "userEmail": "उपयोगकर्ता ईमेल",
        "emailPlaceholder": "उपयोगकर्ता ईमेल दर्ज करें",
        "duration": "अवधि (दिन)",
        "selectPlan": "योजना चुनें"
      },
      "fillAllFields": "कृपया सभी फ़ील्ड भरें",
      "userNotFound": "उपयोगकर्ता नहीं मिला",
      "selectOneToEdit": "संपादित करने के लिए कृपया एक सब्सक्रिप्शन चुनें",
      "selectToDelete": "हटाने के लिए कृपया सब्सक्रिप्शन चुनें",
      "confirmDeleteMultiple": "{{count}} सब्सक्रिप्शन हटाएं?",
      "selected": "चयनित",
      "confirmDelete": "क्या आप सुनिश्चित हैं कि आप {{user}} के लिए सब्सक्रिप्शन हटाना चाहते हैं? यह क्रिया पूर्ववत नहीं की जा सकती।"
    },
    "marketingDashboard": {
      "subtitle": "मार्केटिंग अवलोकन",
      "refresh": "रीफ्रेश",
      "totalSubscribers": "कुल सब्सक्राइबर",
      "emailOpenRate": "ईमेल ओपन रेट",
      "pushClickRate": "पुश क्लिक रेट",
      "activeSegments": "सक्रिय सेगमेंट",
      "campaignStatus": {
        "active": "सक्रिय",
        "completed": "पूर्ण",
        "scheduled": "अनुसूचित",
        "draft": "ड्राफ्ट"
      }
    },
    "transactions": {
      "subtitle": "भुगतान इतिहास देखें",
      "exportCsv": "CSV निर्यात करें",
      "status": {
        "completed": "पूर्ण",
        "pending": "लंबित",
        "failed": "विफल",
        "refunded": "वापस किया गया"
      },
      "columns": {
        "id": "ID",
        "user": "उपयोगकर्ता",
        "amount": "राशि",
        "type": "प्रकार",
        "status": "स्थिति",
        "date": "तारीख"
      },
      "filters": {
        "all": "सभी"
      },
      "searchPlaceholder": "लेनदेन खोजें...",
      "emptyMessage": "कोई लेनदेन नहीं मिला",
      "details": "लेनदेन विवरण",
      "email": "ईमेल"
    },
    "pushNotifications": {
      "subtitle": "उपयोगकर्ताओं को नोटिफिकेशन बनाएं और भेजें",
      "newNotification": "नया नोटिफिकेशन",
      "status": {
        "draft": "ड्राफ्ट",
        "sent": "भेजा गया",
        "scheduled": "अनुसूचित"
      },
      "columns": {
        "title": "शीर्षक",
        "status": "स्थिति",
        "sent": "भेजे गए",
        "opened": "खोले गए",
        "scheduledAt": "अनुसूचित समय",
        "created": "बनाया गया",
        "actions": "कार्रवाइयां"
      },
      "filters": {
        "all": "सभी"
      },
      "searchPlaceholder": "नोटिफिकेशन खोजें...",
      "emptyMessage": "कोई नोटिफिकेशन नहीं मिला",
      "createModal": "नया पुश नोटिफिकेशन",
      "editModal": "नोटिफिकेशन संपादित करें",
      "scheduleModal": "नोटिफिकेशन शेड्यूल करें",
      "titleLabel": "शीर्षक",
      "bodyLabel": "संदेश",
      "dateTimeLabel": "तारीख और समय",
      "cancel": "रद्द करें",
      "create": "नोटिफिकेशन बनाएं",
      "schedule": "शेड्यूल करें",
      "send": "अभी भेजें",
      "confirmSend": "नोटिफिकेशन \"{{title}}\" भेजें?",
      "confirmDelete": "नोटिफिकेशन \"{{title}}\" हटाएं?",
      "fillRequired": "कृपया शीर्षक और संदेश भरें"
    }
  },
  "placeholder": {
    "email": "[hi] your@email.com",
    "password": "[hi] ••••••••",
    "pin": "[hi] ••••",
    "dateRange": {
      "from": "[hi] From (YYYY-MM-DD)",
      "to": "[hi] To (YYYY-MM-DD)"
    },
    "amount": {
      "min": "[hi] Min",
      "max": "[hi] Max",
      "price": "[hi] 0.00"
    },
    "chatMessage": "[hi] Type here...",
    "deepLink": "[hi] bayitplus://content/123",
    "scheduleDateTime": "[hi] YYYY-MM-DDTHH:mm",
    "roomCode": "[hi] ABCD1234",
    "time": {
      "start": "[hi] 08:00",
      "end": "[hi] 10:00"
    },
    "filter": {
      "userId": "[hi] Enter user ID"
    },
    "datetime": "[hi] YYYY-MM-DDTHH:mm",
    "number": "[hi] 0",
    "chat": "[hi] Type your message..."
  },
  "components": {
    "select": {
      "default": "[hi] Select..."
    }
  },
  "plans": {
    "basic": {
      "name": "बेसिक",
      "features": [
        "सभी VOD सामग्री",
        "रेडियो और पॉडकास्ट",
        "1 डिवाइस पर देखें",
        "SD गुणवत्ता"
      ],
      "notIncluded": "[hi] ['Live channels', 'AI Assistant', 'Offline viewing']"
    },
    "premium": {
      "name": "प्रीमियम",
      "features": [
        "सभी VOD सामग्री",
        "लाइव चैनल",
        "रेडियो और पॉडकास्ट",
        "स्मार्ट AI सहायक",
        "2 डिवाइस पर देखें",
        "HD गुणवत्ता"
      ],
      "notIncluded": "[hi] ['Offline viewing', 'Family profiles']"
    },
    "family": {
      "name": "फैमिली",
      "features": [
        "सभी VOD सामग्री",
        "लाइव चैनल",
        "रेडियो और पॉडकास्ट",
        "स्मार्ट AI सहायक",
        "4 डिवाइस पर देखें",
        "4K गुणवत्ता",
        "5 फैमिली प्रोफाइल",
        "ऑफ़लाइन डाउनलोड"
      ],
      "notIncluded": "[hi] []"
    },
    "batchActions": {
      "selectedCount": "[hi] {{count}} selected",
      "selectedCount_one": "[hi] {{count}} selected",
      "selectedCount_other": "[hi] {{count}} selected",
      "clear": "[hi] Clear"
    },
    "costDashboard": {
      "title": "[hi] Cost Dashboard",
      "costBreakdown": "[hi] Cost Breakdown",
      "loadingBreakdown": "[hi] Loading breakdown...",
      "aiCosts": "[hi] AI Costs",
      "infrastructure": "[hi] Infrastructure",
      "thirdParty": "[hi] Third-party",
      "thirdPartyApis": "[hi] Third-party APIs",
      "translation": "[hi] Translation",
      "search": "[hi] Search",
      "percentOfTotal": "[hi] % of total",
      "components": "[hi] Components",
      "topSpenders": {
        "title": "[hi] Top 20 Spenders (Monthly)",
        "loading": "[hi] Loading top spenders...",
        "rank": "[hi] Rank",
        "userId": "[hi] User ID",
        "costRange": "[hi] Cost Range",
        "privacyNote": "[hi] User IDs are hashed and costs are aggregated into ranges for privacy protection."
      },
      "categories": {
        "permanent": "[hi] Permanent",
        "transient": "[hi] Transient",
        "permanentVsTransient": "[hi] Permanent vs Transient",
        "permanentFixed": "[hi] Permanent (Fixed)",
        "transientVariable": "[hi] Transient (Variable)",
        "permanentDesc": "[hi] Infrastructure costs that occur monthly regardless of usage",
        "transientDesc": "[hi] Usage-based costs that fluctuate with platform activity",
        "detailedBreakdown": "[hi] Detailed Breakdown",
        "costItem": "[hi] Cost Item",
        "category": "[hi] Category",
        "amount": "[hi] Amount"
      },
      "timeline": {
        "title": "[hi] Cost Timeline",
        "loading": "[hi] Loading timeline...",
        "amountLabel": "[hi] Amount ($)",
        "revenue": "[hi] Revenue",
        "totalCost": "[hi] Total Cost",
        "netProfit": "[hi] Net Profit",
        "showingData": "[hi] Showing data from {{start}} to {{end}}"
      },
      "plSummary": {
        "netProfitLoss": "[hi] Net Profit/Loss",
        "margin": "[hi] margin",
        "revenue": "[hi] REVENUE",
        "totalCosts": "[hi] TOTAL COSTS"
      }
    }
  },
  "subscribe": {
    "title": "अपना प्लान चुनें",
    "subtitle": "किसी भी प्लान के लिए 7 दिन का मुफ्त ट्रायल। कभी भी रद्द करें।",
    "monthly": "मासिक",
    "yearly": "वार्षिक",
    "save2Months": "2 महीने बचाएं",
    "popular": "सबसे लोकप्रिय",
    "period": "/महीना",
    "perYear": "/वर्ष",
    "select": "प्लान चुनें",
    "selected": "चयनित",
    "processing": "प्रोसेसिंग...",
    "startTrial": "मुफ्त ट्रायल शुरू करें",
    "noCharge": "[hi] Your credit card won't be charged during the trial period"
  },
  "notFound": {
    "title": "पेज नहीं मिला",
    "description": "जो पेज आप खोज रहे हैं वह मौजूद नहीं है।",
    "homeButton": "होम जाएं",
    "searchButton": "खोजें",
    "orTry": "[hi] Or try:",
    "liveChannel": "[hi] Live",
    "vodLabel": "[hi] Movies",
    "podcastsLabel": "[hi] Podcasts"
  },
  "profiles": {
    "addProfile": "[hi] Add Profile",
    "enterPin": "[hi] Enter PIN",
    "selectError": "[hi] Error selecting profile",
    "wrongPin": "[hi] Incorrect PIN",
    "loading": "[hi] Loading profiles...",
    "manage": "[hi] Manage Profiles",
    "whoIsWatching": "[hi] Who's Watching?",
    "manageProfiles": "[hi] Manage Profiles",
    "kids": "बच्चे",
    "addIcon": "+"
  },
  "watch": {
    "notFound": "[hi] Content not found",
    "backToHome": "[hi] Back to Home",
    "episodes": "[hi] Episodes",
    "addToList": "[hi] Add to List",
    "like": "[hi] Like",
    "share": "[hi] Share",
    "cast": "[hi] Cast",
    "episodesList": "[hi] Episodes",
    "schedule": "[hi] Schedule",
    "now": "[hi] Now",
    "related": "[hi] Related Content",
    "deleteEpisode": "[hi] Delete Episode",
    "confirmDeleteEpisode": "[hi] Delete this episode?"
  },
  "live": {
    "title": "[hi] Live TV",
    "next": "[hi] Next:",
    "noChannels": "[hi] No channels available",
    "tryLater": "[hi] Try again later",
    "categories": {
      "all": "[hi] All",
      "news": "[hi] News",
      "entertainment": "[hi] Entertainment",
      "sports": "[hi] Sports",
      "kids": "[hi] Kids",
      "music": "[hi] Music"
    }
  },
  "judaism": {
    "title": "यहूदी धर्म",
    "items": "आइटम",
    "empty": "कोई सामग्री उपलब्ध नहीं",
    "emptyHint": "कोई अन्य श्रेणी आज़माएं",
    "dashboard": "[hi] Your Jewish Dashboard",
    "categories": {
      "news": "[hi] Jewish News",
      "community": "[hi] Community"
    },
    "shabbat": {
      "title": "शब्बत समय",
      "shabbatShalom": "शब्बत शालोम!",
      "shabbatMode": "[hi] Shabbat Mode",
      "endsIn": "[hi] Shabbat ends in",
      "candleLighting": "मोमबत्ती जलाना",
      "havdalah": "हवदला",
      "parashat": "पराशत",
      "friday": "[hi] Friday",
      "saturday": "[hi] Saturday",
      "noData": "[hi] Unable to load Shabbat times"
    },
    "erevShabbat": {
      "title": "[hi] Erev Shabbat",
      "prepareFor": "[hi] Prepare for Shabbat",
      "inTime": "[hi] in {{time}}",
      "featuredContent": "[hi] Shabbat Content",
      "noContent": "[hi] Shabbat content coming soon!",
      "shabbatShalom": "[hi] Shabbat Shalom!",
      "timeUntil": "[hi] Time until Shabbat",
      "shabbatSongs": "[hi] Shabbat Songs",
      "parashaStudy": "[hi] Parasha",
      "shabbatRecipes": "[hi] Recipes",
      "prayers": "[hi] Prayers"
    }
  },
  "children": {
    "title": "बच्चे",
    "items": "आइटम",
    "empty": "कोई सामग्री उपलब्ध नहीं",
    "emptyHint": "कोई अन्य श्रेणी आज़माएं",
    "exitKidsMode": "किड्स मोड से बाहर निकलें",
    "exitDescription": "[hi] Enter parent code to exit",
    "parentCode": "[hi] Parent code",
    "confirm": "[hi] Confirm",
    "wrongCode": "[hi] Incorrect code",
    "noContent": "[hi] No content available",
    "tryAnotherCategory": "[hi] Try selecting another category",
    "categories": {
      "all": "सभी",
      "cartoons": "कार्टून",
      "educational": "शैक्षिक",
      "music": "संगीत",
      "hebrew": "हिब्रू",
      "stories": "कहानियां",
      "jewish": "यहूदी"
    },
    "ageRatings": {
      "3": "[hi] Ages 3+",
      "5": "[hi] Ages 5+",
      "7": "[hi] Ages 7+",
      "10": "[hi] Ages 10+",
      "12": "[hi] Ages 12+"
    },
    "moderation": {
      "pending": "[hi] Pending Review",
      "approved": "[hi] Approved",
      "rejected": "[hi] Rejected"
    },
    "admin": {
      "stats": "[hi] Kids Content Manager",
      "seedContent": "[hi] Seed Content",
      "importArchive": "[hi] Import Archive.org",
      "syncPodcasts": "[hi] Sync Podcasts",
      "syncYouTube": "[hi] Sync YouTube",
      "tagVod": "[hi] Tag VOD",
      "pendingModeration": "[hi] Pending Moderation"
    }
  },
  "youngsters": {
    "title": "[hi] Youngsters",
    "items": "[hi] items",
    "empty": "[hi] No content available",
    "emptyHint": "[hi] Try another category",
    "exitYoungstersMode": "[hi] Exit Youngsters Mode",
    "exitDescription": "[hi] Enter parent code to exit",
    "parentCode": "[hi] Parent code",
    "confirm": "[hi] Confirm",
    "wrongCode": "[hi] Incorrect code",
    "noContent": "[hi] No content available",
    "tryAnotherCategory": "[hi] Try selecting another category",
    "categories": {
      "all": "[hi] All",
      "trending": "[hi] Trending",
      "news": "[hi] News",
      "culture": "[hi] Culture",
      "educational": "[hi] Educational",
      "music": "[hi] Music",
      "entertainment": "[hi] Entertainment",
      "sports": "[hi] Sports",
      "tech": "[hi] Technology",
      "judaism": "[hi] Judaism"
    },
    "ageGroups": {
      "middle-school": "[hi] Middle School (12-14)",
      "high-school": "[hi] High School (15-17)"
    },
    "moderation": {
      "pending": "[hi] Pending Review",
      "approved": "[hi] Approved",
      "rejected": "[hi] Rejected"
    },
    "admin": {
      "stats": "[hi] Youngsters Content Manager",
      "seedContent": "[hi] Seed Content",
      "importArchive": "[hi] Import Archive.org",
      "syncPodcasts": "[hi] Sync Podcasts",
      "syncYouTube": "[hi] Sync YouTube",
      "tagVod": "[hi] Tag VOD",
      "pendingModeration": "[hi] Pending Moderation"
    }
  },
  "chatbot": {
    "title": "Bayit+ सहायक",
    "greeting": "नमस्ते! मैं Bayit+ स्मार्ट सहायक हूं। आज मैं आपकी कैसे मदद कर सकता हूं?",
    "openChat": "[hi] Open chat",
    "welcome": "[hi] Hello! I'm the Bayit+ smart assistant. How can I help you today? Click the microphone and speak, or type a message.",
    "placeholder": "यहां टाइप करें...",
    "recording": "रिकॉर्डिंग...",
    "transcribing": "ट्रांसक्राइब हो रहा है...",
    "stopRecording": "[hi] Stop recording",
    "startRecording": "[hi] Start voice recording",
    "recommendations": "[hi] Here are some recommendations:",
    "showMultipleSuccess": "[hi] Showing {{count}} content items in widgets",
    "showMultipleNotFound": "[hi] Could not find the requested content. Please try different names.",
    "resolvingContent": "[hi] Finding your content...",
    "errors": {
      "micPermission": "[hi] Could not access microphone. Please check microphone permissions in your browser.",
      "transcribeFailed": "[hi] Could not transcribe the recording. Please try again.",
      "general": "[hi] Sorry, something went wrong. Please try again."
    },
    "suggestions": {
      "whatToWatch": "[hi] What to watch today?",
      "israeliMovies": "[hi] Recommended Israeli movies",
      "whatsOnNow": "[hi] What's on now?",
      "popularPodcasts": "[hi] Popular podcasts"
    },
    "voiceCommands": {
      "showChannels": "[hi] Show me channels...",
      "playChess": "[hi] Start a chess game with...",
      "multiContent": "[hi] Show side by side..."
    }
  },
  "chat": {
    "title": "[hi] Bayit+ Assistant",
    "greeting": "[hi] Hello! I'm Bayit+ smart assistant. How can I help you today? Click the microphone and speak, or type a message."
  },
  "subtitles": {
    "nikud": "निक्कुड़",
    "selection": "चयन",
    "translation": "अनुवाद",
    "translating": "अनुवाद हो रहा है...",
    "close": "बंद करें",
    "unavailable": "अनुवाद उपलब्ध नहीं",
    "off": "बंद",
    "none": "कोई नहीं",
    "autoGenerated": "स्वतः जनित",
    "selectLanguage": "सबटाइटल भाषा चुनें",
    "liveTranslate": "लाइव अनुवाद",
    "translateTo": "में अनुवाद करें",
    "downloadMore": "और सबटाइटल डाउनलोड करें...",
    "downloading": "OpenSubtitles पर खोज रहे हैं...",
    "opensubtitlesSource": "OpenSubtitles.com से",
    "downloadSuccess": "{{count}} सबटाइटल डाउनलोड किए",
    "noSubtitlesFound": "इस सामग्री के लिए कोई सबटाइटल नहीं मिला",
    "smartSubs": "स्मार्ट सब्स",
    "smartSubsDescription": "दोहरा दृश्य: सरलीकृत हिब्रू + अंग्रेजी मूल हाइलाइटिंग के साथ",
    "smartSubsDualView": "दोहरा दृश्य",
    "shoreshToggle": "Shoresh हाइलाइटिंग",
    "shoreshOn": "Shoresh हाइलाइटिंग सक्षम",
    "shoreshOff": "Shoresh हाइलाइटिंग अक्षम",
    "nikudLive": "Nikud के साथ हिब्रू",
    "nikudLiveDescription": "आसान पढ़ने के लिए स्वर चिह्नों के साथ हिब्रू सबटाइटल",
    "nikudEnabled": "Nikud सबटाइटल सक्षम",
    "nikudDisabled": "Nikud सबटाइटल अक्षम",
    "nikudSubtitleLabel": "Nikud के साथ हिब्रू: {{text}}",
    "available": "सबटाइटल",
    "clickToEnable": "लाइव अनुवाद सक्षम करने के लिए क्लिक करें",
    "connectionError": "लाइव अनुवाद त्रुटि",
    "inputLanguageTooltip": "इनपुट भाषा जांचें",
    "premiumRequired": "प्रीमियम सब्सक्रिप्शन आवश्यक",
    "selectInputLanguage": "इनपुट भाषा चुनें",
    "translateActive": "लाइव अनुवाद सक्रिय",
    "noEnglishSubtitles": "इस सामग्री के लिए अंग्रेजी सबटाइटल उपलब्ध नहीं हैं।",
    "hebrewMode": {
      "title": "हिब्रू प्रदर्शन मोड",
      "unavailable": "अनुपलब्ध",
      "generate": "जनरेट करें",
      "regular": {
        "title": "सामान्य हिब्रू",
        "description": "स्वर चिह्नों के बिना मानक हिब्रू पाठ"
      },
      "nikud": {
        "title": "Nikud के साथ हिब्रू",
        "description": "आसान पढ़ने के लिए स्वर चिह्नों के साथ हिब्रू",
        "unavailableReason": "इस सामग्री के लिए AI प्रोसेसिंग उपलब्ध नहीं"
      },
      "shoresh": {
        "title": "Shoresh (मूल शब्द)",
        "description": "मूल विश्लेषण के साथ हिब्रू शब्द: शब्द [मूल]",
        "unavailableReason": "इस सामग्री के लिए मूल शब्द विश्लेषण उपलब्ध नहीं"
      }
    },
    "englishMode": {
      "title": "अंग्रेजी प्रदर्शन मोड",
      "unavailable": "अनुपलब्ध",
      "generate": "जनरेट करें",
      "firstTimeHint": "ये AI-संचालित मोड अंग्रेजी वाक्य संरचना सीखते हुए हिब्रू बनाए रखने में मदद करते हैं। प्रत्येक मोड एक अनूठा सीखने का अनुभव प्रदान करता है।",
      "regular": {
        "title": "सामान्य अंग्रेजी",
        "description": "मानक अंग्रेजी सबटाइटल"
      },
      "heblish": {
        "title": "हेब्लिश",
        "description": "इमर्सिव लर्निंग के लिए हिब्रू शब्द इंजेक्शन के साथ अंग्रेजी",
        "unavailableReason": "इस सामग्री के लिए Heblish प्रोसेसिंग उपलब्ध नहीं"
      },
      "grammarFlip": {
        "title": "ग्रामर-फ्लिप",
        "description": "अंग्रेजी वाक्य संरचना के साथ हिब्रू शब्द (कर्ता-क्रिया-कर्म)",
        "unavailableReason": "इस सामग्री के लिए Grammar-Flip प्रोसेसिंग उपलब्ध नहीं"
      },
      "slangSynthesis": {
        "title": "स्लैंग संश्लेषण",
        "description": "आकर्षक सामग्री के लिए आधुनिक इजरायली और अमेरिकी स्लैंग मिश्रण",
        "unavailableReason": "इस सामग्री के लिए Slang Synthesis प्रोसेसिंग उपलब्ध नहीं"
      }
    },
    "loading": "सबटाइटल लोड हो रहे हैं...",
    "error": {
      "title": "सबटाइटल त्रुटि",
      "retry": "पुनः प्रयास करें",
      "loadFailed": "सबटाइटल लोड करने में विफल",
      "cuesFailed": "सबटाइटल टेक्स्ट लोड करने में विफल",
      "networkError": "नेटवर्क त्रुटि - कृपया अपना कनेक्शन जांचें",
      "serverError": "सर्वर त्रुटि - कृपया बाद में पुनः प्रयास करें"
    },
    "aiModesAvailable": "उपलब्ध AI मोड",
    "aiModesTitle": "AI उपशीर्षक मोड",
    "fetchSubtitles": "उपशीर्षक प्राप्त करें",
    "fontSize": "फ़ॉन्ट आकार",
    "mode": {
      "engrew": "एनग्रू",
      "heblish": "हेब्लिश",
      "shoresh": "शोरेश",
      "standard": "मानक"
    },
    "opensubtitles": "OpenSubtitles",
    "searchExternal": "बाहरी उपशीर्षक खोजें",
    "settingsTitle": "उपशीर्षक सेटिंग्स",
    "showBackground": "पृष्ठभूमि दिखाएं",
    "singleMode": "एकल मोड",
    "splitMode": "स्प्लिट मोड",
    "primary_language": "प्राथमिक भाषा",
    "secondary_language": "द्वितीयक भाषा",
    "layout_mode": "लेआउट मोड",
    "interactive_title": "इंटरैक्टिव उपशीर्षक"
  },
  "video": {
    "watchTrailer": "[hi] Watch Trailer",
    "closeTrailer": "[hi] Close Trailer",
    "deleteConfirm": "[hi] Delete this episode?"
  },
  "recordings": {
    "title": "मेरी रिकॉर्डिंग",
    "subtitle": "अपनी रिकॉर्ड की गई लाइव स्ट्रीम देखें और प्रबंधित करें",
    "record": "रिकॉर्ड करें",
    "recording": "रिकॉर्डिंग",
    "storageUsed": "[hi] Storage Used",
    "totalRecordings": "[hi] Total Recordings",
    "maxDuration": "[hi] Max Duration",
    "noRecordings": "अभी तक कोई रिकॉर्डिंग नहीं",
    "noRecordingsHint": "किसी भी लाइव चैनल से रिकॉर्डिंग शुरू करें!",
    "confirmDelete": "[hi] Are you sure you want to delete this recording? This action cannot be undone.",
    "deleteRecording": "[hi] Delete Recording",
    "deleteFailed": "[hi] Failed to delete recording",
    "expires": "[hi] Expires",
    "subtitlesAvailable": "[hi] Subtitles Available",
    "recordingSaved": "[hi] Recording Saved!",
    "savedSuccess": "[hi] Recording saved successfully! Duration: {{duration}}",
    "viewInMyRecordings": "[hi] View in My Recordings",
    "error": "[hi] Recording Error",
    "startFailed": "[hi] Failed to start recording. Please try again.",
    "stopFailed": "[hi] Failed to stop recording. Please try again.",
    "page": "[hi] Page"
  },
  "chess": {
    "title": "[hi] Chess",
    "welcome": "[hi] Welcome to Chess",
    "subtitle": "[hi] Play chess with friends and family around the world",
    "createGame": "[hi] Create New Game",
    "joinGame": "[hi] Join Game",
    "gameCode": "[hi] Game Code",
    "enterGameCode": "[hi] Enter Game Code",
    "invalidGameCode": "[hi] Invalid game code. Must be 6 characters.",
    "joinFailed": "[hi] Failed to join game",
    "join": "[hi] Join",
    "create": "[hi] Create",
    "chooseColor": "[hi] Choose Your Color",
    "white": "[hi] White",
    "black": "[hi] Black",
    "chatPlaceholder": "[hi] Type a message... (@bot for advice)",
    "botHint": "[hi] Tag @bot in your message to get chess advice from our AI assistant",
    "bot": "[hi] Chess Assistant",
    "mute": "[hi] Mute",
    "unmute": "[hi] Unmute",
    "speaking": "[hi] participants",
    "resign": "[hi] Resign",
    "offerDraw": "[hi] Offer Draw",
    "newGame": "[hi] New Game",
    "checkmate": "[hi] Checkmate!",
    "stalemate": "[hi] Stalemate",
    "draw": "[hi] Draw",
    "resigned": "[hi] Game Resigned",
    "reconnecting": "[hi] Reconnecting...",
    "moveHistory": "[hi] Move History",
    "noMoves": "[hi] No moves yet",
    "showHints": "[hi] Show Guide Hints",
    "yourTurn": "[hi] Your Turn",
    "opponentTurn": "[hi] Opponent's Turn",
    "waitingForOpponent": "[hi] Waiting for opponent...",
    "gameOver": "[hi] Game Over",
    "sendingInvite": "[hi] Sending game invite to {{name}}...",
    "inviteSent": "[hi] Game invite sent to {{name}}! Game code: {{code}}",
    "inviteFailed": "[hi] Could not find that user. Please check the name and try again.",
    "inviteReceived": "[hi] {{name}} invited you to a chess game!",
    "joinInvite": "[hi] Join Game",
    "challenge": "[hi] Challenge",
    "playedAsWhite": "[hi] Played as White",
    "playedAsBlack": "[hi] Played as Black",
    "gameMode": "[hi] Game Mode",
    "playVsFriend": "[hi] Play vs Friend",
    "playVsBot": "[hi] Play vs Bot",
    "difficulty": "[hi] Difficulty",
    "easy": "[hi] Easy",
    "medium": "[hi] Medium",
    "hard": "[hi] Hard",
    "chessBot": "[hi] Chess Bot",
    "chat": {
      "title": "[hi] Chat",
      "inputPlaceholder": "[hi] Type a message..."
    },
    "acceptDraw": "[hi] Accept Draw",
    "acceptInvite": "[hi] Accept Invite",
    "blackCaptured": "[hi] Black Captured",
    "blackTurn": "[hi] Black's Turn",
    "challengeFriend": "[hi] Challenge Friend",
    "challengeViaWhatsApp": "[hi] Challenge via WhatsApp",
    "copyCode": "[hi] Copy Code",
    "declineDraw": "[hi] Decline Draw",
    "declineInvite": "[hi] Decline Invite",
    "drawOffered": "[hi] Draw Offered",
    "joinByGameCode": "[hi] Join by Game Code",
    "noFriendsYet": "[hi] No friends yet",
    "offline": "[hi] Offline",
    "online": "[hi] Online",
    "opponent": "[hi] Opponent",
    "whiteCaptured": "[hi] White Captured",
    "whiteTurn": "[hi] White's Turn",
    "you": "[hi] You"
  },
  "friends": {
    "title": "[hi] Friends & Opponents",
    "subtitle": "[hi] Connect with players and challenge friends",
    "myFriends": "[hi] My Friends",
    "requests": "[hi] Requests",
    "findPlayers": "[hi] Find Players",
    "friendsLabel": "[hi] Friends",
    "pendingLabel": "[hi] Pending",
    "add": "[hi] Add Friend",
    "remove": "[hi] Remove",
    "accept": "[hi] Accept",
    "reject": "[hi] Reject",
    "cancel": "[hi] Cancel",
    "noFriends": "[hi] No friends yet",
    "noFriendsDesc": "[hi] Search for players and send friend requests",
    "lastGame": "[hi] Last game: {{time}}",
    "friendsSince": "[hi] Friends since {{date}}",
    "incomingRequests": "[hi] Incoming Requests",
    "outgoingRequests": "[hi] Outgoing Requests",
    "noIncoming": "[hi] No incoming requests",
    "noOutgoing": "[hi] No outgoing requests",
    "sentAt": "[hi] Sent {{time}}",
    "searchPlaceholder": "[hi] Search by name...",
    "noResults": "[hi] No players found",
    "noResultsDesc": "[hi] Try searching with a different name",
    "requestSent": "[hi] Friend request sent!",
    "requestAccepted": "[hi] Friend request accepted!",
    "requestRejected": "[hi] Friend request rejected",
    "requestCancelled": "[hi] Friend request cancelled",
    "friendRemoved": "[hi] Friend removed",
    "searchFailed": "[hi] Failed to search users",
    "requestFailed": "[hi] Failed to send request",
    "acceptFailed": "[hi] Failed to accept request",
    "rejectFailed": "[hi] Failed to reject request",
    "cancelFailed": "[hi] Failed to cancel request",
    "removeFailed": "[hi] Failed to remove friend",
    "friendsCount": "[hi] {{count}} friends",
    "gamesCount": "[hi] {{count}} games",
    "alreadyFriends": "[hi] Friends"
  },
  "stats": {
    "statistics": "[hi] Statistics",
    "matchHistory": "[hi] Match History",
    "headToHead": "[hi] Head to Head",
    "gamesPlayed": "[hi] Games Played",
    "wins": "[hi] Wins",
    "losses": "[hi] Losses",
    "draws": "[hi] Draws",
    "winRate": "[hi] Win Rate",
    "rating": "[hi] Rating",
    "peakRating": "[hi] Peak Rating",
    "peak": "[hi] Peak",
    "winStreak": "[hi] Win Streak",
    "currentStreak": "[hi] Current Streak",
    "bestStreak": "[hi] Best Streak",
    "performance": "[hi] Performance",
    "achievements": "[hi] Achievements",
    "currentRating": "[hi] Current Rating",
    "totalGames": "[hi] Total Games",
    "noGames": "[hi] No games played yet",
    "moves": "[hi] moves",
    "won": "[hi] Won",
    "lost": "[hi] Lost",
    "draw": "[hi] Draw",
    "overall": "[hi] Overall Record",
    "yourWins": "[hi] Your Wins",
    "theirWins": "[hi] Their Wins",
    "totalGamesPlayed": "[hi] Total: {{count}} games",
    "recentGames": "[hi] Recent Games"
  },
  "support": {
    "title": "सहायता केंद्र",
    "subtitle": "हम आज आपकी कैसे मदद कर सकते हैं?",
    "tabs": {
      "docs": "दस्तावेज़",
      "faq": "FAQ",
      "contact": "संपर्क",
      "tickets": "मेरे टिकट"
    },
    "categories": {
      "title": "[hi] Browse Documentation",
      "loading": "[hi] Loading documentation...",
      "loadError": "[hi] Failed to load categories",
      "articleCount": "[hi] {{count}} articles",
      "gettingStarted": "[hi] Getting Started",
      "features": "[hi] Features",
      "troubleshooting": "[hi] Troubleshooting",
      "account": "[hi] Account"
    },
    "docs": {
      "loading": "[hi] Loading document...",
      "loadError": "[hi] Failed to load document",
      "backToList": "[hi] Back to documentation"
    },
    "search": {
      "placeholder": "[hi] Search documentation...",
      "noResults": "[hi] No results found"
    },
    "faq": {
      "title": "[hi] Frequently Asked Questions",
      "loading": "[hi] Loading FAQ...",
      "loadError": "[hi] Failed to load FAQ",
      "empty": "[hi] No FAQ items in this category",
      "categories": {
        "all": "[hi] All Topics",
        "general": "[hi] General",
        "billing": "[hi] Billing",
        "technical": "[hi] Technical",
        "features": "[hi] Features"
      }
    },
    "contact": {
      "voiceTitle": "[hi] Voice Support",
      "voiceDescription": "[hi] Click the avatar button or say \"Jarvis\" to start a voice conversation with our AI assistant.",
      "ticketTitle": "[hi] Create Support Ticket",
      "ticketDescription": "[hi] Need human assistance? Create a support ticket and our team will respond within 24 hours.",
      "createTicket": "[hi] Create Ticket",
      "emailTitle": "[hi] Email Support",
      "emailDescription": "[hi] Prefer email? Reach us at support@bayit.tv for any questions or concerns."
    },
    "ticket": {
      "title": "[hi] Create Support Ticket",
      "subject": "[hi] Subject",
      "subjectPlaceholder": "[hi] Brief description of your issue",
      "message": "[hi] Message",
      "messagePlaceholder": "[hi] Describe your issue in detail...",
      "categoryLabel": "[hi] Category",
      "priorityLabel": "[hi] Priority",
      "submit": "[hi] Submit Ticket",
      "category": {
        "billing": "[hi] Billing",
        "technical": "[hi] Technical",
        "feature": "[hi] Feature Request",
        "general": "[hi] General"
      },
      "priority": {
        "low": "[hi] Low",
        "medium": "[hi] Medium",
        "high": "[hi] High",
        "urgent": "[hi] Urgent"
      },
      "status": {
        "open": "[hi] Open",
        "in_progress": "[hi] In Progress",
        "resolved": "[hi] Resolved",
        "closed": "[hi] Closed"
      },
      "created": "[hi] Created",
      "error": {
        "required": "[hi] Please fill in all required fields",
        "submit": "[hi] Failed to create ticket. Please try again."
      }
    },
    "tickets": {
      "title": "[hi] My Support Tickets",
      "loading": "[hi] Loading tickets...",
      "loadError": "[hi] Failed to load tickets",
      "empty": "[hi] No support tickets yet",
      "emptyFilter": "[hi] No tickets with this status",
      "create": "[hi] New Ticket",
      "createFirst": "[hi] Create Your First Ticket",
      "filter": {
        "all": "[hi] All",
        "open": "[hi] Open",
        "inProgress": "[hi] In Progress",
        "resolved": "[hi] Resolved"
      }
    },
    "voice": {
      "title": "[hi] Voice Assistant",
      "listening": "[hi] I'm listening...",
      "thinking": "[hi] Let me think about that...",
      "speaking": "[hi] Speaking...",
      "error": "[hi] Sorry, I didn't catch that. Try again?",
      "ready": "[hi] What would you like to know?",
      "listeningNow": "[hi] Listening...",
      "wakeWordHint": "[hi] Say \"Jarvis\" to speak"
    },
    "wizard": {
      "role": "[hi] Your Guide"
    }
  },
  "jerusalem": {
    "title": "[hi] Jerusalem Connection",
    "subtitle": "[hi] Stay connected to the heart of Israel",
    "noContent": "[hi] No Jerusalem content available",
    "sources": "[hi] Sources",
    "kotelLive": "[hi] Western Wall Live",
    "categories": {
      "kotel": "[hi] Western Wall",
      "idf-ceremony": "[hi] IDF Ceremonies",
      "diaspora-connection": "[hi] Diaspora Connection",
      "holy-sites": "[hi] Holy Sites",
      "jerusalem-events": "[hi] Jerusalem Events",
      "general": "[hi] Jerusalem"
    }
  },
  "telAviv": {
    "title": "[hi] Tel Aviv Connection",
    "subtitle": "[hi] The city that never stops",
    "noContent": "[hi] No Tel Aviv content available",
    "sources": "[hi] Sources",
    "beachLive": "[hi] Beach Webcam",
    "categories": {
      "beaches": "[hi] Beaches",
      "nightlife": "[hi] Nightlife",
      "culture": "[hi] Culture & Art",
      "music": "[hi] Music Scene",
      "food": "[hi] Food & Dining",
      "tech": "[hi] Tech & Startups",
      "events": "[hi] Events",
      "general": "[hi] Tel Aviv"
    }
  },
  "voiceOnboarding": {
    "welcome": {
      "title": "[hi] Welcome to Voice Control",
      "description": "[hi] Control Bayit+ with your voice for a hands-free experience."
    },
    "features": {
      "voiceCommands": "वॉइस कमांड",
      "voiceCommandsDesc": "स्वाभाविक बोलचाल से नेविगेट करें, खोजें और प्लेबैक नियंत्रित करें",
      "tts": "टेक्स्ट-टू-स्पीच",
      "ttsDesc": "प्रतिक्रियाएं और सामग्री विवरण जोर से सुनें",
      "wakeWord": "वेक वर्ड",
      "wakeWordDesc": "किसी भी समय वॉइस कंट्रोल सक्रिय करने के लिए 'Bayit' बोलें"
    },
    "getStarted": "शुरू करें",
    "permissions": {
      "title": "माइक्रोफोन एक्सेस",
      "description": "वॉइस कंट्रोल के लिए आपकी कमांड सुनने के लिए माइक्रोफोन एक्सेस आवश्यक है",
      "privacy": "आपका वॉइस डेटा सुरक्षित रूप से प्रोसेस किया जाता है और कभी स्टोर नहीं किया जाता"
    },
    "permissionsGranted": "माइक्रोफोन एक्सेस दी गई",
    "permissionRequired": {
      "title": "अनुमति आवश्यक",
      "message": "वॉइस कंट्रोल उपयोग करने के लिए कृपया अपने डिवाइस सेटिंग्स में माइक्रोफोन एक्सेस सक्षम करें"
    },
    "grantPermissions": "अनुमतियां दें",
    "testWakeWord": {
      "title": "वेक वर्ड टेस्ट करें",
      "description": "वॉइस एक्टिवेशन टेस्ट करने के लिए 'Bayit' बोलें",
      "success": "बढ़िया! वॉइस एक्टिवेशन काम कर रहा है"
    },
    "startTest": "टेस्ट शुरू करें",
    "complete": {
      "title": "सब तैयार है!",
      "description": "वॉइस कंट्रोल अब सक्षम है। ये कमांड आज़माएं:",
      "tryCommands": "ये कमांड आज़माएं",
      "examples": {
        "search": "\"Fauda खोजें\"",
        "play": "\"समाचार चलाएं\"",
        "navigate": "\"लाइव टीवी पर जाएं\"",
        "control": "\"रोकें\" या \"आवाज बढ़ाएं\""
      },
      "startUsing": "वॉइस कंट्रोल उपयोग करना शुरू करें"
    },
    "skip": "अभी छोड़ें",
    "buttons": {
      "back": "[hi] Back"
    },
    "completion": {
      "message": "[hi] Voice features are ready to use.",
      "title": "[hi] Voice Setup Complete"
    },
    "title": "[hi] Voice Setup",
    "training": {
      "message": "[hi] Read the phrases aloud to train voice recognition.",
      "title": "[hi] Voice Training"
    }
  },
  "taxonomy": {
    "sections": {
      "movies": "[hi] Movies",
      "series": "[hi] Series",
      "kids": "[hi] Kids",
      "youngsters": "[hi] Youngsters",
      "music": "[hi] Music",
      "documentaries": "[hi] Documentaries",
      "podcasts": "[hi] Podcasts",
      "live": "[hi] Live TV"
    },
    "subcategories": {
      "learning-hebrew": "[hi] Learning Hebrew",
      "young-science": "[hi] Young Science",
      "math-fun": "[hi] Fun Math",
      "nature-animals": "[hi] Nature & Animals",
      "interactive": "[hi] Interactive",
      "hebrew-songs": "[hi] Hebrew Songs",
      "nursery-rhymes": "[hi] Nursery Rhymes",
      "kids-movies": "[hi] Kids Movies",
      "kids-series": "[hi] Kids Series",
      "jewish-holidays": "[hi] Jewish Holidays",
      "torah-stories": "[hi] Torah Stories",
      "bedtime-stories": "[hi] Bedtime Stories",
      "tiktok-trends": "[hi] TikTok Trends",
      "viral-videos": "[hi] Viral Videos",
      "memes": "[hi] Memes",
      "israel-news": "[hi] Israel News",
      "world-news": "[hi] World News",
      "science-news": "[hi] Science News",
      "sports-news": "[hi] Sports News",
      "music-culture": "[hi] Music Culture",
      "film-culture": "[hi] Film Culture",
      "art-culture": "[hi] Art Culture",
      "food-culture": "[hi] Food Culture",
      "study-help": "[hi] Study Help",
      "career-prep": "[hi] Career Prep",
      "life-skills": "[hi] Life Skills",
      "teen-movies": "[hi] Teen Movies",
      "teen-series": "[hi] Teen Series",
      "gaming": "[hi] Gaming",
      "coding": "[hi] Coding",
      "gadgets": "[hi] Gadgets",
      "bar-bat-mitzvah": "[hi] Bar/Bat Mitzvah",
      "teen-torah": "[hi] Teen Torah",
      "jewish-history": "[hi] Jewish History",
      "learning-hebrew.description": "बच्चों के लिए हिब्रू में पढ़ना, लिखना और शब्दावली सीखना",
      "young-science.description": "बच्चों के लिए अनुकूलित प्रयोग और वैज्ञानिक व्याख्याएं",
      "math-fun.description": "मजेदार और खेल-खेल में संख्याएं और अंकगणित सीखना",
      "nature-animals.description": "जिज्ञासु बच्चों के लिए जानवरों और प्रकृति की दुनिया",
      "interactive.description": "बच्चों के लिए इंटरैक्टिव और सहभागी सामग्री",
      "hebrew-songs.description": "क्लासिक और नए इजरायली बच्चों के गाने",
      "nursery-rhymes.description": "छोटे बच्चों और शिशुओं के लिए गाने और धुनें",
      "kids-movies.description": "बच्चों के लिए उपयुक्त पूर्ण-लंबाई की फिल्में",
      "kids-series.description": "बच्चों के लिए एनिमेटेड सीरीज और टीवी शो",
      "jewish-holidays.description": "बच्चों के लिए यहूदी त्योहारों और परंपराओं के बारे में सामग्री",
      "torah-stories.description": "तोराह और यहूदी परंपरा से कहानियां",
      "bedtime-stories.description": "सोने के समय के लिए आरामदायक कहानियां",
      "tiktok-trends.description": "TikTok पर लोकप्रिय ट्रेंड और चैलेंज",
      "viral-videos.description": "सोशल मीडिया पर लोकप्रिय वायरल वीडियो",
      "memes.description": "मजेदार मीम्स और इंटरनेट संस्कृति",
      "israel-news.description": "किशोरों के लिए अनुकूलित इजरायल समाचार",
      "world-news.description": "युवाओं के लिए अंतरराष्ट्रीय समाचार",
      "science-news.description": "वैज्ञानिक खोजें और तकनीकी नवाचार",
      "sports-news.description": "खेल अपडेट और मैच परिणाम",
      "music-culture.description": "संगीत जगत, कलाकार और उत्सव",
      "film-culture.description": "सिनेमा, सीरीज और समीक्षाएं",
      "art-culture.description": "कला, गैलरी और रचनात्मकता",
      "food-culture.description": "खाना पकाना, रेसिपी और खाद्य संस्कृति",
      "study-help.description": "परीक्षा, सारांश और टेस्ट की तैयारी में मदद",
      "career-prep.description": "विश्वविद्यालय और करियर की तैयारी",
      "life-skills.description": "जीवन कौशल, धन प्रबंधन और स्वतंत्रता",
      "teen-movies.description": "किशोरों के लिए अनुशंसित फिल्में",
      "teen-series.description": "किशोरों के लिए लोकप्रिय सीरीज",
      "gaming.description": "वीडियो गेम, ई-स्पोर्ट्स और गेमिंग",
      "coding.description": "प्रोग्रामिंग, कोडिंग और सॉफ्टवेयर विकास",
      "gadgets.description": "गैजेट, तकनीक और समीक्षाएं",
      "bar-bat-mitzvah.description": "बार/बैट मिट्ज़वाह की तैयारी और उत्सव",
      "teen-torah.description": "किशोरों के लिए तोराह कक्षाएं और साप्ताहिक पराशा",
      "jewish-history.description": "यहूदी लोगों का इतिहास"
    }
  },
  "passkey": {
    "manager": {
      "title": "[hi] Passkeys",
      "subtitle": "[hi] Manage your passkeys for secure content access"
    },
    "unsupported": "[hi] Passkeys are not supported on this device",
    "fetchError": "[hi] Failed to load passkeys",
    "registerError": "[hi] Failed to register passkey",
    "deleteError": "[hi] Failed to delete passkey",
    "cancelled": "[hi] Passkey operation was cancelled",
    "noPasskeys": "[hi] No passkeys registered yet. Add one to unlock private content.",
    "unknownDevice": "[hi] Unknown Device",
    "created": "[hi] Created",
    "lastUsed": "[hi] Last used",
    "never": "[hi] Never",
    "addPasskey": "[hi] Add Passkey",
    "deleteConfirmTitle": "[hi] Delete Passkey?",
    "deleteConfirmText": "[hi] This passkey will no longer be able to unlock content. You can always add it again later.",
    "unlock": "[hi] Unlock",
    "unlockContent": "[hi] Unlock Private Content",
    "unlockDescription": "[hi] Use your passkey to access private movies and series",
    "auth": {
      "title": "[hi] Unlock Content",
      "description": "[hi] Use your fingerprint, face, or device PIN to unlock private movies and series.",
      "unlock": "[hi] Unlock with Passkey",
      "authenticating": "[hi] Authenticating...",
      "success": "[hi] Content Unlocked!",
      "cancelled": "[hi] Authentication was cancelled",
      "error": "[hi] Authentication failed. Please try again."
    },
    "qr": {
      "useQR": "[hi] Use Phone to Unlock",
      "scanWithPhone": "[hi] Scan with your phone",
      "instruction": "[hi] Open the camera on your phone and scan the QR code to authenticate",
      "error": "[hi] Failed to generate QR code",
      "expired": "[hi] QR code expired. Please try again."
    }
  },
  "olorin": {
    "errors": {
      "session_not_found": "[hi] Session not found",
      "session_different_partner": "[hi] Session belongs to different partner",
      "session_invalid_status": "[hi] Session is {status}, cannot add transcript",
      "max_sessions_reached": "[hi] Maximum concurrent sessions ({limit}) reached",
      "invalid_api_key": "[hi] Invalid API key",
      "missing_api_key": "[hi] Missing {header} header",
      "capability_disabled": "[hi] Capability '{capability}' is currently disabled",
      "capability_not_enabled": "[hi] Capability '{capability}' not enabled for this partner",
      "source_language_not_supported": "[hi] Source language '{language}' not supported. Supported: {supported}",
      "target_language_not_supported": "[hi] Target language '{language}' not supported. Supported: {supported}",
      "partner_not_found": "[hi] Partner not found",
      "partner_registration_failed": "[hi] Failed to register partner",
      "no_updates_provided": "[hi] No updates provided",
      "webhook_config_failed": "[hi] Failed to configure webhook",
      "webhook_url_not_configured": "[hi] Webhook URL not configured",
      "webhook_secret_not_configured": "[hi] Webhook secret not configured",
      "search_failed": "[hi] Search failed",
      "indexing_failed": "[hi] Indexing failed",
      "detection_failed": "[hi] Detection failed",
      "explanation_failed": "[hi] Failed to get explanation",
      "reference_not_found": "[hi] Reference '{reference_id}' not found",
      "enrichment_failed": "[hi] Enrichment failed",
      "get_references_failed": "[hi] Failed to get references",
      "create_session_failed": "[hi] Failed to create session",
      "add_transcript_failed": "[hi] Failed to add transcript",
      "generate_recap_failed": "[hi] Failed to generate recap"
    }
  },
  "portal": {
    "nav": {
      "home": "होम",
      "features": "विशेषताएं",
      "solutions": "समाधान",
      "pricing": "मूल्य निर्धारण",
      "demo": "लाइव डेमो",
      "contact": "संपर्क करें",
      "getStarted": "शुरू करें"
    },
    "hero": {
      "ctaExplore": "विशेषताएं देखें",
      "ctaDemo": "डेमो का अनुरोध करें"
    },
    "cta": {
      "title": "शुरू करने के लिए तैयार हैं?",
      "subtitle": "आइए चर्चा करें कि हम आपके व्यवसाय को बदलने में कैसे मदद कर सकते हैं",
      "button": "हमसे संपर्क करें"
    },
    "contactPage": {
      "title": "संपर्क में रहें",
      "subtitle": "हमारे समाधानों में रुचि है? आइए बात करें",
      "formTitle": "हमें एक संदेश भेजें",
      "infoTitle": "संपर्क जानकारी",
      "form": {
        "name": "पूरा नाम",
        "email": "ईमेल पता",
        "company": "कंपनी का नाम",
        "phone": "फोन नंबर",
        "message": "आपका संदेश",
        "messagePlaceholder": "हमें अपनी आवश्यकताओं के बारे में बताएं..."
      },
      "submit": "संदेश भेजें",
      "sending": "भेज रहे हैं...",
      "success": "संदेश सफलतापूर्वक भेजा गया! हम जल्द ही आपसे संपर्क करेंगे।",
      "error": "संदेश भेजने में विफल। कृपया पुनः प्रयास करें।",
      "scheduleTitle": "कॉल शेड्यूल करना पसंद करते हैं?",
      "scheduleSubtitle": "हमारी टीम के साथ व्यक्तिगत डेमो बुक करें",
      "scheduleCta": "डेमो कॉल शेड्यूल करें"
    },
    "pricingPage": {
      "title": "किफायती",
      "titleHighlight": "मूल्य निर्धारण योजनाएं",
      "subtitle": "अपनी आवश्यकताओं के अनुरूप योजना चुनें",
      "comparisonTitle": "विशेषताओं की तुलना",
      "faqTitle": "अक्सर पूछे जाने वाले प्रश्न",
      "faq": {
        "q1": "मूल्य निर्धारण की गणना कैसे की जाती है?",
        "a1": "मूल्य निर्धारण आपकी विशिष्ट आवश्यकताओं और उपयोग पर आधारित है। अनुकूलित उद्धरण के लिए हमसे संपर्क करें।",
        "q2": "क्या मैं बाद में अपनी योजना को अपग्रेड कर सकता हूं?",
        "a2": "हां, आप किसी भी समय अपग्रेड कर सकते हैं। हम आपके डेटा को सहजता से स्थानांतरित करने में मदद करेंगे।",
        "q3": "कौन सा सपोर्ट शामिल है?",
        "a3": "सभी योजनाओं में ईमेल सपोर्ट शामिल है। प्रोफेशनल और एंटरप्राइज योजनाओं में समर्पित खाता प्रबंधकों के साथ प्राथमिकता सपोर्ट शामिल है।"
      },
      "professional": {
        "name": "व्यावसायिक",
        "price": "उद्धरण के लिए संपर्क करें",
        "priceNote": "कस्टम मूल्य निर्धारण",
        "description": "उन्नत आवश्यकताओं वाले बढ़ते व्यवसायों के लिए",
        "cta": "उद्धरण प्राप्त करें"
      },
      "enterprise": {
        "name": "उद्यम",
        "price": "अनुकूलित",
        "priceNote": "वॉल्यूम आधारित",
        "description": "बड़े संगठनों और उद्यम तैनाती के लिए",
        "cta": "बिक्री से संपर्क करें"
      },
      "ctaTitle": "शुरू करने के लिए तैयार हैं?",
      "ctaSubtitle": "आइए अपनी आवश्यकताओं पर चर्चा करें और सही योजना खोजें",
      "ctaButton": "बिक्री से संपर्क करें"
    },
    "featuresPage": {
      "title": "शक्तिशाली",
      "titleHighlight": "विशेषताएं",
      "subtitle": "सफल होने के लिए आपको जो कुछ भी चाहिए",
      "techSpecsTitle": "तकनीकी विनिर्देश",
      "workflowTitle": "यह कैसे काम करता है",
      "workflow": {
        "s1": {
          "title": "आयात करें",
          "description": "अपनी सामग्री अपलोड और व्यवस्थित करें"
        },
        "s2": {
          "title": "कॉन्फ़िगर करें",
          "description": "अपनी प्राथमिकताएं और सेटिंग्स सेट करें"
        },
        "s3": {
          "title": "तैनात करें",
          "description": "अपने समाधान के साथ लाइव जाएं"
        },
        "s4": {
          "title": "मॉनिटर करें",
          "description": "प्रदर्शन ट्रैक करें और अनुकूलित करें"
        }
      },
      "ctaTitle": "विशेषताओं का पता लगाने के लिए तैयार हैं?",
      "ctaSubtitle": "व्यक्तिगत डेमो के साथ सभी विशेषताओं को क्रिया में देखें",
      "ctaButton": "डेमो शेड्यूल करें"
    },
    "demoPage": {
      "title": "हमारा देखें",
      "titleHighlight": "प्लेटफ़ॉर्म",
      "subtitle": "हमारे समाधान की शक्ति का अनुभव करें",
      "scheduleCta": "लाइव डेमो शेड्यूल करें",
      "stepsTitle": "यह कैसे काम करता है",
      "steps": {
        "analyze": {
          "title": "विश्लेषण करें",
          "description": "प्रदर्शन ट्रैक करें और सुधार करें"
        }
      },
      "featuresTitle": "प्लेटफ़ॉर्म हाइलाइट्स",
      "platformsTitle": "उपलब्ध है",
      "ctaTitle": "अपने कस्टम डेमो के लिए तैयार हैं?",
      "ctaSubtitle": "अपनी आवश्यकताओं के अनुरूप व्यक्तिगत प्रदर्शन शेड्यूल करें",
      "ctaButton": "डेमो शेड्यूल करें"
    },
    "workflow": {
      "sectionTitle": "बुद्धिमान वर्कफ़्लो",
      "sectionSubtitle": "4 चरणों में सुव्यवस्थित प्रक्रिया",
      "step1": {
        "title": "सेटअप",
        "description": "अपने खाते और प्राथमिकताओं को कॉन्फ़िगर करें"
      },
      "step2": {
        "title": "अनुकूलित करें",
        "description": "अपनी आवश्यकताओं के लिए सेटिंग्स को अनुकूलित करें"
      },
      "step3": {
        "title": "तैनात करें",
        "description": "अपना समाधान लॉन्च करें"
      },
      "step4": {
        "title": "मॉनिटर करें",
        "description": "प्रदर्शन ट्रैक करें और अनुकूलित करें"
      }
    }
  },
  "trivia": {
    "didYouKnow": "क्या आप जानते हैं?",
    "dismissHint": "तथ्य बंद करें",
    "settings": {
      "displayLanguages": "प्रदर्शन भाषाएं",
      "languageHint": "प्रत्येक तथ्य के लिए 1-3 भाषाएं चुनें",
      "language": "भाषा",
      "selectLanguage": "इस भाषा को चुनें",
      "deselectLanguage": "इस भाषा को अचयनित करें",
      "enableDescription": "[hi] Show trivia questions while watching content.",
      "enableTrivia": "[hi] Enable Trivia",
      "title": "[hi] Trivia Settings"
    },
    "aiTrivia": "AI ट्रिविया",
    "tellMeMore": "मुझे और बताएं",
    "more": "अधिक",
    "follow_up": "अनुवर्ती"
  },
  "auth": {
    "loginRequired": "[hi] Login Required",
    "loginToWatch": "[hi] Please sign in to watch {{title}}",
    "login": "[hi] Login",
    "signUp": "[hi] Sign Up",
    "biometricEnrollEnable": "[hi] Enable",
    "biometricEnrollMessage": "[hi] Use Face ID or fingerprint for faster sign-in next time.",
    "biometricEnrollSkip": "[hi] Skip",
    "biometricEnrollTitle": "[hi] Enable Biometric Sign-In",
    "biometricSignIn": "[hi] Sign in with Biometrics",
    "signOut": "[hi] Sign Out",
    "register": {
      "createAccount": "खाता बनाएं",
      "email": "ईमेल",
      "password": "पासवर्ड",
      "confirmPassword": "पासवर्ड की पुष्टि करें",
      "register": "पंजीकरण",
      "alreadyHaveAccount": "पहले से खाता है? साइन इन करें",
      "passwordStrength": {
        "weak": "कमजोर",
        "medium": "मध्यम",
        "strong": "मजबूत"
      }
    }
  },
  "recording": {
    "stop": "रिकॉर्डिंग रोकें",
    "start": "रिकॉर्डिंग शुरू करें"
  },
  "discover": {
    "title": "[hi] Discover",
    "subtitle": "19 AI-संचालित सुविधाएं खोजें",
    "description": "Bayit+ आपके देखने, सुनने और सीखने के अनुभव को बेहतर बनाने के लिए AI का उपयोग करता है। जानें कि आपके प्लेटफॉर्म पर क्या उपलब्ध है।",
    "featureCount": "{{count}} सुविधाएं",
    "tryIt": "आज़माएं",
    "startWalkthrough": "वॉकथ्रू शुरू करें",
    "availableOn": "उपलब्ध है",
    "prerequisites": "पूर्वापेक्षाएं",
    "setup": "सेट अप करें",
    "error": {
      "fetchFailed": "Discover सुविधाएं लोड करने में विफल। कृपया पुनः प्रयास करें।",
      "unknownFeature": "सुविधा नहीं मिली।",
      "featureDisabled": "यह सुविधा अभी अक्षम है।"
    },
    "availability": {
      "ready": "तैयार",
      "setupNeeded": "सेटअप आवश्यक",
      "premiumRequired": "प्रीमियम आवश्यक",
      "notAvailable": "उपलब्ध नहीं",
      "platformOnly": "अन्य प्लेटफॉर्म"
    },
    "platform": {
      "web": "Web",
      "ios": "iOS",
      "android": "Android",
      "tvos": "Apple TV"
    },
    "category": {
      "watching_movies": "फिल्में देखना",
      "watching_live_tv": "लाइव टीवी देखना",
      "learn_hebrew": "हिब्रू सीखें",
      "search_discovery": "खोज और खोज",
      "chat_assistants": "चैट सहायक"
    },
    "feature": {
      "pause_ask": {
        "name": "रोकें और पूछें",
        "tagline": "किसी भी दृश्य को रोकें और अपने AI साथी से उसके बारे में पूछें",
        "description": "देखते समय, वीडियो को रोकें और वर्तमान दृश्य के बारे में प्रश्न पूछें। आपका AI पात्र सांस्कृतिक संदर्भ समझाएगा, संवाद का अनुवाद करेगा, या कथानक पर चर्चा करेगा।"
      },
      "interactive_subtitles": {
        "name": "इंटरेक्टिव उपशीर्षक",
        "tagline": "तुरंत अनुवाद और संदर्भ के लिए किसी भी उपशीर्षक शब्द को स्पर्श करें",
        "description": "उपशीर्षक में किसी भी शब्द पर क्लिक करें उसका अनुवाद देखें, उच्चारण सुनें और उपयोग के उदाहरण प्राप्त करें। अपने पसंदीदा शो देखते हुए शब्द भंडार बनाएं।"
      },
      "vocabulary": {
        "name": "शब्द भंडार निर्माता",
        "tagline": "आप जो शो देखते हैं उनसे नए शब्द सीखें",
        "description": "उपशीर्षक से नए हिब्रू शब्द स्वचालित रूप से एकत्र करें। फ्लैशकार्ड की समीक्षा करें, प्रगति ट्रैक करें, और आपको पसंद आने वाली सामग्री के माध्यम से अपना शब्द भंडार बनाएं।"
      },
      "vod_moments": {
        "name": "VOD पल",
        "tagline": "आपकी पसंदीदा सामग्री के AI-क्यूरेटेड हाइलाइट्स",
        "description": "फिल्मों और शो से AI-जनित हाइलाइट क्लिप और मुख्य क्षण प्राप्त करें। यादगार दृश्य साझा करें और सबसे अच्छे पलों को दोबारा देखें।"
      },
      "cultural_context": {
        "name": "सांस्कृतिक संदर्भ",
        "tagline": "हर दृश्य के पीछे सांस्कृतिक पृष्ठभूमि समझें",
        "description": "आप जो सामग्री देखते हैं उसमें दिखाई देने वाली इज़राइली रीति-रिवाज, त्योहारों, हास्य और सामाजिक मानदंडों की व्याख्या करने वाले रियल-टाइम सांस्कृतिक एनोटेशन प्राप्त करें।"
      },
      "bilingual_bridge": {
        "name": "द्विभाषी सेतु",
        "tagline": "देखते समय हिब्रू-हिंदी में साथ-साथ सीखना",
        "description": "हाइलाइट किए गए शब्द भंडार के साथ दोहरी भाषा के उपशीर्षक देखें। स्वाभाविक रूप से समझ विकसित करने के लिए हिब्रू और अपनी मातृभाषा के बीच टॉगल करें।"
      },
      "ai_companion": {
        "name": "AI साथी",
        "tagline": "इज़राइली सामग्री के लिए आपका व्यक्तिगत AI गाइड",
        "description": "एक AI पात्र जो आपके साथ देखता है, टिप्पणी प्रदान करता है, प्रश्नों का उत्तर देता है और इज़राइली मीडिया की बारीकियों को समझने में आपकी मदद करता है।"
      },
      "live_dubbing": {
        "name": "लाइव डबिंग",
        "tagline": "लाइव इज़राइली टीवी चैनलों की रियल-टाइम AI डबिंग",
        "description": "अपनी पसंदीदा भाषा में AI-संचालित रियल-टाइम डबिंग के साथ लाइव इज़राइली टीवी देखें। भाषा की बाधाओं के बिना समाचार, टॉक शो और मनोरंजन का अनुभव करें।"
      },
      "live_subtitles": {
        "name": "लाइव उपशीर्षक",
        "tagline": "लाइव प्रसारण के लिए रियल-टाइम AI उपशीर्षक",
        "description": "लाइव इज़राइली टीवी देखते समय रियल-टाइम में AI-जनित उपशीर्षक प्राप्त करें। लाइव सामग्री के तत्काल अनुवाद के लिए अपनी पसंदीदा भाषा चुनें।"
      },
      "live_trivia": {
        "name": "लाइव ट्रिविया",
        "tagline": "लाइव प्रसारण पर आधारित ट्रिविया खेल खेलें",
        "description": "AI लाइव प्रसारण से विषयों का पता लगाता है और रियल-टाइम में ट्रिविया प्रश्न उत्पन्न करता है। दोस्तों के साथ प्रतिस्पर्धा करें और टीवी देखते हुए इज़राइली संस्कृति के बारे में जानें।"
      },
      "catch_up": {
        "name": "कैच अप",
        "tagline": "लाइव टीवी पर जो आपने मिस किया उसका AI सारांश",
        "description": "लाइव प्रसारण का कोई हिस्सा मिस हो गया? AI-जनित सारांश प्राप्त करें जो आपको बताएंगे कि क्या हुआ, त्वरित समीक्षा के लिए मुख्य क्षण हाइलाइट किए गए हैं।"
      },
      "scene_search": {
        "name": "दृश्य खोज",
        "tagline": "सभी सामग्री में विशिष्ट दृश्य खोजें",
        "description": "किसी याद किए गए दृश्य का वर्णन करें और AI इसे सभी उपलब्ध सामग्री में खोज लेगा। संवाद, दृश्य तत्वों, या कथानक विवरण द्वारा खोजें।"
      },
      "phonetic_mirror": {
        "name": "फोनेटिक मिरर",
        "tagline": "AI फीडबैक के साथ हिब्रू उच्चारण का अभ्यास करें",
        "description": "हिब्रू बोलते हुए खुद को रिकॉर्ड करें और उच्चारण पर तुरंत AI फीडबैक प्राप्त करें। अपनी बोली की मूल वक्ताओं से तुलना करें और समय के साथ प्रगति ट्रैक करें।"
      },
      "talk_back": {
        "name": "टॉक बैक",
        "tagline": "अपने AI पात्र के साथ हिब्रू में आवाज़ बातचीत करें",
        "description": "अपने AI पात्र से बात करके बातचीत हिब्रू का अभ्यास करें। प्राकृतिक संवाद में व्याकरण, शब्द भंडार और उच्चारण पर रियल-टाइम फीडबैक प्राप्त करें।"
      },
      "interactive_mission": {
        "name": "इंटरेक्टिव मिशन",
        "tagline": "AI मार्गदर्शन के साथ मजेदार हिब्रू सीखने की चुनौतियां",
        "description": "AI-निर्देशित मिशन पूर्ण करें जो सामग्री देखने को हिब्रू सीखने के व्यायाम के साथ जोड़ते हैं। पुरस्कार अर्जित करें और अपनी भाषा यात्रा ट्रैक करें।"
      },
      "glossary": {
        "name": "व्यक्तिगत शब्दावली",
        "tagline": "सामग्री से निर्मित आपका व्यक्तिगत हिब्रू शब्दकोश",
        "description": "वे सभी हिब्रू शब्द जो आपने खोजे और सहेजे हैं, श्रेणी, आवृत्ति और महारत स्तर के अनुसार व्यवस्थित। कभी भी समीक्षा करें और अभ्यास करें।"
      },
      "llm_search": {
        "name": "AI खोज",
        "tagline": "प्राकृतिक भाषा प्रश्नों के साथ सामग्री खोजें",
        "description": "प्राकृतिक भाषा का उपयोग करके पूरी Bayit+ लाइब्रेरी खोजें। 'परिवार के बारे में मजेदार इज़राइली कॉमेडी' या 'तेल अवीव के बारे में डॉक्युमेंट्री' मांगें और AI-क्यूरेटेड परिणाम प्राप्त करें।"
      },
      "proactive_voice": {
        "name": "सक्रिय आवाज़",
        "tagline": "आवाज़-प्रथम AI सहायक जो आपकी ज़रूरतों का अनुमान लगाता है",
        "description": "एक AI सहायक जो सुनता है और सक्रिय रूप से प्रासंगिक सामग्री सुझाव, अनुवाद और आप जो देख रहे हैं उसके आधार पर सीखने के अवसर प्रदान करता है।"
      },
      "chatbot": {
        "name": "बयित चैट",
        "tagline": "इज़राइली सामग्री से संबंधित किसी भी विषय पर AI से चैट करें",
        "description": "इज़राइली संस्कृति के बारे में प्रश्न पूछें, सामग्री अनुशंसाएं प्राप्त करें, हिब्रू का अभ्यास करें, या आपने जो देखा उस पर चर्चा करें। आपका AI साथी हमेशा उपलब्ध है।"
      }
    },
    "prereq": {
      "avatar": "अपना AI पात्र बनाएं",
      "subscription": "प्रीमियम सदस्यता आवश्यक",
      "microphone": "माइक्रोफ़ोन एक्सेस आवश्यक",
      "contentType": "अपनी सामग्री प्राथमिकताएं चुनें",
      "preference": "अपनी भाषा प्राथमिकताएं सेट करें",
      "voiceClone": "अपना वॉइस क्लोन सेट अप करें"
    },
    "walkthrough": {
      "tryItNow": "[hi] Try it now",
      "watchDemo": "[hi] Watch demo",
      "skip": "[hi] Skip",
      "next": "[hi] Next",
      "done": "[hi] Done",
      "complete": "[hi] Walkthrough complete",
      "stepCounter": "[hi] {{current}} of {{total}}",
      "pause_ask": {
        "step1": "[hi] Navigate to a movie with interactive moments",
        "step2": "[hi] Pause the movie during a scene",
        "step3": "[hi] Tap the Ask a Character button",
        "step4": "[hi] Watch the character respond to you"
      },
      "interactive_subtitles": {
        "step1": "[hi] Start playing a movie with subtitles",
        "step2": "[hi] Tap the Interactive button in the control bar",
        "step3": "[hi] Select your subtitle language",
        "step4": "[hi] Tap any word in the subtitles to learn more"
      },
      "vocabulary": {
        "step1": "[hi] Open a movie with interactive subtitles enabled",
        "step2": "[hi] Tap a word you want to learn",
        "step3": "[hi] Tap Save to Vocabulary",
        "step4": "[hi] Review your saved words in the Vocabulary section"
      },
      "vod_moments": {
        "step1": "[hi] Start watching a movie with interactive moments",
        "step2": "[hi] Wait for an interactive prompt to appear",
        "step3": "[hi] See the AI-generated interaction"
      },
      "cultural_context": {
        "step1": "[hi] Play a movie with Hebrew dialogue",
        "step2": "[hi] Tap on a subtitle with cultural significance",
        "step3": "[hi] Read the AI-generated cultural explanation"
      },
      "bilingual_bridge": {
        "step1": "[hi] Open a movie with bilingual support",
        "step2": "[hi] Select the bilingual subtitle mode",
        "step3": "[hi] Tap a highlighted phrase to see the translation",
        "step4": "[hi] Watch both languages side by side"
      },
      "ai_companion": {
        "step1": "[hi] Start watching any movie",
        "step2": "[hi] Tap the AI Companion button",
        "step3": "[hi] Type a question about the movie",
        "step4": "[hi] Read the contextual AI response"
      },
      "live_dubbing": {
        "step1": "[hi] Navigate to a live TV channel",
        "step2": "[hi] Tap the dubbing button in the control bar",
        "step3": "[hi] Select your preferred language",
        "step4": "[hi] Listen to the real-time AI dubbing"
      },
      "live_subtitles": {
        "step1": "[hi] Navigate to a live TV channel",
        "step2": "[hi] Tap the subtitles button",
        "step3": "[hi] Select your subtitle language",
        "step4": "[hi] Watch the real-time subtitles appear"
      },
      "live_trivia": {
        "step1": "[hi] Navigate to a live TV channel",
        "step2": "[hi] Tap the trivia button",
        "step3": "[hi] Answer the AI-generated questions"
      },
      "catch_up": {
        "step1": "[hi] Navigate to a live broadcast",
        "step2": "[hi] Select the catch-up option",
        "step3": "[hi] Tap to generate an AI summary",
        "step4": "[hi] Read the summary of what you missed"
      },
      "scene_search": {
        "step1": "[hi] Navigate to a recorded broadcast",
        "step2": "[hi] Type what you are looking for",
        "step3": "[hi] Tap on the matching scene",
        "step4": "[hi] Watch the scene from that point"
      },
      "phonetic_mirror": {
        "step1": "[hi] Open the Phonetic Mirror in Zeh Ani",
        "step2": "[hi] Read the Hebrew phrase shown",
        "step3": "[hi] Speak the phrase into your microphone",
        "step4": "[hi] Review the AI pronunciation feedback"
      },
      "talk_back": {
        "step1": "[hi] Open Talk Back in Zeh Ani",
        "step2": "[hi] Listen to your avatar speak Hebrew",
        "step3": "[hi] Respond in Hebrew using your microphone",
        "step4": "[hi] Review the AI feedback on your response"
      },
      "interactive_mission": {
        "step1": "[hi] Open Interactive Missions",
        "step2": "[hi] Select a mission level",
        "step3": "[hi] Follow the AI-guided exercises",
        "step4": "[hi] Complete the mission and earn rewards"
      },
      "glossary": {
        "step1": "[hi] Open the Hebrew Glossary",
        "step2": "[hi] Search for a Hebrew word",
        "step3": "[hi] Listen to the pronunciation"
      },
      "llm_search": {
        "step1": "[hi] Open the Search tab",
        "step2": "[hi] Type a natural language query",
        "step3": "[hi] Browse the AI-curated results"
      },
      "proactive_voice": {
        "step1": "[hi] Open the Voice Suggestions feature",
        "step2": "[hi] Tap and hold to speak",
        "step3": "[hi] Hear the personalized recommendations"
      },
      "chatbot": {
        "step1": "[hi] Open the AI Assistant",
        "step2": "[hi] Type your question or request",
        "step3": "[hi] Read the AI response"
      }
    }
  },
  "byoc": {
    "home": {
      "title": "[hi] Bring Your Own Content",
      "subtitle": "[hi] Connect your IPTV, Plex, or YouTube sources and enjoy Bayit+ AI features on your own content",
      "connectButton": "[hi] Connect Sources",
      "aiFeatures": {
        "dubbing": "[hi] AI Dubbing available",
        "subtitles": "[hi] Live Subtitles available"
      }
    },
    "pageSubtitle": "अपना खुद का कंटेंट लाएं - IPTV और स्ट्रीमिंग स्रोत जोड़ें",
    "addSource": "स्रोत जोड़ें",
    "sync": "सिंक करें",
    "remove": "हटाएं",
    "channelCount": "{{count}} चैनल",
    "empty": {
      "title": "कोई स्रोत नहीं जोड़ा गया",
      "subtitle": "Bayit+ के साथ अपना कंटेंट देखने के लिए अपने IPTV, Xtream या स्ट्रीमिंग स्रोत जोड़ें"
    },
    "source": {
      "iptv": "IPTV स्रोत",
      "xtream": "Xtream Codes"
    },
    "sourceType": {
      "iptv": "IPTV / M3U",
      "xtream": "Xtream Codes"
    },
    "addIptv": {
      "title": "IPTV स्रोत जोड़ें",
      "subtitle": "M3U या M3U8 प्लेलिस्ट फ़ाइल का URL दर्ज करें",
      "urlPlaceholder": "https://example.com/playlist.m3u",
      "validate": "सत्यापित करें",
      "add": "स्रोत जोड़ें"
    },
    "addXtream": {
      "title": "Xtream Codes से कनेक्ट करें",
      "subtitle": "अपने Xtream Codes सर्वर के क्रेडेंशियल दर्ज करें",
      "serverUrl": "सर्वर URL",
      "username": "उपयोगकर्ता नाम",
      "password": "पासवर्ड",
      "connect": "कनेक्ट करें"
    },
    "preview": {
      "title": "पूर्वावलोकन",
      "channelCount": "{{count}} चैनल मिले"
    },
    "providers": {
      "title": "लोकप्रिय प्रदाता"
    },
    "wizard": {
      "step1": "स्रोत जोड़ें",
      "step2": "प्रसंस्करण",
      "step3": "समीक्षा",
      "selectSource": "स्रोत प्रकार चुनें"
    },
    "normalization": {
      "title": "आपका कंटेंट प्रोसेस हो रहा है",
      "total": "कुल {{count}} चैनल",
      "matched": "{{count}} मिलान",
      "stage": {
        "parsing": "प्लेलिस्ट पार्स हो रही है...",
        "matching": "चैनल मिलान हो रहा है...",
        "enriching": "मेटाडेटा समृद्ध हो रहा है...",
        "finalizing": "अंतिम रूप दिया जा रहा है..."
      }
    },
    "review": {
      "title": "आयातित कंटेंट की समीक्षा करें",
      "subtitle": "{{matched}} मिलान, {{unmatched}} चैनल बेमेल",
      "matchedChannels": "मिलान किए गए चैनल",
      "unmatchedChannels": "बेमेल चैनल",
      "apply": "लागू करें और आयात करें"
    },
    "error": {
      "urlRequired": "कृपया URL दर्ज करें",
      "noChannels": "इस प्लेलिस्ट में कोई चैनल नहीं मिला",
      "invalidUrl": "इस URL से प्लेलिस्ट लोड नहीं हो सकी",
      "allFieldsRequired": "सभी फ़ील्ड आवश्यक हैं",
      "enrichFailed": "स्रोत का विश्लेषण विफल",
      "syncFailed": "स्रोत सिंक विफल",
      "normalizationFailed": "कंटेंट प्रोसेसिंग विफल",
      "normalizationPollFailed": "प्रोसेसिंग के दौरान कनेक्शन खो गया"
    },
    "plex": {
      "connectPlex": "Plex कनेक्ट करें",
      "enterCodeAt": "यह कोड यहां दर्ज करें",
      "waitingForAuth": "प्राधिकरण की प्रतीक्षा हो रही है...",
      "selectServer": "एक Plex सर्वर चुनें",
      "connecting": "{{serverName}} से कनेक्ट हो रहा है...",
      "connected": "कनेक्टेड",
      "label": "Plex"
    },
    "settings": {
      "title": "आपके कंटेंट स्रोत",
      "refresh": "रिफ्रेश",
      "noSources": "कोई कंटेंट स्रोत कनेक्ट नहीं है",
      "noSourcesSubtitle": "अपना Plex, YouTube, IPTV या Xtream प्रदाता कनेक्ट करें",
      "removeSource": "स्रोत हटाएं",
      "plexSubtitle": "अपने Plex मीडिया सर्वर से स्ट्रीम करें",
      "youtubeSubtitle": "अपनी YouTube लाइब्रेरी एक्सेस करें",
      "iptvXtreamLabel": "IPTV / Xtream",
      "iptvXtreamSubtitle": "M3U प्लेलिस्ट या Xtream कोड जोड़ें",
      "youtube": "YouTube",
      "xtreamCodes": "Xtream Codes",
      "iptv": "IPTV"
    }
  },
  "onboarding": {
    "welcome": {
      "title": "Bayit+ में आपका स्वागत है",
      "subtitle": "इज़राइली सामग्री, संस्कृति और भाषा सीखने के लिए आपका AI-संचालित प्रवेश द्वार",
      "getStarted": "शुरू करें"
    },
    "highlight": {
      "dubbing": "लाइव AI डबिंग",
      "subtitles": "इंटरैक्टिव सबटाइटल",
      "ai": "AI साथी",
      "learning": "हिब्रू सीखना"
    },
    "voice": {
      "title": "वॉयस सेटअप",
      "subtitle": "वॉयस कमांड, हिब्रू उच्चारण अभ्यास और हैंड्स-फ्री नेविगेशन के लिए अपना माइक्रोफ़ोन सक्षम करें",
      "enable": "माइक्रोफ़ोन सक्षम करें",
      "granted": "माइक्रोफ़ोन सफलतापूर्वक सक्षम हुआ"
    },
    "tour": {
      "done": "हो गया"
    },
    "demo": {
      "dubbing": {
        "title": "लाइव AI डबिंग",
        "description": "अपनी पसंदीदा भाषा में रियल-टाइम AI डबिंग के साथ इज़राइली टीवी देखें",
        "hebrew": "हिब्रू",
        "english": "अंग्रेजी"
      },
      "subtitles": {
        "title": "इंटरैक्टिव सबटाइटल",
        "description": "तत्काल अनुवाद और उच्चारण के लिए सबटाइटल में किसी भी शब्द पर टैप करें",
        "sample": "परिवार Shabbat रात्रिभोज के लिए एकत्र हुआ",
        "word": "शबत",
        "translation": "शब्बत - साप्ताहिक विश्राम का दिन"
      },
      "interaction": {
        "title": "AI पात्र इंटरैक्शन",
        "description": "किसी भी दृश्य को रोकें और सांस्कृतिक संदर्भ के बारे में अपने AI साथी से पूछें",
        "userMsg": "वे कौन सा त्योहार मना रहे हैं?",
        "aiMsg": "वे Sukkot मना रहे हैं, जो झोपड़ियों का पर्व है। आप जो अस्थायी झोपड़ी देख रहे हैं उसे sukkah कहते हैं।"
      },
      "trivia": {
        "title": "लाइव ट्रिविया",
        "description": "AI लाइव प्रसारण से ट्रिविया प्रश्न बनाता है। प्रतिस्पर्धा करें और सीखें!",
        "question": "इज़राइल की आधिकारिक भाषा क्या है?",
        "optionA": "अरबी",
        "optionB": "हिब्रू",
        "optionC": "अंग्रेजी"
      },
      "catchup": {
        "title": "स्मार्ट कैच अप",
        "description": "लाइव प्रसारण का हिस्सा छूट गया? AI आपके छूटे हुए हिस्से का सारांश देता है",
        "missed": "छूटा हुआ",
        "summary": "AI सारांश",
        "live": "अभी लाइव"
      },
      "byoc": {
        "title": "अपना खुद का कंटेंट लाएं",
        "description": "अपने IPTV स्रोत आयात करें और उन्हें Bayit+ सामग्री के साथ देखें",
        "step1": "स्रोत जोड़ें",
        "step2": "AI संवर्धन",
        "step3": "देखें"
      },
      "zehAni": {
        "title": "अपना AI पात्र बनाएं",
        "description": "एक व्यक्तिगत AI अवतार बनाएं जो आपके साथ सीखे",
        "generated": "AI अवतार"
      }
    }
  },
  "dm": {
    "title": "संदेश",
    "conversations": "बातचीत",
    "conversation": "बातचीत",
    "empty": {
      "title": "अभी तक कोई संदेश नहीं",
      "subtitle": "किसी मित्र के साथ बातचीत शुरू करें"
    },
    "input": {
      "placeholder": "संदेश लिखें...",
      "send": "भेजें"
    },
    "translate": "अनुवाद करें",
    "react": "प्रतिक्रिया दें",
    "read": "पढ़ा गया",
    "sent": "भेजा गया",
    "loadMore": "पुराने संदेश लोड करें",
    "startConversation": "बातचीत शुरू करने के लिए संदेश भेजें",
    "reaction": {
      "like": "पसंद",
      "love": "प्यार",
      "laugh": "हाहा",
      "surprise": "वाह",
      "sad": "दुखद"
    },
    "error": {
      "fetchFailed": "संदेश लोड करने में विफल",
      "sendFailed": "संदेश भेजने में विफल"
    }
  },
  "household": {
    "empty": {
      "title": "अभी तक कोई घरेलू नहीं",
      "subtitle": "अपने परिवार को प्रबंधित करने के लिए घरेलू बनाएं"
    },
    "create": {
      "namePlaceholder": "घरेलू नाम",
      "button": "घरेलू बनाएं"
    },
    "members": "सदस्य",
    "role": {
      "owner": "मालिक",
      "guardian": "अभिभावक",
      "child": "बच्चा"
    },
    "invite": {
      "title": "सदस्यों को आमंत्रित करें",
      "emailPlaceholder": "ईमेल पता",
      "send": "आमंत्रण भेजें",
      "pending": "लंबित आमंत्रण"
    },
    "removeMember": "हटाएं",
    "error": {
      "fetchFailed": "घरेलू लोड करने में विफल",
      "createFailed": "घरेलू बनाने में विफल",
      "updateFailed": "घरेलू अपडेट करने में विफल",
      "deleteFailed": "घरेलू हटाने में विफल",
      "inviteFailed": "आमंत्रण भेजने में विफल",
      "removeFailed": "सदस्य हटाने में विफल"
    }
  },
  "aiChat": {
    "retryButton": "[hi] Retry",
    "sendButton": "[hi] Send",
    "title": "[hi] AI Chat",
    "voiceButton": "[hi] Voice"
  },
  "aiOnboarding": {
    "buttons": {
      "back": "[hi] Back"
    },
    "completion": {
      "message": "[hi] You're all set! Start exploring AI features.",
      "title": "[hi] Setup Complete"
    },
    "permissions": {
      "description": "[hi] Grant permissions to enable AI features like voice and camera.",
      "title": "[hi] Permissions"
    },
    "personalization": {
      "description": "[hi] Tell us your preferences to personalize your AI experience.",
      "title": "[hi] Personalization"
    },
    "title": "[hi] AI Setup",
    "welcome": {
      "description": "[hi] Bayit+ uses AI to enhance your viewing experience with dubbing, subtitles, and more.",
      "title": "[hi] Welcome to Bayit+ AI"
    }
  },
  "auth_device_authorized": "[hi] Device authorized",
  "auth_device_code_expired": "[hi] Code expired",
  "auth_device_get_new_code": "[hi] Get new code",
  "auth_device_manual_login": "[hi] Sign in manually",
  "auth_device_visit_uri": "[hi] Visit the URL shown on your TV",
  "avatar": {
    "tapToSpeak": "[hi] Tap to speak",
    "title": "[hi] Avatar"
  },
  "dubbing": {
    "mixer": {
      "dubbedAudio": "[hi] Dubbed Audio",
      "originalAudio": "[hi] Original Audio",
      "title": "[hi] Audio Mixer"
    },
    "settings_title": "[hi] Dubbing Settings",
    "target_language": "[hi] Target Language",
    "voiceSelector": {
      "selected": "[hi] Selected",
      "subtitle": "[hi] Choose a voice for dubbing",
      "title": "[hi] Voice Selection"
    }
  },
  "go_back": "[hi] Go Back",
  "miniPlayer": {
    "closePlayer": "[hi] Close Player",
    "skipBackward": "[hi] Skip Backward",
    "skipForward": "[hi] Skip Forward"
  },
  "retry": "[hi] Retry",
  "search_hint": "[hi] Search channels, movies, shows...",
  "search_no_results": "[hi] No results found",
  "search_prompt": "[hi] What are you looking for?",
  "subscription_required": "[hi] Subscription Required",
  "subscription_upsell_tv": "[hi] Upgrade to watch on TV",
  "talkback": {
    "title": "[hi] Talkback"
  },
  "voiceAssistant": {
    "fabLabel": "[hi] Voice Assistant",
    "modal": {
      "cancel": "[hi] Cancel",
      "setupMessage": "[hi] Set up voice recognition to use the voice assistant.",
      "setupRequired": "[hi] Setup Required",
      "startSetup": "[hi] Start Setup",
      "title": "[hi] Voice Assistant"
    }
  },
  "voiceCommand": {
    "executing": "[hi] Executing...",
    "listening": "[hi] Listening...",
    "noMatch": "[hi] No match found",
    "recognized": "[hi] Recognized"
  },
  "voiceDecision": {
    "cancel": "[hi] Cancel",
    "confirm": "[hi] Confirm",
    "matched": "[hi] Matched"
  },
  "voiceSearch": {
    "listening": "[hi] Listening...",
    "noResults": "[hi] No results found",
    "tapToSpeak": "[hi] Tap to speak",
    "title": "[hi] Voice Search"
  },
  "voiceSettings": {
    "language": "[hi] Language",
    "speechRate": "[hi] Speech Rate",
    "title": "[hi] Voice Settings",
    "ttsProvider": "[hi] TTS Provider",
    "voiceMode": "[hi] Voice Mode",
    "voiceSelection": "[hi] Voice Selection",
    "wakeWord": "[hi] Wake Word"
  },
  "voiceWizard": {
    "buttons": {
      "back": "[hi] Back"
    },
    "calibration": {
      "description": "[hi] Speak normally to calibrate the microphone.",
      "listening": "[hi] Listening...",
      "micButton": "[hi] Start Recording",
      "resultTitle": "[hi] Calibration Result",
      "stopButton": "[hi] Stop Recording",
      "tapToStart": "[hi] Tap to start calibration",
      "title": "[hi] Microphone Calibration"
    },
    "complete": {
      "message": "[hi] Voice wizard setup is complete. You can now use voice features.",
      "title": "[hi] Setup Complete"
    },
    "language": {
      "description": "[hi] Select your preferred language for voice commands.",
      "title": "[hi] Voice Language"
    },
    "permission": {
      "description": "[hi] Microphone access is needed for voice features.",
      "granted": "[hi] Permission Granted",
      "requestButton": "[hi] Grant Permission",
      "title": "[hi] Microphone Permission"
    },
    "title": "[hi] Voice Wizard"
  },
  "watch_now": "[hi] Watch Now",
  "culture": {
    "title": "इज़राइली संस्कृति",
    "description": "जेरूसलम, तेल अवीव और इज़राइली विरासत",
    "shabbat": {
      "title": "शबत मोड",
      "enableShabbatMode": "शबत मोड सक्षम करें",
      "shabbatTimes": "शबत का समय",
      "timesDescription": "मोमबत्ती जलाने और हवदलाह के समय यहाँ प्रदर्शित होंगे",
      "aboutTitle": "शबत मोड के बारे में",
      "aboutDescription": "सक्षम होने पर, शबत मोड शबत के घंटों के दौरान सूचनाओं को रोकेगा, स्क्रीन की चमक कम करेगा और एक सरलीकृत इंटरफ़ेस सक्षम करेगा।"
    },
    "judaism": {
      "holidaysAndTorah": "त्योहार और तोराह",
      "parashaOfTheWeek": "सप्ताह की पराशा",
      "parashaDescription": "साप्ताहिक तोराह पाठ और टिप्पणी"
    },
    "morning": {
      "title": "सुबह की रस्म",
      "description": "संकल्प और कृतज्ञता के साथ अपने दिन की शुरुआत करें",
      "dailyInspiration": "दैनिक प्रेरणा",
      "dailyInspirationDescription": "आपकी सुबह की दिनचर्या के लिए क्यूरेटेड सामग्री",
      "modehAni": "मोदे अनी",
      "modehAniDescription": "सुबह की कृतज्ञता प्रार्थना",
      "netilatYadayim": "नेतिलत यादयिम",
      "netilatYadayimDescription": "अनुष्ठानिक हाथ धोना",
      "shacharit": "शचरित",
      "shacharitDescription": "सुबह की प्रार्थना सेवा"
    },
    "glossary": {
      "termDetail": "शब्द विवरण",
      "definition": "परिभाषा",
      "pronunciation": "उच्चारण",
      "examples": "उदाहरण"
    },
    "jerusalem": {
      "title": "जेरूसलम"
    },
    "telaviv": {
      "title": "तेल अवीव"
    }
  },
  "zehAni": {
    "dashboard": {
      "title": "ज़ेह अनी",
      "biometricConsent": "बायोमेट्रिक सहमति",
      "activeConsents": "{{count}} सक्रिय सहमतियाँ",
      "magicMirror": "जादुई दर्पण",
      "magicMirrorDescription": "दैनिक अभिवादन और फेस आईडी",
      "v2vPractice": "V2V अभ्यास",
      "v2vPracticeDescription": "वॉइस-टू-वॉइस उच्चारण",
      "avatar3d": "3D अवतार",
      "avatar3dDescription": "आपका व्यक्तिगत अवतार मेश",
      "movieInteractions": "फिल्म इंटरैक्शन",
      "movieInteractionsDescription": "फिल्म के किरदारों को ब्राउज़ करें और उनसे बात करें",
      "contacts": "संपर्क",
      "contactsDescription": "WhatsApp संपर्क साझा करना",
      "feedback": "प्रतिक्रिया",
      "feedbackDescription": "अपना अनुभव साझा करें",
      "consent": "सहमति",
      "consentDescription": "बायोमेट्रिक सहमति प्रबंधन",
      "chess": "शतरंज",
      "chessDescription": "दोस्तों और परिवार के साथ शतरंज खेलें"
    },
    "mirror": {
      "title": "जादुई दर्पण",
      "avatarContentDescription": "अवतार",
      "wordOfTheDay": "आज का शब्द",
      "playLipsync": "लिप सिंक चलाएं",
      "noAvatarYet": "अभी कोई अवतार नहीं",
      "noAvatarDescription": "कहानी में खुद को देखने के लिए 3D अवतार बनाएं",
      "createAvatar": "अवतार बनाएं"
    },
    "mode": {
      "title": "अवतार मोड",
      "enableAvatarMode": "अवतार मोड सक्षम करें",
      "enableDescription": "सामग्री पर प्रतिक्रिया देते हुए अपना अवतार दिखाएं",
      "avatarPreview": "अवतार पूर्वावलोकन",
      "avatarPreviewContentDescription": "अवतार पूर्वावलोकन",
      "noAvatarConfigured": "कोई अवतार कॉन्फ़िगर नहीं किया गया",
      "reactionStyle": "प्रतिक्रिया शैली"
    },
    "wardrobe": {
      "title": "वार्डरोब",
      "equippedContentDescription": "सुसज्जित"
    },
    "settings": {
      "title": "अवतार सेटिंग्स",
      "privacy": "गोपनीयता",
      "privateAvatarMode": "निजी अवतार मोड",
      "privateAvatarDescription": "अपना अवतार अन्य उपयोगकर्ताओं से छिपाएं",
      "appearance": "दिखावट",
      "enableAnimations": "एनिमेशन सक्षम करें",
      "animationsDescription": "अवतार की गतिविधियों और भावों को एनिमेट करें",
      "availableOutfits": "उपलब्ध पोशाकें"
    },
    "selfie": {
      "title": "वीडियो सेल्फी",
      "camera": "कैमरा",
      "cameraPreview": "कैमरा पूर्वावलोकन",
      "startRecording": "रिकॉर्डिंग शुरू करें",
      "stopRecording": "रिकॉर्डिंग बंद करें",
      "rec": "REC",
      "enterPin": "अवतार बनाने के लिए अपना PIN दर्ज करें",
      "pinLabel": "PIN",
      "retake": "दोबारा लें",
      "creatingAvatar": "आपका अवतार बनाया जा रहा है...",
      "avatarCreated": "अवतार सफलतापूर्वक बनाया गया",
      "avatarPreviewContentDescription": "अवतार पूर्वावलोकन",
      "createAnother": "एक और बनाएं"
    },
    "mesh": {
      "title": "3D अवतार",
      "meshViewer": "3D मेश व्यूअर",
      "meshViewerDescription": "3D मेश व्यूअर के लिए WebView या GLSurfaceView एकीकरण आवश्यक है",
      "skinTone": "त्वचा का रंग",
      "hairStyle": "बालों की शैली",
      "accessories": "सहायक उपकरण",
      "saveChanges": "परिवर्तन सहेजें"
    },
    "v2v": {
      "title": "वॉइस अभ्यास",
      "nextPhrase": "अगला वाक्यांश",
      "stop": "रोकें",
      "record": "रिकॉर्ड करें",
      "mic": "MIC",
      "viewProgress": "प्रगति देखें",
      "analyzingPronunciation": "उच्चारण का विश्लेषण...",
      "pronunciationFeedback": "उच्चारण प्रतिक्रिया",
      "similarity": "समानता: {{score}}%",
      "yourProgress": "आपकी प्रगति",
      "transforms": "ट्रांसफॉर्म: {{count}}",
      "improvement": "सुधार: {{score}}%",
      "continuePracticing": "अभ्यास जारी रखें"
    },
    "characters": {
      "title": "किरदार",
      "noCharactersFound": "इस फिल्म के लिए कोई किरदार नहीं मिला",
      "characterCount": "{{count}} किरदार"
    },
    "interactions": {
      "title": "फिल्म इंटरैक्शन",
      "noInteractableMovies": "कोई इंटरैक्टिव फिल्म उपलब्ध नहीं"
    },
    "feedbackInbox": {
      "title": "प्रतिक्रिया इनबॉक्स",
      "refreshContentDescription": "रिफ्रेश करें",
      "noFeedbackYet": "अभी कोई प्रतिक्रिया नहीं",
      "feedbackAppearHere": "आपके संपर्कों की प्रतिक्रिया यहाँ दिखाई देगी",
      "playVoiceMessage": "वॉइस मैसेज चलाएं"
    },
    "addContact": {
      "title": "संपर्क जोड़ें",
      "nameLabel": "नाम",
      "phoneLabel": "फ़ोन",
      "relationship": "संबंध",
      "language": "भाषा"
    },
    "avatar3d": {
      "title": "3D अवतार",
      "glbMeshViewer": "GLB मेश व्यूअर",
      "controls": "नियंत्रण",
      "animate": "एनिमेट करें",
      "vertices": "शीर्ष",
      "bones": "हड्डियाँ",
      "blendShapes": "ब्लेंड शेप्स",
      "hasGlb": "GLB है",
      "status": "स्थिति: {{value}}"
    }
  }
}
